<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Room</h2>
			<a v-if="$store.state.principal.type === 'Clinic'" class="v-btn v-btn--contained theme--light v-size--default success mx-2" :href="experiencePortal() + '/#/' + $store.state.principal.tenantSlug + '/' + $root.selectedExperience.slug" target="_blank">
				Go to Experience
				<v-icon class="ml-2" color="white">mdi-arrow-right-circle</v-icon>
			</a>
			<v-btn color="primary" @click="showRoomLibrary()">Add Room</v-btn>
		</div>

		<div class="d-flex flex-wrap justify-space-around align-stretch">
			<div v-for="(entity, index) in entityList" :key="index">
				<v-card :elevation="2" width="340" class="mb-5">
					<v-card-title>
						<span>{{ entity.name }}</span>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon v-if="entity.mainStructure" v-bind="attrs" v-on="on" color="success"> mdi-home </v-icon>
							</template>
							<span>Entry Point</span>
						</v-tooltip>
					</v-card-title>
					<div class="v-card__text pa-0" style="position: relative; height: 200px; max-height: 200px; overflow: auto">
						<div style="position: absolute; transform-origin: top left; transform: scale(calc(340 / (1920 * 0.5)))">

							<img v-if="entity.backgroundDisplay" width="960px" :src="$root.asset(entity.backgroundDisplay)" :id="'background-display-' + entity.slug" />
							<img v-else-if="$root.isImage(entity.background)" width="960px" :src="$root.asset(entity.background)" :id="'background-' + entity.slug" />
							<video v-else-if="$root.isVideo(entity.background)" width="960px" preload="auto" autoplay="autoplay" muted playsinline disablepictureinpicture loop="loop" :id="'background-video-' + entity.slug">
								<source :src="$root.asset(entity.background)" type="video/mp4" />
							</video>
							<template v-else-if="$root.isYoutubeUrl(entity.background)">
								<youtube
									:videoId="$root.getYoutubeId(entity.background, backgroundYoutubeParams)"
									:player-vars="$root.getYoutubeParams(entity.background)"
									style="pointer-events: none "
									width="960"
									height="530"
									ref="backgroundIndexYoutube"
								></youtube>
							</template>
							<vimeo-player
								v-else-if="$root.isVimeoUrl(entity.background)"
								:video-url="entity.background"
								:options="backgroundVimeoParams"
								style="pointer-events: none "
								player-width="960"
								player-height="auto"
							></vimeo-player>
							<div v-for="(item, index) in entity.linkToDataList" :key="index">
								<img
									v-if="item.type === 'Image'"
									:src="$root.asset(item.value)"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
										width: item.width + 'px',
										height: item.height + 'px',
										objectFit: $root.setBackgroundSize(item.subType),
										objectPosition: $root.setBackgroundPosition(item),
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										position: 'absolute'
									}"
								/>
								<iframe
									v-else-if="item.type === 'Video' && $root.isEmbedVideo(item.value)"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										position: 'absolute'
									}"
									frameborder="0"
									allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
									scrolling="0"
									:src="$root.asset(item.value.replace(/.$/,'1'))"
								>
								<!-- string replace above is to force videos muted in the room page. -->
								</iframe>
								<video
									v-else-if="item.type === 'Video'"
									:style="{
										backgroundColor: '#000000',
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										position: 'absolute'
									}"
									frameborder="0"
									autoplay
									muted
									playsinline
									scrolling="0"
									:src="$root.asset(item.value.replace(/.$/,'1'))"
								>
								<!-- string replace above is to force videos muted in the room page. -->
								</video>
								<div
									v-else-if="item.type === 'Text'"
									class="hotspot_text"
									v-html="item.value"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + (item.skewX ? item.skewX : '0') + 'deg,' + (item.skewY ? item.skewY : '0') + 'deg)',
										position: 'absolute',
										backgroundColor: item.backgroundColor,
										borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
										padding: (item.padding ? item.padding / 4 : '0') + 'px'
									}"
								></div>
								<div
									v-else-if="item.type === 'Embed_HTML' && item.target === 'Embed'"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										position: 'absolute',
										overflow: 'hidden'
									}"
									v-append="item.valueRender ? item.valueRender : item.value"
								></div>
								<v-btn
									v-else-if="(item.type === 'Button' || item.type === 'Back_Button') && !item.backgroundImage"
									:class="'hotspot_btn hotspot_btn_custom_' + item.id"
									absolute
									:color="item.backgroundColor"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
										borderRadius: item.borderRadius + 'px',
										borderWidth: item.borderWidth + 'px',
										borderColor: item.borderColor
									}"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
								<v-btn
									v-else-if="(item.type === 'Button' || item.type === 'Back_Button') && item.backgroundImage"
									:class="'hotspot_btn hotspot_btn_custom_' + item.id"
									absolute
									:style="{
										backgroundImage: 'url(' + item.backgroundImage + ')',
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
										borderRadius: item.borderRadius + 'px',
										borderWidth: item.borderWidth + 'px',
										borderColor: item.borderColor
									}"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
								<router-link
									v-else
									class="room-link"
									to="#"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 3,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)'
									}"
								></router-link>
							</div>
							<div
								v-if="entity.dataMap.isExhibitionHall && entity.dataMap.boothSelected != null && entity.dataMap.boothSelected.length > 0"
								class="d-flex justify-center"
								style="position: absolute; z-index:1; top: 0; right: 0, bottom:0; width: auto; min-width:100%; max-height:100%;"
							>
								<v-row class="d-flex justify-center mx-0">
									<v-col cols="8" class="my-4" style="background-color: rgba(0, 0, 0, 0.5); overflow-y: auto; max-height: 90%;">
										<v-list style="background-color: rgba(0, 0, 0, 0)" dark dense>
											<div v-for="(item, index) in getBoothSelectedList(entity.dataMap.boothSelected, entity.slug)" :key="index">
												<v-list-item v-if="item != null && item.boothBackground.type == 'Color'" link v-bind:style="{backgroundColor: item.boothBackground.color}">
													<v-list-item-avatar size="30" color="grey lighten-2">
														<v-img :src="$root.asset(item.logo)"></v-img>
													</v-list-item-avatar>
													<v-list-item-content>{{ item.name }}</v-list-item-content>
												</v-list-item>
												<v-list-item v-else-if="item != null && item.boothBackground.type == 'Upload'" link v-bind:style="{backgroundImage: 'url(' + item.boothBackground.image + ')'}">
													<v-list-item-avatar size="30" color="grey lighten-2">
														<v-img :src="$root.asset(item.logo)"></v-img>
													</v-list-item-avatar>
													<v-list-item-content>{{ item.name }}</v-list-item-content>
												</v-list-item>
												<v-divider></v-divider>
											</div>
										</v-list>
									</v-col>
								</v-row>
							</div>

							<div
								v-if="entity.dataMap.isPosterRoom && entity.dataMap.posterSelected != null && entity.dataMap.posterSelected.length > 0 && posterList.length > 0"
								class="d-flex justify-center"
								style="position: absolute; z-index:1; top: -40px; right: 0, bottom:0; width: auto; min-width:260%; max-height:100%;transform: scale(0.38); margin-left: -768px"
							>
								<v-row style="height: 570px">
									<v-col cols="12" style="padding: 0px 40px; max-height: 100%">
										<div style="overflow: hidden auto; max-height: 100vh; background-color:#00000070;"
											:style="{maxHeight: getHightForPoster(entity) + 'px'}"
										>
											<v-carousel v-model="posterPage[index]" height="100%" hide-delimiters  next-icon="mdi-arrow-right-circle" prev-icon="mdi-arrow-left-circle">
												<v-carousel-item
													v-for="page in Math.ceil(entity.dataMap.posterSelected.length/4)"
													:key="page"
												>
													<v-row class="d-flex justify-center mx-0;" style="postion: absolute">
														<v-col cols="3" class="my-4"  v-for="(poster, idxPoster) in getPosterSelectedList(entity.dataMap.posterSelected, page)" :key="idxPoster" >
																<v-card style="background-color: #00000000;">
																	<v-card-title class="justify-center">
																		<span class="headline" style="color: white">{{ poster.name }}</span>
																	</v-card-title>
																	<v-card-text>
																		<div
																			style="margin: 10px; width: 555px; margin: auto; border-top-left-radius: 12px; border-top-right-radius: 12px; padding: 5px"
																			:style="{ backgroundColor: poster.backgroundColor }"
																		>
																			<v-row v-for="(item, index) in poster.posterDataList" :key="index" style="margin: 5px; padding: 0px">
																				<v-col v-for="(item1, index1) in item" :key="index1" :cols="12 / item.length" style="padding: 1px">
																					<v-btn
																						v-if="item1.type == 'URL FIELD'"
																						width="100%"
																						:color="item1.backgroundColor"
																						:style="{ color: item1.fontColor }"
																					>
																						{{ item1.label }}
																					</v-btn>
																					<v-btn
																						v-else-if="item1.type == 'FILE DOWNLOAD'"
																						width="100%"
																						:color="item1.backgroundColor"
																						:style="{ color: item1.fontColor }"
																					>
																						{{ item1.label }}
																						<v-icon :color="item1.iconColor" medium>mdi-download</v-icon>
																					</v-btn>
																					<div
																						v-else-if="item1.type == 'TEXT'"
																						v-html="item1.value"
																						:style="{
																							backgroundColor: item1.backgroundColor,
																							border: '1px solid ' + item1.backgroundColor
																						}"
																						style="border: 1px solid black; padding: 10px 10px 0px 10px"
																					></div>
																					<v-carousel v-else-if="item1.type == 'GALLERY'" hide-delimiters height="368">
																						<v-carousel-item
																							v-for="(image, idxImage) in item1.images"
																							class="galley_poster"
																							:key="idxImage"
																							:src="$root.asset(image)"
																							reverse-transition="fade"
																							transition="fade"
																						>
																						</v-carousel-item>
																					</v-carousel>
																					<iframe
																						v-else-if="item1.type == 'VIDEO'"
																						id="video_poster"
																						:src="$root.asset(item1.value + (item1.value.includes('youtube') ? '&mute=1' : '&muted=1') )"
																						frameborder="0"
																						allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'"
																						scrolling="0"
																						width="100%"
																						height="300px"
																					>
																					<!-- add src above with mute/muted to mute video from poster -->
																					</iframe>
																				</v-col>
																			</v-row>
																		</div>
																	</v-card-text>
																</v-card>
														</v-col>
													</v-row>
												</v-carousel-item>
											</v-carousel>
										</div>
									</v-col>
								</v-row>
							</div>
						</div>
					</div>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showEdit(entity)">
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Edit Room</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showLinkTo(entity)">
									<v-icon>mdi-link-variant-plus</v-icon>
								</v-btn>
							</template>
							<span>Link To</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="duplicateRoom(entity)">
									<v-icon>mdi-content-duplicate</v-icon>
								</v-btn>
							</template>
							<span>Duplicate Room</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
									<v-btn :disabled="(entity.mainStructure ) ? true : false" icon v-bind="attrs" v-on="on" @click="deleteStructure(entity.id)">
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Delete Room</span>
						</v-tooltip>
					</v-card-actions>
				</v-card>
			</div>
		</div>

		<!---Room Library Clinic-->
		<v-dialog v-model="dialogRoomLibrary" persistent no-click-animation fullscreen hide-overlay>
			<v-card>
				<v-card-title class="headline">
					Choose one of the room below
					<v-spacer></v-spacer>
					<v-btn icon @click="closeRoomLibrary()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-row>
					<v-col cols="4">
						<v-autocomplete v-model="tagFilter" :items="tagList" chips small-chips deletable-chips label="Filter by tags" multiple solo dense></v-autocomplete>
					</v-col>
					<div style="display: flex; flex-direction: row; margin-top: 13px">
						<v-btn color="primary" style="margin-right: 10px" @click="listRoomLibrary">filter</v-btn>
						<v-btn color="primary" @click="resetRoomLibraryFilter">Reset</v-btn>
					</div>
				</v-row>
				<v-divider class="mx-4 mb-4"></v-divider>
				<div class="d-flex flex-wrap justify-space-around align-stretch">
					<v-hover v-for="(room, index) in roomLibraryList.data" :key="index" v-slot:default="{ hover }">
						<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
							<div id="structure-view" style="display: block">
								<div class="entry-view">
									<v-img v-if="room.backgroundDisplay" :src="$root.asset(room.backgroundDisplay)" max-height="200" min-height="200" @click="chooseRoomLibrary(room)" style="cursor: pointer;"></v-img>
									<v-img v-else-if="$root.isImage(room.background)" :src="$root.asset(room.background)" max-height="200" min-height="200" @click="chooseRoomLibrary(room)" style="cursor: pointer;"></v-img>
									<video
										v-else-if="$root.isVideo(room.background)"
										width="100%"
										style="max-height: 200px; min-height: 200px; cursor: pointer;"
										preload="auto"
										autoplay="autoplay"
										muted
										playsinline
										disablepictureinpicture
										loop="loop"
										@click="chooseRoomLibrary(room)"
									>
										<source :src="$root.asset(room.background)" type="video/mp4" />
									</video>
									<template v-else-if="$root.isYoutubeUrl(room.background)">
										<div style="width: 100%; height: 200px; background-color: #00000000; z-index: 1; position: absolute; cursor: pointer;"
											@click="chooseRoomLibrary(room)">
										</div>
										<youtube
											:videoId="$root.getYoutubeId(room.background, backgroundYoutubeParams)"
											:player-vars="backgroundYoutubeParams"
											style="pointer-events: none "
											width="340"
											height="200"
											@click="chooseRoomLibrary(room)"
										></youtube>
									</template>
									<template v-else-if="$root.isVimeoUrl(room.background)">
										<div style="width: 100%; height: 200px; background-color: #00000000; z-index: 1; position: absolute; cursor: pointer;"
											@click="chooseRoomLibrary(room)">
										</div>
										<vimeo-player
											:video-url="room.background"
											:options="backgroundVimeoParams"
											style="pointer-events: none"
											player-width="340"
											player-height="200"
											ref="background"
										></vimeo-player>
									</template>
									<router-link
										v-for="(item, index) in entity.linkToDataList"
										:key="index"
										class="room-link"
										to="#"
										:style="{
											width: item.width + 'px',
											height: item.height + 'px',
											top: item.posY + 'px',
											left: item.posX + 'px',
											transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)'
										}"
									></router-link>
								</div>
							</div>
						</v-card>
					</v-hover>
				</div>

				<div class="d-flex flex-wrap justify-space-between" style="margin: 0px 20px 0px 30px">
					<div class="d-inline-flex">
						<span style="margin-top: 10px"> Rows per page : </span>
						<v-select
							v-model="roomLibraryList.size"
							:items="rowsPerPage"
							style="margin-left: 10px; width: 80px"
							@change="listRoomLibrary()"
							hide-details=""
							solo
						></v-select>
					</div>

					<v-pagination
						v-model="roomLibraryList.page"
						:length="roomLibraryList.length"
						:total-visible="7"
						@input="listRoomLibrary()"
					></v-pagination>
				</div>
			</v-card>
		</v-dialog>

		<!---Background Transition Library-->
		<v-dialog v-model="dialogBackgroundTransition" :retain-focus="false" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card style="overflow-x: auto">
				<v-card-title class="headline">
					Choose one of the background transition below
					<v-spacer></v-spacer>
					<v-btn icon @click="closeBackgroundTransition()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-row>
					<v-col cols="4">
						<v-autocomplete v-model="tagFilterTransition" :items="tagListTransition" chips small-chips deletable-chips label="Filter by tags" multiple solo dense></v-autocomplete>
					</v-col>
					<div style="display: flex; flex-direction: row; margin-top: 13px">
						<v-btn color="primary" style="margin-right: 10px" @click="filterBackgroundTransition">filter</v-btn>
						<v-btn color="primary" @click="resetBackgroundTransitionFilter">Reset</v-btn>
					</div>
				</v-row>
				<v-divider class="mx-4 mb-4"></v-divider>
				<div class="d-flex flex-wrap justify-space-around align-stretch">
					<v-hover v-for="(background, index) in backgroundTransitionList" :key="index" v-slot:default="{ hover }">
						<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
							<div id="structure-view" style="display: block">
								<div class="entry-view">
									<v-img
										v-if="background.backgroundTransitionDisplay"
										:src="$root.asset(background.backgroundTransitionDisplay)"
										max-height="200"
										min-height="200"
										@click="chooseBackgroundTransition(background.backgroundTransition)"
									></v-img>
									<video
										v-else-if="$root.isVideo(background.backgroundTransition)"
										width="100%"
										style="max-height: 200px; min-height: 200px"
										preload="auto"
										autoplay="autoplay"
										muted
										playsinline
										disablepictureinpicture
										loop="loop"
										@click="chooseBackgroundTransition(background.backgroundTransition)"
									>
										<source :src="$root.asset(background.backgroundTransition)" type="video/mp4" />
									</video>
									<template v-else-if="$root.isYoutubeUrl(background.backgroundTransition)">
										<div style="width: 100%; height: 200px; background-color: #00000000; z-index: 1; position: absolute; cursor: pointer;"
											@click="chooseBackgroundTransition(background.backgroundTransition)">
										</div>
										<youtube
											:videoId="$root.getYoutubeId(background.backgroundTransition, backgroundYoutubeParams)"
											:player-vars="$root.getYoutubeParams(background.backgroundTransition)"
											style="pointer-events: none "
											width="340"
											height="200"
											ref="backgroundIndexYoutube"
										></youtube>
									</template>
									<template v-else-if="$root.isVimeoUrl(background.backgroundTransition)">
										<div style="width: 100%; height: 200px; background-color: #00000000; z-index: 1; position: absolute; cursor: pointer;"
											@click="chooseBackgroundTransition(background.backgroundTransition)">
										</div>
										<vimeo-player
											:video-url="background.backgroundTransition"
											:options="backgroundVimeoParams"
											style="pointer-events: none"
											player-width="340"
											player-height="200"
											@click="chooseBackgroundTransition(background.backgroundTransition)"
										></vimeo-player>
									</template>
								</div>
							</div>
						</v-card>
					</v-hover>
				</div>
			</v-card>
		</v-dialog>
		<!--End of Background transition library-->

		<v-dialog v-model="dialogAdd" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Add Room
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="8">
							<v-form ref="formAdd" v-model="valid" @submit.prevent="addStructure">
								<v-row class="entry-view justify-center">
									<v-col cols="12">
										<v-col sm="3">
											<v-select v-model="uploadType" :items="['CloudFront', 'Vimeo']" label="Upload Type"></v-select>
										</v-col>
									</v-col>
									<v-col class="text-center" cols="12" sm="6">
										<v-btn
											class="ma-2"
											color="primary"
											absolute
											small
											style="z-index: 2;"
											@click="
												dialogRoomLibrary = true;
												closeAdd();
												isAdd = true;
											"
											>Room Library</v-btn
										>
										<img
											v-if="
												backgroundTemp &&
												backgroundTemp.startsWith('data') &&
												backgroundType == 'Upload' &&
												(backgroundImageName.toLowerCase().endsWith('.jpg') || backgroundImageName.toLowerCase().endsWith('.jpeg') || backgroundImageName.toLowerCase().endsWith('.png'))
											"
											:src="backgroundTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entity.background && backgroundType == 'URL' && $root.isImage(entity.background)"
											:src="entity.background.toLowerCase().startsWith('http') ? entity.background : baseLocation + '/asset/file/' + entity.background"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-else-if="backgroundTemp && backgroundType == 'Upload' && backgroundTemp.startsWith('data') && backgroundImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="backgroundTemp" type="video/mp4" />
										</video>
										<video
											v-else-if="entity.background && backgroundType == 'URL' && $root.isVideo(entity.background)"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="entity.background.toLowerCase().startsWith('http') ? entity.background : baseLocation + '/asset/file/' + entity.background" type="video/mp4" />
										</video>
										<div v-else-if="entity.background && backgroundType == 'URL'  && $root.isYoutubeUrl(entity.background)">
											<youtube
												:videoId="$root.getYoutubeId(entity.background, backgroundYoutubeParams)"
												:player-vars="backgroundYoutubeParams"
												style="pointer-events: none"
												width="355"
												height="200"
												ref="backgroundYoutube"
												@ready="playYoutube('background')"
											></youtube>
										</div>
										<vimeo-player
											v-else-if="entity.background && backgroundType == 'URL'   && $root.isVimeoUrl(entity.background)"
											:video-url="entity.background"
											:options="backgroundVimeoParams"
											style="pointer-events: none"
											player-width="355"
											player-height="200"
											ref="background"
										></vimeo-player>
										<div v-else style="border: 5px solid black; width: 100%; height: 200px"></div>
										<!---INPUT FOR BACKGROUND--->
										<v-row>
											<v-col cols="12" sm="3">
												<v-select v-model="backgroundType" :items="['Upload', 'URL']" label="Type"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="backgroundType === 'Upload'">
												<input ref="attachment1" type="file" accept="image/png, image/jpeg, image/jpg, video/mp4" @change="onBackgroundUpload" style="display: none" />
												<v-text-field
													v-model="backgroundFileName"
													label="Background"
													hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
													placeholder="Upload Background"
													prepend-icon="mdi-image"
													@click="openBackgroundDialog()"
													readonly
													:rules="[(v) => !!v || 'Room image is required']"
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else>
												<v-text-field v-model="entity.background" prepend-icon="mdi-image" label="Background" placeholder="Background Url" :rules="[(v) => !!v || 'Room image is required']"></v-text-field> </v-col
										></v-row>
										<!---END INPUT FOR BACKGROUND-->
									</v-col>
									<v-col class="text-center" cols="12" sm="6">
										<v-btn
											class="ma-2"
											color="primary"
											absolute
											small
											style="z-index: 2;"
											@click="
												showBackgroundTransitionLibrary();
												closeAdd();
												isAdd = true;
												isIntro = true;
											"
										>
											Transition Library
										</v-btn>
										<img
											v-if="
												introTransitionTemp &&
												introTransitionTemp.startsWith('data') &&
												introTransitionType == 'Upload' &&
												(introTransitionImageName.toLowerCase().endsWith('.jpg') || introTransitionImageName.toLowerCase().endsWith('.jpeg') || introTransitionImageName.toLowerCase().endsWith('.png'))
											"
											:src="introTransitionTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entity.introTransition && introTransitionType == 'URL' && $root.isImage(entity.introTransition)"
											:src="entity.introTransition.toLowerCase().startsWith('http') ? entity.introTransition : baseLocation + '/asset/file/' + entity.introTransition"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-else-if="introTransitionTemp && introTransitionTemp.startsWith('data') && introTransitionType == 'Upload' && introTransitionImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="introTransitionTemp" type="video/mp4" />
										</video>
										<video
											v-else-if="!dialogBackgroundTransition && entity.introTransition && introTransitionType == 'URL' && $root.isVideo(entity.introTransition)"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="entity.introTransition.toLowerCase().startsWith('http') ? entity.introTransition : baseLocation + '/asset/file/' + entity.introTransition" type="video/mp4" />
										</video>
										<div v-else-if="!dialogBackgroundTransition && entity.introTransition && introTransitionType == 'URL'  && $root.isYoutubeUrl(entity.introTransition)">
											<youtube
												:videoId="$root.getYoutubeId(entity.introTransition, introTransitionYoutubeParams)"
												:player-vars="introTransitionYoutubeParams"
												style="pointer-events: none "
												width="355"
												height="200"
												ref="introTransitionYoutube"
												@ready="playYoutube('introTransition')"
											></youtube>
										</div>
										<vimeo-player
											v-else-if="!dialogBackgroundTransition && entity.introTransition && introTransitionType == 'URL' && $root.isVimeoUrl(entity.introTransition)"
											:video-url="entity.introTransition"
											:options="introTransitionVimeoParams"
											style="pointer-events: none"
											player-width="355"
											player-height="200"
											ref="introTransition"
										></vimeo-player>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>
										<!--INPUT FOR INTRO TRANSITION--->
										<v-row>
											<v-col cols="12" sm="3">
												<v-select v-model="introTransitionType" :items="['Upload', 'URL']" label="Type"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="introTransitionType === 'Upload'" :disabled="isClinic">
												<input ref="attachment2" type="file" accept="video/mp4" @change="onIntroTransitionUpload" style="display: none" />
												<v-text-field
													v-model="introTransitionFileName"
													label="Intro Transition (Optional)"
													hint="It’s recommended to use video with resolution of 1080 pixels."
													placeholder="Upload Intro Transition"
													prepend-icon="mdi-image-move"
													@click="openIntroTransitionDialog()"
													readonly
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else>
												<v-text-field v-model="entity.introTransition" prepend-icon="mdi-image-move" label="Intro Transition (Optional)" placeholder="Intro Transition Url"></v-text-field> </v-col
										></v-row>
										<v-row v-if="introTransitionType === 'URL' && entity.dataMap">
											<v-col class="pa-0 pl-3" cols="12" sm="5" >
												<v-switch
													v-model="entity.dataMap.introTransition.autoplay"
													inset
													:label="
														entity.dataMap.introTransition.autoplay ? 'Autoplay On' : 'Autoplay Off'
													"
													class="mt-0"
													dense
												></v-switch>
											</v-col>
											<v-col class="pa-0 pl-3" cols="12" sm="6" >
												<v-switch
													v-model="entity.dataMap.introTransition.sound"
													inset
													:label="
														entity.dataMap.introTransition.sound ? 'Sound On' : 'Sound Off'
													"
													class="mt-0"
													dense
												></v-switch>
											</v-col>
										</v-row>

										<!--END INPUT FOR INTRO TRANSITION--->
									</v-col>
									<v-col class="text-center" cols="12" sm="6">
										<v-btn
											class="ma-2"
											color="primary"
											absolute
											small
											style="z-index: 2;"
											@click="
												showBackgroundTransitionLibrary();
												closeAdd();
												isAdd = true;
												isIntro = false;
											"
										>
											Transition Library
										</v-btn>
										<img
											v-if="
												outroTransitionTemp &&
												outroTransitionTemp.startsWith('data') &&
												outroTransitionType == 'Upload' &&
												(outroTransitionImageName.toLowerCase().endsWith('.jpg') || outroTransitionImageName.toLowerCase().endsWith('.jpeg') || outroTransitionImageName.toLowerCase().endsWith('.png'))
											"
											:src="outroTransitionTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entity.outroTransition && outroTransitionType == 'URL' && $root.isImage(entity.outroTransition)"
											:src="entity.outroTransition.toLowerCase().startsWith('http') ? entity.outroTransition : baseLocation + '/asset/file/' + entity.outroTransition"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-else-if="outroTransitionTemp && outroTransitionTemp.startsWith('data') && outroTransitionType == 'Upload' && outroTransitionImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="outroTransitionTemp" type="video/mp4" />
										</video>
										<video
											v-else-if="!dialogBackgroundTransition && entity.outroTransition && outroTransitionType == 'URL' && $root.isVideo(entity.outroTransition)"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="entity.outroTransition.toLowerCase().startsWith('http') ? entity.outroTransition : baseLocation + '/asset/file/' + entity.outroTransition" type="video/mp4" />
										</video>
										<div v-else-if="!dialogBackgroundTransition && entity.outroTransition && outroTransitionType == 'URL'  && $root.isYoutubeUrl(entity.outroTransition)">
											<youtube
												:videoId="$root.getYoutubeId(entity.outroTransition, outroTransitionYoutubeParams)"
												:player-vars="outroTransitionYoutubeParams"
												style="pointer-events: none "
												width="355"
												height="200"
												ref="outroTransitionYoutube"
												@ready="playYoutube('outroTransition')"
											></youtube>
										</div>
										<vimeo-player
											v-else-if="!dialogBackgroundTransition && entity.outroTransition && outroTransitionType == 'URL' && $root.isVimeoUrl(entity.outroTransition)"
											:video-url="entity.outroTransition"
											:options="outroTransitionVimeoParams"
											style="pointer-events: none"
											player-width="355"
											player-height="200"
											ref="outroTransition"
										></vimeo-player>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>
										<!--INPUT FOR OUTRO TRANSITION--->
										<v-row>
											<v-col cols="12" sm="3">
												<v-select v-model="outroTransitionType" :items="['Upload', 'URL']" label="Type"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="outroTransitionType === 'Upload'" :disabled="isClinic">
												<input ref="attachment6" type="file" accept="video/mp4" @change="onOutroTransitionUpload" style="display: none" />
												<v-text-field
													v-model="outroTransitionFileName"
													label="Outro Transition (Optional)"
													hint="It’s recommended to use video with resolution of 1080 pixels."
													placeholder="Upload Outro Transition"
													prepend-icon="mdi-image-move"
													@click="openOutroTransitionDialog()"
													readonly
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else>
												<v-text-field v-model="entity.outroTransition" prepend-icon="mdi-image-move" label="Outro Transition (Optional)" placeholder="Outro Transition Url"></v-text-field> </v-col
										></v-row>
										<v-row v-if="outroTransitionType === 'URL' && entity.dataMap">
											<v-col class="pa-0 pl-3" cols="12" sm="5" >
												<v-switch
													v-model="entity.dataMap.outroTransition.autoplay"
													inset
													:label="
														entity.dataMap.outroTransition.autoplay ? 'Autoplay On' : 'Autoplay Off'
													"
													class="mt-0"
													dense
												></v-switch>
											</v-col>
											<v-col class="pa-0 pl-3" cols="12" sm="6" >
												<v-switch
													v-model="entity.dataMap.outroTransition.sound"
													inset
													:label="
														entity.dataMap.outroTransition.sound ? 'Sound On' : 'Sound Off'
													"
													class="mt-0"
													dense
												></v-switch>
											</v-col>
										</v-row>

										<!--END INPUT FOR OUTRO TRANSITION--->
									</v-col>
									<v-col v-if="isMainStructure && !isClinic" class="text-center" col="12" sm="6">
										<img
											v-if="
												backgroundLoginTemp &&
												backgroundLoginTemp.startsWith('data') &&
												backgroundLoginType == 'Upload' &&
												(backgroundLoginImageName.toLowerCase().endsWith('.jpg') || backgroundLoginImageName.toLowerCase().endsWith('.jpeg') || backgroundLoginImageName.toLowerCase().endsWith('.png'))
											"
											:src="backgroundLoginTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entity.dataMap.backgroundLogin && backgroundLoginType == 'URL' && $root.isImage(entity.dataMap.backgroundLogin)"
											:src="entity.dataMap.backgroundLogin.toLowerCase().startsWith('http') ? entity.dataMap.backgroundLogin : baseLocation + '/asset/file/' + entity.dataMap.backgroundLogin"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-else-if="backgroundLoginTemp && backgroundLoginTemp.startsWith('data') && backgroundLoginType == 'Upload' && backgroundLoginImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="backgroundLoginTemp" type="video/mp4" />
										</video>
										<video
											v-else-if="entity.dataMap.backgroundLogin && backgroundLoginType == 'URL' && $root.isVideo(entity.dataMap.backgroundLogin)"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="entity.dataMap.backgroundLogin.toLowerCase().startsWith('http') ? entity.dataMap.backgroundLogin : baseLocation + '/asset/file/' + entity.dataMap.backgroundLogin" type="video/mp4" />
										</video>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>
										<!--INPUT FOR BACKGROUND LOGIN-->
										<v-row>
											<v-col cols="12" sm="3">
												<v-select v-model="backgroundLoginType" :items="['Upload', 'URL']" label="Type" v-if="isMainStructure"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="isMainStructure && backgroundLoginType === 'Upload' && !isClinic">
												<input ref="attachment5" type="file" accept="image/png, image/jpeg, image/jpg, video/mp4" @change="onBackgroundLoginUpload" style="display: none" />
												<v-text-field
													v-model="backgroundLoginFileName"
													label="Background Login (Optional)"
													hint="It’s recommended to use video with resolution of 1080 pixels."
													placeholder="Upload Background Login"
													prepend-icon="mdi-image-move"
													@click="openBackgroundLoginDialog()"
													readonly
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else-if="isMainStructure && !isClinic">
												<v-text-field v-model="entity.dataMap.backgroundLogin" prepend-icon="mdi-image-move" label="Background Login (Optional)" placeholder="Background Login Url"></v-text-field>
											</v-col>
										</v-row>
										<!--END INPUT FOR BACKGROUND LOGIN--->
									</v-col>
									<v-col v-if="isExhibitionHall" class="text-center" col="12" sm="6">
										<img
											v-if="
												bannerRotatingVideoTemp &&
												bannerRotatingVideoTemp.startsWith('data') &&
												bannerRotatingVideoType == 'Upload' &&
												(bannerRotatingVideoImageName.toLowerCase().endsWith('.jpg') || bannerRotatingVideoImageName.toLowerCase().endsWith('.jpeg') || bannerRotatingVideoImageName.toLowerCase().endsWith('.png'))
											"
											:src="bannerRotatingVideoTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entity.dataMap.bannerRotatingVideo && bannerRotatingVideoType == 'URL' && $root.isImage(entity.dataMap.bannerRotatingVideo)"
											:src="entity.dataMap.bannerRotatingVideo.toLowerCase().startsWith('http') ? entity.dataMap.bannerRotatingVideo : baseLocation + '/asset/file/' + entity.dataMap.bannerRotatingVideo"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-else-if="bannerRotatingVideoTemp && bannerRotatingVideoTemp.startsWith('data') && bannerRotatingVideoType == 'Upload' && bannerRotatingVideoImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="bannerRotatingVideoTemp" type="video/mp4" />
										</video>
										<video
											v-else-if="entity.dataMap.bannerRotatingVideo && bannerRotatingVideoType == 'URL' && $root.isVideo(entity.dataMap.bannerRotatingVideo)"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source
												:src="entity.dataMap.bannerRotatingVideo.toLowerCase().startsWith('http') ? entity.dataMap.bannerRotatingVideo : baseLocation + '/asset/file/' + entity.dataMap.bannerRotatingVideo"
												type="video/mp4"
											/>
										</video>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>
										<!--INPUT FOR BANNER ROTATING VIDEO-->
										<v-row>
											<v-col cols="12" sm="3" v-if="isExhibitionHall && !isClinic">
												<v-select v-if="!isClinic" v-model="bannerRotatingVideoType" :items="['Upload', 'URL']" label="Type" :disabled="isClinic"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="isExhibitionHall && bannerRotatingVideoType === 'Upload' && !isClinic">
												<input ref="attachment3" type="file" accept="video/mp4" @change="onBannerRotatingVideoUpload" style="display: none" />
												<v-text-field
													v-model="bannerRotatingVideoFileName"
													label="Banner Rotating Video (Optional)"
													placeholder="Upload Banner Rotating Video"
													prepend-icon="mdi-image-move"
													@click="openBannerRotatingVideoDialog()"
													readonly
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else-if="isExhibitionHall && !isClinic">
												<v-text-field v-model="entity.dataMap.bannerRotatingVideo" prepend-icon="mdi-image-move" label="Banner Rotating Video" placeholder="Banner Rotating Video Url" :disabled="isClinic"></v-text-field>
											</v-col>
										</v-row>
										<!--END INPUT FOR BANNER ROTATING VIDEO-->
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-text-field v-model="entity.name" label="Name" :rules="[(v) => !!v || 'Name is required']" @input="createUrl(entity.name, false)" prepend-icon="mdi-home" dense></v-text-field>
									</v-col>
									<v-col cols="12" class="mb-n6">
										<v-text-field
											v-model="entity.slug"
											label="URL"
											:rules="[(v) => !!v || 'URL is required', (v) => /^[a-z0-9]*$/.test(v) || 'Must be alphanumeric with lowercase']"
											:hint="host + '/#/' + $store.state.principal.tenantSlug + '/' + $root.selectedExperience.slug + ($store.state.principal.type === 'Exhibition' ? '/hall/' : '/room/') + entity.slug"
											prepend-icon="mdi-web"
											dense
										></v-text-field>
										<v-checkbox
											v-model="isMainStructure"
											label="Entry Point"
											hint="Only check if this is the entry point to your event. This is the first location which will show when users visit the login link"
											persistent-hint
											dense
										></v-checkbox>
										<v-row>
											<v-col cols="2">
												<v-checkbox v-model="isExhibitionHall" label="Exhibition Hall" dense v-if="!isClinic" @change="changeType('exhibition_hall')"></v-checkbox>
											</v-col>
											<v-col cols="2">
												<v-checkbox v-model="isPosterRoom" label="Poster Room" dense v-if="!isClinic" @change="changeType('poster_room')"></v-checkbox>
											</v-col>
										</v-row>
									</v-col>
									<v-col cols="12" sm="12" v-if="isExhibitionHall">
										<v-select v-if="!isClinic" v-model="entity.dataMap.boothSelected" :items="booths" item-text="name" item-value="id" label="Booths" multiple :disabled="isClinic">
											<template v-slot:append-outer>
												<v-btn icon @click="showBoothOrder(entity.dataMap.boothSelected, true)">
													<v-icon>mdi-sort</v-icon>
												</v-btn>
											</template>
										</v-select>
									</v-col>
									<v-col cols="12" sm="12" v-if="isPosterRoom">
										<v-select v-if="!isClinic" v-model="entity.dataMap.posterSelected" :items="posterList" item-text="name" item-value="id" label="Posters" multiple :disabled="isClinic">
											<template v-slot:append-outer>
												<v-btn icon @click="showPosterOrder(entity.dataMap.posterSelected, false)">
													<v-icon>mdi-sort</v-icon>
												</v-btn>
											</template>
										</v-select>
									</v-col>
									<v-col cols="12" v-if="isExhibitionHall && !isClinic">
										<v-row>
											<v-col cols="8">
												<v-autocomplete v-model="boothBackgroundTagFilter" :items="boothBackgroundTagList" chips small-chips deletable-chips label="Filter by tags" multiple solo dense></v-autocomplete>
											</v-col>
											<div style="display: flex; flex-direction: row; margin-top: 13px">
												<v-btn style="margin-right: 10px" @click="filterBoothBackground" color="primary">filter</v-btn>
												<v-btn @click="resetBoothBackground" color="primary">Reset</v-btn>
											</div>
										</v-row>
										<v-carousel hide-delimiters class="top">
											<v-carousel-item v-for="(item, index) in boothBackgroundList" :key="index" eager>
												<v-img :src="$root.asset(item.background)" contain eager>
													<v-btn v-if="item.id == selectedBoothBackground" color="blue">Selected Booth Background</v-btn>
													<v-btn v-else @click="selectBoothBackground(item)">Select This Booth Background</v-btn>
												</v-img>
											</v-carousel-item>
										</v-carousel>
									</v-col>
									<v-col cols="12" sm="12" class="mb-n4">
										<v-checkbox v-model="isPasswordProtectRoom" label="Password Protect Room" dense></v-checkbox>
										<v-text-field
											v-if="isPasswordProtectRoom"
											v-model="passwordProtect"
											:rules="[(v) => !!v || 'Password Protect Room is required']"
											prepend-icon="mdi-shield-key"
											label="Password Protect Room"
											placeholder="Password Protect Room"
											:type="passwordFieldType"
											:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
											@click:append="switchVisibility"
										></v-text-field>
									</v-col>
									<template v-if="$store.state.principal.type == 'Exhibition'">
										<v-col cols="12">
											<v-select
												v-model="entity.allowTicketList"
												:items="ticketList"
												item-text="name"
												item-value="id"
												label="Allowed Ticket List"
												prepend-icon="mdi-check"
												multiple
												chips
												hint="Empty list means all access"
												persistent-hint
											></v-select>
										</v-col>
										<v-col cols="12">
											<v-select v-model="entity.denyTicketList" :items="ticketList" item-text="name" item-value="id" label="Denied Ticket List" prepend-icon="mdi-block-helper" multiple chips></v-select>
										</v-col>

									</template>
									<v-col cols="12" sm="6">
										<v-switch
											v-model="entity.status"
											inset
											prepend-icon="mdi-list-status"
											:label="
												entity.status ? 'Active' : 'Inactive'
											"
											class="mt-0"
											dense
										></v-switch>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
		<!--- END OF ROOM LIBRARY-->

		<v-dialog v-model="dialogEdit" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Edit Room
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="8">
							<v-form ref="formEdit" v-model="validEdit" @submit.prevent="editStructure">
								<v-row class="entry-view justify-center">
									<v-col cols="12">
										<v-col sm="3">
											<v-select v-model="uploadType" :items="['CloudFront', 'Vimeo']" label="Upload Type"></v-select>
										</v-col>
									</v-col>
									<v-col class="text-center" cols="12" sm="6">
										<v-btn
											class="ma-2"
											color="primary"
											absolute
											small
											style="z-index: 2;"
											@click="
												dialogRoomLibrary = true;
												dialogEdit = false;
												isEdit = true;
											"
											>Room Library</v-btn
										>
										<img
											v-if="
												editBackgroundTemp &&
												editBackgroundTemp.startsWith('data') &&
												backgroundType == 'Upload' &&
												(backgroundImageName.toLowerCase().endsWith('.jpg') || backgroundImageName.toLowerCase().endsWith('.jpeg') || backgroundImageName.toLowerCase().endsWith('.png'))
											"
											:src="editBackgroundTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entityEdit.background && backgroundType == 'URL' && $root.isImage(entityEdit.background)"
											:src="entityEdit.background.toLowerCase().startsWith('http') ? entityEdit.background : baseLocation + '/asset/file/' + entityEdit.background"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-else-if="editBackgroundTemp && backgroundType == 'Upload' && editBackgroundTemp.startsWith('data') && backgroundImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="editBackgroundTemp" type="video/mp4" />
										</video>
										<div v-else-if="entityEdit.background && backgroundType == 'URL' && $root.isVideo(entityEdit.background)" class="d-flex justify-center">
											<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Background
												&& (entityEdit.transitMap.videoUploadStatus.Background === 'ready' || entityEdit.transitMap.videoUploadStatus.Background === 'uploading')"
												class="icon_vimeo_progress_upload">mdi-progress-upload
											</v-icon>
											<video
												style="min-height: 200px; max-height: 200px;"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="entityEdit.background.toLowerCase().startsWith('http') ? entityEdit.background : baseLocation + '/asset/file/' + entityEdit.background" type="video/mp4" />
											</video>
										</div>
										<div v-else-if="entityEdit.background && backgroundType == 'URL' && $root.isYoutubeUrl(entityEdit.background)">
											<youtube
												:videoId="$root.getYoutubeId(entityEdit.background, backgroundYoutubeParams)"
												:player-vars="backgroundYoutubeParams"
												style="pointer-events: none "
												width="355"
												height="200"
												ref="backgroundYoutube"
												@ready="playYoutube('background')"
											></youtube>
										</div>
										<div v-else-if="entityEdit.background && backgroundType == 'URL'  && $root.isVimeoUrl(entityEdit.background)" class="d-flex justify-center">
											<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Background
												&& entityEdit.transitMap.videoUploadStatus.Background === 'available'"
												class="icon_vimeo_succes_upload" small>mdi-vimeo
											</v-icon>
											<vimeo-player
												:video-url="entityEdit.background"
												:options="backgroundVimeoParams"
												style="pointer-events: none"
												player-width="355"
												player-height="200"
												ref="background"
											>
											</vimeo-player>
										</div>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>

										<!---INPUT FOR BACKGROUND--->
										<v-row>
											<v-col cols="12" sm="3">
												<v-select v-model="backgroundType" :items="['Upload', 'URL']" label="Type"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="backgroundType === 'Upload'">
												<input ref="attachment1" type="file" accept="image/png, image/jpeg, image/jpg, video/mp4" @change="onBackgroundUpload" style="display: none" />
												<v-text-field
													v-model="backgroundFileName"
													label="Background"
													hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
													placeholder="Upload Background"
													prepend-icon="mdi-image"
													@click="openBackgroundDialog()"
													readonly
													:rules="[(v) => !!v || 'Room image is required']"
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else>
												<v-text-field v-model="entityEdit.background" prepend-icon="mdi-image" label="Background" placeholder="Background Url" :rules="[(v) => !!v || 'Room image is required']"></v-text-field>
											</v-col>
										</v-row>
										<!---END INPUT FOR BACKGROUND-->
									</v-col>
									<v-col class="text-center" cols="12" sm="6">
										<v-btn
											class="ma-2"
											color="primary"
											absolute
											small
											style="z-index: 2;"
											@click="
												showBackgroundTransitionLibrary();
												dialogEdit = false;
												isEdit = true;
												isIntro = true;
											"
										>
											Transition Library
										</v-btn>
										<img
											v-if="
												editIntroTransitionTemp &&
												editIntroTransitionTemp.startsWith('data') &&
												introTransitionType == 'Upload' &&
												(introTransitionImageName.toLowerCase().endsWith('.jpg') || introTransitionImageName.toLowerCase().endsWith('.jpeg') || introTransitionImageName.toLowerCase().endsWith('.png'))
											"
											:src="editIntroTransitionTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entityEdit.introTransition && introTransitionType == 'URL' && $root.isImage(entityEdit.introTransition)"
											:src="entityEdit.introTransition.toLowerCase().startsWith('http') ? entityEdit.introTransition : baseLocation + '/asset/file/' + entityEdit.introTransition"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-if="editIntroTransitionTemp && editIntroTransitionTemp.startsWith('data') && introTransitionType == 'Upload' && introTransitionImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="editIntroTransitionTemp" type="video/mp4" />
										</video>
										<div v-else-if="(!dialogBackgroundTransition && !dialogRoomLibrary) && entityEdit.introTransition && introTransitionType == 'URL' && $root.isVideo(entityEdit.introTransition)" class="d-flex justify-center">
											<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Intro_Transition
												&& (entityEdit.transitMap.videoUploadStatus.Intro_Transition === 'ready' || entityEdit.transitMap.videoUploadStatus.Intro_Transition === 'uploading')"
												class="icon_vimeo_progress_upload">mdi-progress-upload
											</v-icon>
											<video
												style="min-height: 200px; max-height: 200px;"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="entityEdit.introTransition.toLowerCase().startsWith('http') ? entityEdit.introTransition : baseLocation + '/asset/file/' + entityEdit.introTransition" type="video/mp4" />
											</video>
										</div>

										<div v-else-if="(!dialogBackgroundTransition && !dialogRoomLibrary) && entityEdit.introTransition && introTransitionType == 'URL' && $root.isYoutubeUrl(entityEdit.introTransition)">
											<youtube
												:videoId="$root.getYoutubeId(entityEdit.introTransition, introTransitionYoutubeParams)"
												:player-vars="introTransitionYoutubeParams"
												style="pointer-events: none "
												width="355"
												height="200"
												ref="introTransitionYoutube"
												@ready="playYoutube('introTransition')"
											></youtube>
										</div>
										<div v-else-if="(!dialogBackgroundTransition && !dialogRoomLibrary) && entityEdit.introTransition && introTransitionType == 'URL' && $root.isVimeoUrl(entityEdit.introTransition)" class="d-flex justify-center">
											<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Intro_Transition
												&& entityEdit.transitMap.videoUploadStatus.Intro_Transition === 'available'"
												class="icon_vimeo_succes_upload" small>mdi-vimeo
											</v-icon>
											<vimeo-player
												:video-url="entityEdit.introTransition"
												:options="introTransitionVimeoParams"
												style="pointer-events: none"
												player-width="355"
												player-height="200"
												ref="introTransition"
											></vimeo-player>
										</div>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>
										<!--INPUT FOR INTRO TRANSITION--->
										<v-row>
											<v-col cols="12" sm="3">
												<v-select v-model="introTransitionType" :items="['Upload', 'URL']" label="Type"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="introTransitionType === 'Upload'" :disabled="isClinic">
												<input ref="attachment2" type="file" accept="video/mp4" @change="onIntroTransitionUpload" style="display: none" />
												<v-text-field
													v-model="introTransitionFileName"
													label="Intro Transition (Optional)"
													hint="It’s recommended to use video with resolution of 1080 pixels."
													placeholder="Upload Intro Transition"
													prepend-icon="mdi-image-move"
													@click="openIntroTransitionDialog()"
													readonly
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else>
												<v-text-field v-model="entityEdit.introTransition" prepend-icon="mdi-image-move" label="Intro Transition (Optional)" placeholder="Intro Transition Url"></v-text-field>
											</v-col>
										</v-row>
										<v-row v-if="introTransitionType === 'URL'">
											<v-col class="pa-0 pl-3" cols="12" sm="5" >
												<v-switch
													v-model="entityEdit.dataMap.introTransition.autoplay"
													inset
													:label="
														entityEdit.dataMap.introTransition.autoplay ? 'Autoplay On' : 'Autoplay Off'
													"
													class="mt-0"
													dense
												></v-switch>
											</v-col>
											<v-col class="pa-0 pl-3" cols="12" sm="6" >
												<v-switch
													v-model="entityEdit.dataMap.introTransition.sound"
													inset
													:label="
														entityEdit.dataMap.introTransition.sound ? 'Sound On' : 'Sound Off'
													"
													class="mt-0"
													dense
												></v-switch>
											</v-col>
										</v-row>
										<!--END INPUT FOR INTRO TRANSITION--->
									</v-col>
									<v-col class="text-center" cols="12" sm="6">
										<v-btn
											class="ma-2"
											color="primary"
											absolute
											small
											style="z-index: 2;"
											@click="
												showBackgroundTransitionLibrary();
												dialogEdit = false;
												isEdit = true;
												isIntro = false;
											"
										>
											Transition Library
										</v-btn>
										<img
											v-if="
												editOutroTransitionTemp &&
												editOutroTransitionTemp.startsWith('data') &&
												outroTransitionType == 'Upload' &&
												(outroTransitionImageName.toLowerCase().endsWith('.jpg') || outroTransitionImageName.toLowerCase().endsWith('.jpeg') || outroTransitionImageName.toLowerCase().endsWith('.png'))
											"
											:src="editOutroTransitionTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entityEdit.outroTransition && outroTransitionType == 'URL' && $root.isImage(entityEdit.outroTransition)"
											:src="entityEdit.outroTransition.toLowerCase().startsWith('http') ? entityEdit.outroTransition : baseLocation + '/asset/file/' + entityEdit.outroTransition"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-if="editOutroTransitionTemp && editOutroTransitionTemp.startsWith('data') && outroTransitionType == 'Upload' && outroTransitionImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="editOutroTransitionTemp" type="video/mp4" />
										</video>
										<div v-else-if="(!dialogBackgroundTransition && !dialogRoomLibrary) && entityEdit.outroTransition && outroTransitionType == 'URL' && $root.isVideo(entityEdit.outroTransition)" class="d-flex justify-center">
											<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Outro_Transition
												&& (entityEdit.transitMap.videoUploadStatus.Outro_Transition === 'ready' || entityEdit.transitMap.videoUploadStatus.Outro_Transition === 'uploading')"
												class="icon_vimeo_progress_upload">mdi-progress-upload
											</v-icon>
											<video
												style="min-height: 200px; max-height: 200px;"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="entityEdit.outroTransition.toLowerCase().startsWith('http') ? entityEdit.outroTransition : baseLocation + '/asset/file/' + entityEdit.outroTransition" type="video/mp4" />
											</video>
										</div>

										<div v-else-if="(!dialogBackgroundTransition && !dialogRoomLibrary) && entityEdit.outroTransition && outroTransitionType == 'URL' && !$root.isVideo(entityEdit.outroTransition) && $root.isYoutubeUrl(entityEdit.outroTransition)">
											<youtube
												:videoId="$root.getYoutubeId(entityEdit.outroTransition, outroTransitionYoutubeParams)"
												:player-vars="outroTransitionYoutubeParams"
												style="pointer-events: none "
												width="355"
												height="200"
												ref="outroTransitionYoutube"
												@ready="playYoutube('outroTransition')"
											></youtube>
										</div>
										<div v-else-if="(!dialogBackgroundTransition && !dialogRoomLibrary) && entityEdit.outroTransition && outroTransitionType == 'URL' && $root.isVimeoUrl(entityEdit.outroTransition)" class="d-flex justify-center">
											<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Outro_Transition
												&& entityEdit.transitMap.videoUploadStatus.Outro_Transition === 'available'"
												class="icon_vimeo_succes_upload" small>mdi-vimeo
											</v-icon>
											<vimeo-player
												:video-url="entityEdit.outroTransition"
												:options="outroTransitionVimeoParams"
												player-width="355"
												player-height="200"
												style="pointer-events: none"
												ref="outroTransition"
											></vimeo-player>
										</div>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>
										<!--INPUT FOR OUTRO TRANSITION--->
										<v-row>
											<v-col cols="12" sm="3">
												<v-select v-model="outroTransitionType" :items="['Upload', 'URL']" label="Type"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="outroTransitionType === 'Upload'" :disabled="isClinic">
												<input ref="attachment6" type="file" accept="video/mp4" @change="onOutroTransitionUpload" style="display: none" />
												<v-text-field
													v-model="outroTransitionFileName"
													label="Outro Transition (Optional)"
													hint="It’s recommended to use video with resolution of 1080 pixels."
													placeholder="Upload Intro Transition"
													prepend-icon="mdi-image-move"
													@click="openOutroTransitionDialog()"
													readonly
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else>
												<v-text-field v-model="entityEdit.outroTransition" prepend-icon="mdi-image-move" label="Outro Transition (Optional)" placeholder="Outro Transition Url"></v-text-field> </v-col
										></v-row>
										<v-row v-if="outroTransitionType === 'URL'">
											<v-col class="pa-0 pl-3" cols="12" sm="5" >
												<v-switch
													v-model="entityEdit.dataMap.outroTransition.autoplay"
													inset
													:label="
														entityEdit.dataMap.outroTransition.autoplay ? 'Autoplay On' : 'Autoplay Off'
													"
													class="mt-0"
													dense
												></v-switch>
											</v-col>
											<v-col class="pa-0 pl-3" cols="12" sm="6" >
												<v-switch
													v-model="entityEdit.dataMap.outroTransition.sound"
													inset
													:label="
														entityEdit.dataMap.outroTransition.sound ? 'Sound On' : 'Sound Off'
													"
													class="mt-0"
													dense
												></v-switch>
											</v-col>
										</v-row>
										<!--END INPUT FOR OUTRO TRANSITION--->
									</v-col>
									<v-col v-if="isMainStructure && !isClinic" class="text-center" col="12" sm="6">
										<img
											v-if="
												editBackgroundLoginTemp &&
												editBackgroundLoginTemp.startsWith('data') &&
												backgroundLoginType == 'Upload' &&
												(backgroundLoginImageName.toLowerCase().endsWith('.jpg') || backgroundLoginImageName.toLowerCase().endsWith('.jpeg') || backgroundLoginImageName.toLowerCase().endsWith('.png'))
											"
											:src="editBackgroundLoginTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entityEdit.dataMap.backgroundLogin && backgroundLoginType == 'URL' && $root.isImage(entityEdit.dataMap.backgroundLogin)"
											:src="entityEdit.dataMap.backgroundLogin.toLowerCase().startsWith('http') ? entityEdit.dataMap.backgroundLogin : baseLocation + '/asset/file/' + entityEdit.dataMap.backgroundLogin"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-else-if="editBackgroundLoginTemp && editBackgroundLoginTemp.startsWith('data') && backgroundLoginType == 'Upload' && backgroundLoginImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="editBackgroundLoginTemp" type="video/mp4" />
										</video>
										<div v-else-if="entityEdit.dataMap.backgroundLogin && backgroundLoginType == 'URL' && $root.isVideo(entityEdit.dataMap.backgroundLogin)" class="d-flex justify-center">
											<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Background_Login
												&& (entityEdit.transitMap.videoUploadStatus.Background_Login === 'ready' || entityEdit.transitMap.videoUploadStatus.Background_Login === 'uploading')"
												class="icon_vimeo_progress_upload">mdi-progress-upload
											</v-icon>
											<video
												style="min-height: 200px; max-height: 200px;"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="entityEdit.dataMap.backgroundLogin.toLowerCase().startsWith('http') ? entityEdit.dataMap.backgroundLogin : baseLocation + '/asset/file/' + entityEdit.dataMap.backgroundLogin"
													type="video/mp4"
												/>
											</video>
										</div>
										<div v-else-if="entityEdit.dataMap.backgroundLogin && backgroundLoginType == 'URL' && !$root.isVideo(entityEdit.dataMap.backgroundLogin) && $root.isYoutubeUrl(entityEdit.dataMap.backgroundLogin)">
											<youtube
												:videoId="$root.getYoutubeId(entityEdit.dataMap.backgroundLogin, backgroundLoginYoutubeParams)"
												:player-vars="backgroundLoginYoutubeParams"
												style="pointer-events: none "
												width="355"
												height="200"
												ref="backgroundLoginYoutube"
												@ready="playYoutube('backgroundLogin')"
											></youtube>
										</div>
										<div v-else-if="entityEdit.dataMap.backgroundLogin && backgroundLoginType == 'URL' && $root.isVimeoUrl(entityEdit.dataMap.backgroundLogin)" class="d-flex justify-center">
											<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Background_Login
												&& entityEdit.transitMap.videoUploadStatus.Background_Login === 'available'"
												class="icon_vimeo_succes_upload" small>mdi-vimeo
											</v-icon>
											<vimeo-player
												:video-url="entityEdit.dataMap.backgroundLogin"
												:options="backgroundLoginVimeoParams"
												player-width="355"
												player-height="200"
												style="pointer-events: none"
												ref="backgroundLogin"
											></vimeo-player>
										</div>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>
										<!--INPUT FOR BACKGROUND LOGIN--->
										<v-row>
											<v-col cols="12" sm="3">
												<v-select v-model="backgroundLoginType" :items="['Upload', 'URL']" label="Type" v-if="isMainStructure"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="isMainStructure && backgroundLoginType === 'Upload' && !isClinic">
												<input ref="attachment5" type="file" accept="image/png, image/jpeg, image/jpg, video/mp4" @change="onBackgroundLoginUpload" style="display: none" />
												<v-text-field
													v-model="backgroundLoginFileName"
													label="Background Login (Optional)"
													hint="It’s recommended to use video with resolution of 1080 pixels."
													placeholder="Upload Background Login"
													prepend-icon="mdi-image-move"
													@click="openBackgroundLoginDialog()"
													readonly
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else-if="isMainStructure && !isClinic">
												<v-text-field v-model="entityEdit.dataMap.backgroundLogin" prepend-icon="mdi-image-move" label="Background Login (Optional)" placeholder="Background Login Url"></v-text-field>
											</v-col>
										</v-row>
										<!--END INPUT FOR BACKGROUND LOGIN--->
									</v-col>
									<v-col v-if="isExhibitionHall" class="text-center" col="12" sm="6">
										<img
											v-if="
												editBannerRotatingVideoTemp &&
												editBannerRotatingVideoTemp.startsWith('data') &&
												bannerRotatingVideoType == 'Upload' &&
												(bannerRotatingVideoImageName.toLowerCase().endsWith('.jpg') || bannerRotatingVideoImageName.toLowerCase().endsWith('.jpeg') || bannerRotatingVideoImageName.toLowerCase().endsWith('.png'))
											"
											:src="editBannerRotatingVideoTemp"
											style="min-height: 200px; max-height: 200px;"
										/>
										<img
											v-else-if="entityEdit.dataMap.bannerRotatingVideo && bannerRotatingVideoType == 'URL' && $root.isImage(entityEdit.dataMap.bannerRotatingVideo)"
											:src="entityEdit.dataMap.bannerRotatingVideo.toLowerCase().startsWith('http') ? entityEdit.dataMap.bannerRotatingVideo : baseLocation + '/asset/file/' + entityEdit.dataMap.bannerRotatingVideo"
											style="min-height: 200px; max-height: 200px;"
										/>

										<video
											v-else-if="editBannerRotatingVideoTemp && editBannerRotatingVideoTemp.startsWith('data') && bannerRotatingVideoType == 'Upload' && bannerRotatingVideoImageName.toLowerCase().endsWith('.mp4')"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="editBannerRotatingVideoTemp" type="video/mp4" />
										</video>
										<video
											v-else-if="entityEdit.dataMap.bannerRotatingVideo && bannerRotatingVideoType == 'URL' && $root.isVideo(entityEdit.dataMap.bannerRotatingVideo)"
											style="min-height: 200px; max-height: 200px;"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source
												:src="entityEdit.dataMap.bannerRotatingVideo.toLowerCase().startsWith('http') ? entityEdit.dataMap.bannerRotatingVideo : baseLocation + '/asset/file/' + entity.dataMap.bannerRotatingVideo"
												type="video/mp4"
											/>
										</video>
										<div v-else style="border: 5px solid black; width: 100%; min-height: 200px; max-height: 200px; margin-bottom: 6px;"></div>
										<!--INPUT FOR BANNER ROTATING VIDEO--->
										<v-row>
											<v-col cols="12" sm="3" v-if="isExhibitionHall && !isClinic">
												<v-select v-model="bannerRotatingVideoType" :items="['Upload', 'URL']" label="Type" :disabled="isClinic"></v-select>
											</v-col>
											<v-col cols="12" sm="9" v-if="isExhibitionHall && bannerRotatingVideoType === 'Upload' && !isClinic">
												<input ref="attachment3" type="file" accept="video/mp4" @change="onBannerRotatingVideoUpload" style="display: none" />
												<v-text-field
													v-model="bannerRotatingVideoFileName"
													label="Banner Rotating Video (Optional)"
													placeholder="Upload Banner Rotating Video"
													prepend-icon="mdi-image-move"
													@click="openBannerRotatingVideoDialog()"
													readonly
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="9" v-else-if="isExhibitionHall && !isClinic">
												<v-text-field v-model="entityEdit.dataMap.bannerRotatingVideo" prepend-icon="mdi-image-move" label="Banner Rotating Video" placeholder="Banner Rotating Video Url" :disabled="isClinic"></v-text-field>
											</v-col>
										</v-row>
										<!--END INPUT FOR BANNER ROTATING VIDEO--->
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-text-field v-model="entityEdit.name" label="Name" :rules="[(v) => !!v || 'Name is required']" @input="createUrl(entityEdit.name, true)" prepend-icon="mdi-home" dense></v-text-field>
									</v-col>
									<v-col cols="12" class="mb-n6">
										<v-text-field
											v-model="entityEdit.slug"
											label="URL"
											:rules="[(v) => !!v || 'URL is required', (v) => /^[a-z0-9]*$/.test(v) || 'Must be alphanumeric with lowercase']"
											:hint="host + '/#/' + $store.state.principal.tenantSlug + '/' + $root.selectedExperience.slug + ($store.state.principal.type === 'Exhibition' ? '/hall/' : '/room/') + entityEdit.slug"
											prepend-icon="mdi-web"
											dense
										></v-text-field>
										<v-checkbox
											v-model="isMainStructure"
											label="Entry Point"
											hint="Only check if this is the entry point to your event. This is the first location which will show when users visit the login link"
											persistent-hint
											dense
										></v-checkbox>

										<v-row>
											<v-col cols="2">
												<v-checkbox v-model="isExhibitionHall" label="Exhibition Hall" dense v-if="!isClinic" @change="changeType('exhibition_hall')"></v-checkbox>
											</v-col>
											<v-col cols="2">
												<v-checkbox v-model="isPosterRoom" label="Poster Room" dense v-if="!isClinic" @change="changeType('poster_room')"></v-checkbox>
											</v-col>
										</v-row>
									</v-col>
									<v-col cols="12" sm="12" v-if="isExhibitionHall">
										<v-select v-if="!isClinic" v-model="entityEdit.dataMap.boothSelected" :items="booths" item-text="name" item-value="id" label="Booths" multiple :disabled="isClinic">
											<template v-slot:append-outer>
												<v-btn icon @click="showBoothOrder(entityEdit.dataMap.boothSelected, false)">
													<v-icon>mdi-sort</v-icon>
												</v-btn>
											</template>
										</v-select>
									</v-col>
									<v-col cols="12" sm="12" v-if="isPosterRoom">
										<v-select v-if="!isClinic" v-model="entityEdit.dataMap.posterSelected" :items="posterList" item-text="name" item-value="id" label="Posters" multiple :disabled="isClinic">
											<template v-slot:append-outer>
												<v-btn icon @click="showPosterOrder(entityEdit.dataMap.posterSelected, false)">
													<v-icon>mdi-sort</v-icon>
												</v-btn>
											</template>
										</v-select>

									</v-col>
									<v-col cols="12" v-if="isExhibitionHall && !isClinic">
										<v-row>
											<v-col cols="8">
												<v-autocomplete v-model="boothBackgroundTagFilter" :items="boothBackgroundTagList" chips small-chips deletable-chips label="Filter by tags" multiple solo dense></v-autocomplete>
											</v-col>
											<div style="display: flex; flex-direction: row; margin-top: 13px">
												<v-btn style="margin-right: 10px" @click="filterBoothBackground" color="primary">filter</v-btn>
												<v-btn @click="resetBoothBackground" color="primary">Reset</v-btn>
											</div>
										</v-row>
										<v-carousel hide-delimiters class="top">
											<v-carousel-item v-for="(item, index) in boothBackgroundList" :key="index" eager>
												<v-img :src="$root.asset(item.background)" contain eager>
													<v-btn v-if="item.id == selectedBoothBackground" color="blue">Selected Booth Background</v-btn>
													<v-btn v-else @click="selectBoothBackground(item)">Select This Booth Background</v-btn>
												</v-img>
											</v-carousel-item>
										</v-carousel>
									</v-col>
									<v-col cols="12" sm="12" class="mb-n4">
										<v-checkbox v-model="isPasswordProtectRoom" label="Password Protect Room" dense></v-checkbox>
										<v-text-field
											v-if="isPasswordProtectRoom"
											v-model="entityEdit.dataMap.passwordProtect"
											:rules="[(v) => !!v || 'Password Protect Room is required']"
											prepend-icon="mdi-shield-key"
											label="Password Protect Room"
											placeholder="Password Protect Room"
											:type="passwordFieldType"
											:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
											@click:append="switchVisibility"
										></v-text-field>
									</v-col>
									<template v-if="$store.state.principal.type == 'Exhibition'">
										<v-col cols="12">
											<v-select
												v-model="entityEdit.allowTicketList"
												:items="ticketList"
												item-text="name"
												item-value="id"
												label="Allowed Ticket List"
												prepend-icon="mdi-check"
												multiple
												chips
												hint="Empty list means all access"
												persistent-hint
											></v-select>
										</v-col>
										<v-col cols="12">
											<v-select v-model="entityEdit.denyTicketList" :items="ticketList" item-text="name" item-value="id" label="Denied Ticket List" prepend-icon="mdi-block-helper" multiple chips></v-select>
										</v-col>
									</template>
								</v-row>
								<v-row>
									<v-col cols="12" sm="6">
										<v-switch
											v-model="entityEdit.status"
											inset
											prepend-icon="mdi-list-status"
											:label="
												entityEdit.status ? 'Active' : 'Inactive'
											"
											class="mt-0"
											dense
										></v-switch>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!validEdit" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog :retain-focus="false" v-model="dialogLinkTo" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Link To
					<v-spacer></v-spacer>
					<v-btn icon @click="closeLinkTo()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text style="overflow-x: auto">
					<div class="d-flex">
						<div class="ma-1">
							<v-card class="pa-3">
								<div @mousedown="startDraw($event)" @mousemove="draw($event)" style="position: relative; width: 960px; min-width: 960px; background-color: rgba(0, 0, 0, 0.2);" ref="canvas" id="canvas">
									<img
										v-if="entityEdit.background && (entityEdit.background.toLowerCase().endsWith('.jpg') || entityEdit.background.toLowerCase().endsWith('.jpeg') || entityEdit.background.toLowerCase().endsWith('.png'))"
										:src="entityEdit.background.toLowerCase().startsWith('http') ? entityEdit.background : baseLocation + '/asset/file/' + entityEdit.background"
										style="display: block"
										width="100%"
										draggable="false"
									/>
									<video
										v-else-if="entityEdit.background && entityEdit.background.toLowerCase().endsWith('.mp4')"
										style="display: block"
										width="100%"
										preload="auto"
										autoplay="autoplay"
										muted
										playsinline
										disablepictureinpicture
										loop="loop"
										draggable="false"
									>
										<source :src="entityEdit.background.toLowerCase().startsWith('http') ? entityEdit.background : baseLocation + '/asset/file/' + entityEdit.background" type="video/mp4" />
									</video>
									<template v-else-if="$root.isYoutubeUrl(entityEdit.background)">
										<div style="width: 100%; height: 100%; background-color: #00000000; z-index: 1; position: absolute;">
										</div>
										<youtube
											:videoId="$root.getYoutubeId(entityEdit.background, backgroundYoutubeParams)"
											:player-vars="backgroundYoutubeParams"
											style="pointer-events: none "
											width="960"
											height="530"
											@click="chooseRoomLibrary(room)"
										></youtube>
									</template>
									<template v-else-if="$root.isVimeoUrl(entityEdit.background)">
										<div style="width: 100%; height: 100%; background-color: #00000000; z-index: 1; position: absolute;">
										</div>
										<vimeo-player
											:video-url="entityEdit.background"
											:options="backgroundVimeoParams"
											style="pointer-events: none"
											player-width="960"
											player-height="auto"
											ref="background"
										></vimeo-player>
									</template>
									<div v-for="(item, index) in entityEdit.linkToDataList" :key="index">
										<div
											:style="{
												zIndex: layerMode == true ? entityEdit.linkToDataList.length + 2 : 3,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												pointerEvents: 'none',
												border: '1px solid #18FFFF',
												cursor: 'pointer'
											}"
											@click="editLinkTo(entityEdit, item.id)"
										>
											<v-badge :content="index + 1" :value="index + 1" color="teal" overlap style="position: absolute"> </v-badge>
										</div>
										<img
											:id=item.id
											v-if="item.type === 'Image'"
											:src="$root.asset(item.value)"
											:style="{
												zIndex: layerMode == true ? entityEdit.linkToDataList.length - index : 1,
												width: item.width + 'px',
												height: item.height + 'px',
												objectFit: $root.setBackgroundSize(item.subType),
												objectPosition: $root.setBackgroundPosition(item),
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												pointerEvents: 'none'
											}"
											draggable="false"
										/>
										<iframe
											:id=item.id
											v-else-if="item.type === 'Video' && $root.isEmbedVideo(item.value)"
											:style="{
												zIndex: layerMode == true ?  entityEdit.linkToDataList.length - index : 1,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												pointerEvents: 'none'
											}"
											frameborder="0"
											allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
											scrolling="0"
											:src="$root.asset($root.appendMuteVideo(item.value))"
										>
										</iframe>
										<video
											:id=item.id
											v-else-if="item.type === 'Video'"
											:style="{
												backgroundColor: '#000000',
												zIndex: layerMode == true ? entityEdit.linkToDataList.length - index : 1,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												pointerEvents: 'none'
											}"
											frameborder="0"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											scrolling="0"
											:src="$root.asset(item.value)"
										>
										</video>
										<div
											:id=item.id
											v-else-if="item.type === 'Text'"
											class="hotspot_text"
											v-html="item.value"
											:style="{
												zIndex: layerMode == true ? entityEdit.linkToDataList.length - index : 2,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + (item.skewX ? item.skewX : '0') + 'deg,' + (item.skewY ? item.skewY : '0') + 'deg)',
												position: 'absolute',
												backgroundColor: item.backgroundColor,
												borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
												borderWidth: item.borderWidth,
												borderColor: item.borderColor,
												padding: (item.padding ? item.padding : '0') + 'px',
												pointerEvents: 'none'
											}"
										></div>
										<div
											:id=item.id
											v-else-if="item.type === 'Embed_HTML' && item.target === 'Embed'"
											:style="{
												zIndex: layerMode == true ? entityEdit.linkToDataList.length - index : 1,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												overflow: 'hidden',
												pointerEvents: 'none'
											}"
											v-append="item.valueRender ? item.valueRender : item.value"
										></div>

										<v-btn
											:id=item.id
											v-else-if="(item.type === 'Button' || item.type === 'Back_Button') && !item.backgroundImage"
											:class="'hotspot_btn hotspot_btn_custom_' + item.id"
											absolute
											:color="item.backgroundColor"
											:style="{
												zIndex: layerMode == true ?  entityEdit.linkToDataList.length - index : 2,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												textTransform: 'none',
												borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
												borderRadius: item.borderRadius,
												borderWidth: item.borderWidth,
												borderColor: item.borderColor,
												pointerEvents: 'none'
											}"
										>
											<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
										</v-btn>
										<v-btn
											:id=item.id
											v-else-if="(item.type === 'Button' || item.type === 'Back_Button') && item.backgroundImage"
											:class="'hotspot_btn hotspot_btn_custom_' + item.id"
											absolute
											:style="{
												backgroundImage: 'url(' + item.backgroundImage + ')',
												zIndex: layerMode == true ? entityEdit.linkToDataList.length - index : 2,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												textTransform: 'none',
												borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
												borderRadius: item.borderRadius,
												borderWidth: item.borderWidth,
												borderColor: item.borderColor,
												pointerEvents: 'none'
											}"
										>
											<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
										</v-btn>
										<router-link
											v-else
											:id=item.id
											class="room-link"
											to="#"
											:style="{
												zIndex: layerMode == true ? entityEdit.linkToDataList.length - index : 3,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												pointerEvents: 'none'
											}"
										></router-link>
									</div>
									<div
										v-if="entityEdit.dataMap.isExhibitionHall && entityEdit.dataMap.boothSelected != null && entityEdit.dataMap.boothSelected.length > 0"
										class="d-flex justify-center"
										style="position: absolute; z-index:1; top: 0; right: 0, bottom:0; width: auto; min-width:100%; max-height:100%;"
									>
										<v-row class="d-flex justify-center mx-0">
											<v-col cols="8" class="my-2" style="background-color: rgba(0, 0, 0, 0.5); overflow-y: auto; max-height: 95%">
												<v-list style="background-color: rgba(0, 0, 0, 0)" dark dense>
													<div v-for="(item, index) in getBoothSelectedList(entityEdit.dataMap.boothSelected, entityEdit.slug)" :key="index">
														<v-list-item v-if="item" link>
															<v-list-item-avatar size="30" color="grey lighten-2">
																<v-img :src="$root.asset(item.logo)"></v-img>
															</v-list-item-avatar>
															<v-list-item-content>{{ item.name }}</v-list-item-content>
														</v-list-item>
														<v-divider></v-divider>
													</div>
												</v-list>
											</v-col>
										</v-row>
									</div>
									<div
										v-if="entityEdit.dataMap.isPosterRoom && entityEdit.dataMap.posterSelected != null && entityEdit.dataMap.posterSelected.length > 0 && posterList.length > 0"
										class="d-flex justify-center"
										style="position: absolute; z-index:1; top: -40px; right: 0, bottom:0; width: auto; min-width:260%; max-height:100%;transform: scale(0.38); margin-left: -768px"
									>
										<v-row style="height: 570px">
											<v-col cols="12" style="padding: 0px 40px; max-height: 100%;">
												<div style="overflow: hidden auto; max-height: 100vh; background-color:#00000070;">
													<v-carousel v-model="posterPage[index]" height="100%" hide-delimiters  next-icon="mdi-arrow-right-circle" prev-icon="mdi-arrow-left-circle">
														<v-carousel-item
															v-for="page in Math.ceil(entityEdit.dataMap.posterSelected.length/4)"
															:key="page"
														>
															<v-row class="d-flex justify-center mx-0;" style="postion: absolute">
																<v-col cols="3" class="my-4"  v-for="(poster, idxPoster) in getPosterSelectedList(entityEdit.dataMap.posterSelected, page)" :key="idxPoster" >
																		<v-card style="background-color: #00000000;">
																			<v-card-title class="justify-center">
																				<span class="headline" style="color: white">{{ poster.name }}</span>
																			</v-card-title>
																			<v-card-text>
																				<div
																					style="margin: 10px; width: 555px; margin: auto; border-top-left-radius: 12px; border-top-right-radius: 12px; padding: 5px"
																					:style="{ backgroundColor: poster.backgroundColor }"
																				>
																					<v-row v-for="(item, index) in poster.posterDataList" :key="index" style="margin: 5px; padding: 0px">
																						<v-col v-for="(item1, index1) in item" :key="index1" :cols="12 / item.length" style="padding: 1px">
																							<v-btn
																								v-if="item1.type == 'URL FIELD'"
																								width="100%"
																								:color="item1.backgroundColor"
																								:style="{ color: item1.fontColor }"
																							>
																								{{ item1.label }}
																							</v-btn>
																							<v-btn
																								v-else-if="item1.type == 'FILE DOWNLOAD'"
																								width="100%"
																								:color="item1.backgroundColor"
																								:style="{ color: item1.fontColor }"
																							>
																								{{ item1.label }}
																								<v-icon :color="item1.iconColor" medium>mdi-download</v-icon>
																							</v-btn>
																							<div
																								v-else-if="item1.type == 'TEXT'"
																								v-html="item1.value"
																								:style="{
																									backgroundColor: item1.backgroundColor,
																									border: '1px solid ' + item1.backgroundColor
																								}"
																								style="border: 1px solid black; padding: 10px 10px 0px 10px"
																							></div>
																							<v-carousel v-else-if="item1.type == 'GALLERY'" hide-delimiters height="368">
																								<v-carousel-item
																									v-for="(image, idxImage) in item1.images"
																									class="galley_poster"
																									:key="idxImage"
																									:src="$root.asset(image)"
																									reverse-transition="fade"
																									transition="fade"
																								>
																								</v-carousel-item>
																							</v-carousel>
																							<iframe
																								v-else-if="item1.type == 'VIDEO'"
																								id="video_poster"
																								:src="$root.asset(item1.value + (item1.value.includes('youtube') ? '&mute=1' : '&muted=1'))"
																								frameborder="0"
																								allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'"
																								scrolling="0"
																								width="100%"
																								height="300px"
																							>
																							<!-- add src above with mute/muted to mute video from poster -->
																							</iframe>
																						</v-col>
																					</v-row>
																				</div>
																			</v-card-text>
																		</v-card>
																</v-col>
															</v-row>
														</v-carousel-item>
													</v-carousel>
												</div>
											</v-col>
										</v-row>
									</div>
									<div
										v-if="newLinkTo.width && newLinkTo.height && newLinkTo.posX && newLinkTo.posY"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 3,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											position: 'absolute',
											pointerEvents: 'none',
											border: newLinkTo.border
										}"
									></div>
									<div v-if="resize.status">
										<div v-for="(point, index) in resize.points" :key="index">
											<div
												:style="{
													zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 3,
													width: '10px',
													height: '10px',
													top: point.y +'px',
													left: point.x + 'px',
													transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
													position: 'absolute',
													pointerEvents: 'none',
													border: '1px solid black',
													backgroundColor: '#BDBDBD',
												}"
											></div>
										</div>
									</div>
									<img
										v-if="newLinkTo.type === 'Image' && newLinkTo.value != null && newLinkTo.width && newLinkTo.height && newLinkTo.posX && newLinkTo.posY"
										:src="backgroundType === 'Upload' ? newLinkTo.previewImage : $root.asset(newLinkTo.value)"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 1,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											objectFit: newLinkTo.type === 'Image' ? $root.setBackgroundSize(newLinkTo.subType) : 'auto',
											objectPosition: newLinkTo.type === 'Image' ? $root.setBackgroundPosition(newLinkTo) : 'center center',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											position: 'absolute',
											pointerEvents: 'none'
										}"
										draggable="false"
									/>
									<iframe
										v-else-if="newLinkTo.type === 'Video' && newLinkTo.value != null && newLinkTo.width && newLinkTo.height && newLinkTo.posX && newLinkTo.posY"
										:src="backgroundType === 'Upload' ? newLinkTo.previewVideo : $root.asset(newLinkTo.value)"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 1,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											position: 'absolute',
											pointerEvents: 'none'
										}"
										frameborder="0"
										allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
										scrolling="0"
									>
									</iframe>
									<div
										v-else-if="newLinkTo.type === 'Text' && newLinkTo.value != null && newLinkTo.width && newLinkTo.height && newLinkTo.posX && newLinkTo.posY"
										class= "hotspot_text"
										v-html="newLinkTo.value"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 2,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											position: 'absolute',
											backgroundColor: newLinkTo.backgroundColor,
											borderStyle: newLinkTo.borderWidth === 'none' ? newLinkTo.borderWidth : 'solid',
											borderWidth: newLinkTo.borderWidth,
											borderColor: newLinkTo.borderColor,
											padding: (newLinkTo.padding ? newLinkTo.padding : '0') + 'px',
											pointerEvents: 'none'
										}"
									></div>
									<div
										v-else-if="newLinkTo.type === 'Embed_HTML' && newLinkTo.target === 'Embed'"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 1,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											position: 'absolute',
											overflow: 'hidden',
											pointerEvents: 'none'
										}"
										v-append="newLinkTo.valueRender ? newLinkTo.valueRender : newLinkTo.value"
									></div>

									<div
										v-else-if="newLinkTo.type === 'Private_Chat'"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 1,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											position: 'absolute',
											overflow: 'hidden',
											pointerEvents: 'none'
										}"
									>
											<iframe
												:src="$vchaturl + '/frontend/?e='  + $store.state.principal.chatEventToken +
													'&r=' + this.newLinkTo.chatRoom +
													'&u=' + $store.state.principal.chatUserToken"
												style="height:100%; width: 100%"
												allow="camera; microphone;"
											></iframe>
									</div>

									<div
										v-else-if="newLinkTo.type === 'Training_Clinic_Admin' && newLinkTo.target === 'Embed'"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 1,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											position: 'absolute',
											overflow: 'hidden',
											pointerEvents: 'none'
										}"
									>
											<iframe
												:src="$vtrainingurl + '/account/manage-employees/?guid=' + vTrainingUserGUID +'&view=manage-employees'"
												style="height:100%; width: 100%"
												allow="camera; microphone;"
											></iframe>
									</div>

									<v-btn
										v-else-if="(newLinkTo.type === 'Button' || newLinkTo.type === 'Back_Button') && !newLinkTo.backgroundImage"
										class="hotspot_btn hotspot_btn_custom"
										absolute
										:color="newLinkTo.backgroundColor"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 2,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											textTransform: 'none',
											borderStyle: newLinkTo.borderWidth === 'none' ? newLinkTo.borderWidth : 'solid',
											borderRadius: newLinkTo.borderRadius + 'px',
											borderWidth: newLinkTo.borderWidth + 'px',
											borderColor: newLinkTo.borderColor,
											pointerEvents: 'none'
										}"
									>
										<div v-html="newLinkTo.css ? (newLinkTo.value + '<style scoped>' + newLinkTo.css + '</style>') : newLinkTo.value"></div>
									</v-btn>
									<v-btn
										v-else-if="(newLinkTo.type === 'Button' || newLinkTo.type === 'Back_Button') && newLinkTo.backgroundImage"
										class="hotspot_btn hotspot_btn_custom"
										absolute
										:style="{
											backgroundImage: 'url(' + newLinkTo.backgroundImage + ')',
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1: 2,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											textTransform: 'none',
											borderStyle: newLinkTo.borderWidth === 'none' ? newLinkTo.borderWidth : 'solid',
											borderRadius: newLinkTo.borderRadius + 'px',
											borderWidth: newLinkTo.borderWidth + 'px',
											borderColor: newLinkTo.borderColor,
											pointerEvents: 'none'
										}"
									>
										<div v-html="newLinkTo.css ? (newLinkTo.value + '<style scoped>' + newLinkTo.css + '</style>') : newLinkTo.value"></div>
									</v-btn>
									<router-link
										v-else
										class="room-link"
										to="#"
										:style="{
											zIndex: layerMode == true ? entityEdit.linkToDataList.length + 1 : 3,
											backgroundColor: 'rgba(245, 229, 27, .5)',
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											pointerEvents: 'none'
										}"
									></router-link>
								</div>
							</v-card>
						</div>
						<div class="ma-1" style="width: 300px; min-width: 300px">
							<v-card id="linkTo">
								<v-card-text style="max-height: 550px; overflow-y: auto">
									<v-form ref="linkToForm">
									<v-row>
										<v-col cols="12" class="mb-3">
											<v-select v-model="newLinkTo.type" :items="linkTypes" label="Link Type" @change="changeItem" dense outlined hide-details="">
												<template v-slot:selection="{ item }">
													<span>{{ $root.convertLinkTypeLabel(item) }}</span>
												</template>
												<template v-slot:item="{ item }">
													<div class="d-block pa-2" style="max-width: 300px">
														<div>
															<span><strong>{{ $root.convertLinkTypeLabel(item) }}</strong></span>
														</div>
														<div>
															<span style="font-size: 12px;">{{ linkTypeDescriptions[item] }}</span>
														</div>
													</div>
												</template>
											</v-select>
											<v-text-field v-if="newLinkTo.type" v-model="newLinkTo.label" label="Label" hide-details=""></v-text-field>
										</v-col>
										<v-col cols="12" class="my-n4">
											<template v-if="newLinkTo.type === 'Structure'">
												<v-select v-model="newLinkTo.value" :items="entityList.filter((item) => item.id != entityEdit.id)" item-text="name" item-value="id" label="Value" dense outlined></v-select>
											</template>
											<template v-else-if="newLinkTo.type === 'Booth'">
												<v-select v-model="newLinkTo.value" :items="booths" item-text="name" item-value="id" label="Value" dense outlined @change="setBoothAttribute(newLinkTo.value)"></v-select>
												<v-text-field class="d-none" v-model="newLinkTo.name"></v-text-field>
												<v-text-field class="d-none" v-model="newLinkTo.logo"></v-text-field>
											</template>
											<v-select v-else-if="newLinkTo.type === 'Auditorium'" v-model="newLinkTo.value" :items="auditoriums" item-text="name" item-value="id" label="Value" dense outlined></v-select>
											<template v-else-if="newLinkTo.type === 'Track'">
												<v-select v-model="newLinkTo.subType" :items="auditoriums" item-text="name" item-value="id" label="Auditorium" dense outlined @change="listTrack"></v-select>
												<v-select v-model="newLinkTo.value" :items="tracks" item-text="name" item-value="id" label="Value" dense outlined></v-select>
											</template>
											<template v-else-if="newLinkTo.type === 'Dialog'">
												<editor1 api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="initEditor" v-model="newLinkTo.value" />
												<br />
												<span>Background Color</span>
												<v-color-picker class="mt-2 mb-3" v-model="newLinkTo.backgroundColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
											</template>
											<template v-else-if="newLinkTo.type === 'Presentation'">
												<v-select v-model="newLinkTo.value" :items="presentationScheduleList" item-text="presentation.title" item-value="id" label="Value" chips dense outlined multiple>
													<template v-slot:selection="{ item }">
														<v-sheet class="d-flex flex-row ma-1 px-2 align-center rounded-pill primary" dark>
															<span>{{ item.presentation.title }}</span>
															<v-spacer></v-spacer>
															<v-btn icon @click="selectEditPresentation(item)">
																<v-icon>mdi-pencil</v-icon>
															</v-btn>
															<v-btn icon @click="selectDeletePresentationSchedule(item)">
																<v-icon>mdi-delete</v-icon>
															</v-btn>
														</v-sheet>
													</template>
												</v-select>

												<v-col cols="12" class="text-right">
													<v-btn color="primary" @click="dialogPresentation = true">Add Presentation</v-btn>
												</v-col>
												<br />
											</template>
											<template v-else-if="newLinkTo.type === 'Image_Slider'">
												<v-file-input v-model="attachments" accept="image/png, image/jpeg, image/jpg, application/pdf" multiple show-size label="Choose image or pdf files"></v-file-input>
												<v-carousel v-if="newLinkTo.images.length > 0" hide-delimiters class="mb-6" height="250">
													<v-carousel-item v-for="(item, index) in newLinkTo.images" :key="index" :src="!item.endsWith('.pdf') ? $root.asset(item) : $root.asset(item).replace('.pdf', '.jpg')" reverse-transition="fade" transition="fade">
														<v-btn class="ma-2" color="error" fab small @click="newLinkTo.images.splice(index, 1)">
															<v-icon>mdi-delete</v-icon>
														</v-btn>
													</v-carousel-item>
												</v-carousel>
												<span>Background Color</span>
												<v-color-picker class="mt-2 mb-3" v-model="newLinkTo.backgroundColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
											</template>
											<template v-else-if="newLinkTo.type === 'Image'">
												<v-select v-model="backgroundType" :items="['Library', 'Upload', 'URL']" :label="newLinkTo.type + ' Type'" @change="(newLinkTo.previewImage = null), (newLinkTo.value = null)"></v-select>
												<input type="file" ref="attachment" accept="image/png, image/jpeg, image/jpg" style="display: none" @change="previewImage" required />
												<v-row v-if="backgroundType === 'Library'">
													<v-col>
														<v-autocomplete v-if="backgroundType === 'Library'" v-model="frameTagFilter" :items="frameTagList" chips small-chips deletable-chips label="Filter by tags" multiple solo dense></v-autocomplete>
													</v-col>
													<div style="display: flex; flex-direction: row; margin-top: 13px">
														<v-btn color="primary" style="margin-right: 10px" @click="filterFrameLibrary">filter</v-btn>
														<v-btn color="primary" @click="resetFrameLibraryFilter">Reset</v-btn>
													</div>
												</v-row>
												<v-select
													v-if="backgroundType === 'Library'"
													v-model="newLinkTo.value"
													:items="frameList"
													item-text="name"
													item-value="file"
													label="Select frame from library"
													@input="newLinkTo.value = `${newLinkTo.value}`"
												></v-select>
												<v-text-field
													class="mb-2"
													v-else-if="backgroundType === 'Upload'"
													v-model="newLinkTo.value"
													:label="newLinkTo.type"
													hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB."
													:placeholder="'Upload ' + newLinkTo.type"
													@click="$refs.attachment.click()"
												></v-text-field>
												<v-text-field v-else v-model="newLinkTo.value" :label="newLinkTo.type" :placeholder="newLinkTo.type + ' URL'"></v-text-field>
												<v-select v-model="newLinkTo.subType" :items="['Stretch', 'Contain', 'Cover']" label="Background Size" dense outlined></v-select>
												<div v-if="newLinkTo.subType === 'Cover'">
													<v-select v-model="newLinkTo.subPosX" :items="['Left', 'Center', 'Right']" label="Cover Position X" dense outlined></v-select>
													<v-select v-model="newLinkTo.subPosY" :items="['Top', 'Center', 'Bottom']" label="Cover Position Y" dense outlined></v-select>
												</div>
											</template>
											<template v-else-if="newLinkTo.type === 'Video'">
												<v-select v-model="backgroundType" :items="['Upload', 'URL']" :label="newLinkTo.type + ' Type'" @change="(newLinkTo.previewImage = null), (newLinkTo.value = null)"></v-select>
												<input type="file" ref="attachment" id="file-video" accept="video/mp4" style="display: none" @change="previewVideo" required />
												<v-text-field
													class="mb-2"
													v-if="backgroundType === 'Upload'"
													v-model="newLinkTo.value"
													:label="newLinkTo.type"
													hint="it's recommended to use video with resolution of 1080 pixels."
													:placeholder="'Upload ' + newLinkTo.type"
													@click="$refs.attachment.click()"
												></v-text-field>
												<v-text-field v-else v-model="newLinkTo.value" :label="newLinkTo.type" @change="newLinkTo.value = $root.parseVideoUrl(newLinkTo.value, newLinkTo.autoplay)" :placeholder="newLinkTo.type + ' URL'"></v-text-field>
												<v-checkbox
													v-if="backgroundType != 'Upload'"
													v-model="newLinkTo.autoplay"
													:label="`Autoplay: ` + (newLinkTo.autoplay ? 'On' : 'Off')"
													style="margin-top: 0px"
													@change="newLinkTo.value = $root.parseVideoUrl(newLinkTo.value, newLinkTo.autoplay)"
												></v-checkbox>
												<v-checkbox
													v-if="backgroundType != 'Upload'"
													v-model="newLinkTo.sound"
													:label="`Sound: ` + (newLinkTo.sound ? 'On' : 'Off')"
													style="margin-top: 0px"
													@change="newLinkTo.value = $root.parseVideoUrl(newLinkTo.value, newLinkTo.autoplay, newLinkTo.sound)"
												></v-checkbox>
											</template>
											<template v-else-if="newLinkTo.type === 'Embed_HTML'">
												<v-select v-model="newLinkTo.target" :items="['Dialog', 'Embed']" label="Target" dense outlined></v-select>
												<v-textarea v-model="newLinkTo.value" class="mb-2" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Embed HTML is required']" label="Embed HTML" outlined dense hide-details=""></v-textarea>
												<span>Variables that can be used : {{embedHtmlVariable}}</span>
												<br><br>
												<span>Background Color</span>
												<v-color-picker class="mt-2 mb-3" v-model="newLinkTo.backgroundColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
											</template>
											<template v-else-if="newLinkTo.type === 'Zoom'">
												<v-select v-model="newLinkTo.target" :items="['Dialog', 'Embed']" label="Target" dense outlined></v-select>
												<v-textarea v-model="newLinkTo.value" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Zoom URL is required']" label="Zoom URL" outlined dense hide-details=""></v-textarea>
												<v-checkbox	v-model="newLinkTo.disablePreview" label="Skip the join meeting screen"></v-checkbox>
											</template>
											<template v-else-if="newLinkTo.type === 'Teams'">
												<v-select v-model="newLinkTo.target" :items="['Dialog', 'Embed']" label="Target" dense outlined></v-select>
												<v-textarea v-model="newLinkTo.value" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Teams URL is required']" label="Teams URL" outlined dense></v-textarea>
											</template>
											<template v-else-if="newLinkTo.type === 'Training'">
												<v-select v-model="newLinkTo.target" :items="['Dialog', 'Embed']" label="Target" dense outlined></v-select>
												<v-select v-model="newLinkTo.categories" :items="trainingCategoryList" item-text="categoryName" item-value="categoryId" label="Category" multiple dense outlined></v-select>
												<v-checkbox class="pt-0 mt-0" v-model="trainingUseDefaultButton" label="Use the default button"></v-checkbox>
												<div v-if="!trainingUseDefaultButton" class="mb-7" >
													<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="initTextEditor" v-model="newLinkTo.value" style="background-color: #eee"/>
													<br />
													<v-select
														v-model="newLinkTo.backgroundType"
														:items="['Color', 'Upload']"
														label="Type"
														@change="changeBackground()"
													></v-select>
													<span >Background</span>
													<input
														v-if="newLinkTo.backgroundType == 'Upload'"
														ref="attachment7"
														type="file"
														accept="image/png, image/jpeg, image/jpg, video/mp4"
														@change="onBackgroundUploadForButtonLibrary"
														style="display: none"
													/>
													<v-text-field
														v-if="newLinkTo.backgroundType == 'Upload'"
														v-model="buttonLibraryBackgroundFileName"
														placeholder="Upload Background"
														prepend-icon="mdi-image"
														@click="openButtonBackgroundDialog()"
														readonly
													>
													</v-text-field>
													<v-color-picker  v-else-if="newLinkTo.backgroundType == 'Color'" class="mt-2" v-model="newLinkTo.backgroundColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
													<v-text-field v-model="newLinkTo.borderRadius" label="Border radius" type="number" hide-details style="margin-bottom: 20px" @keyup="refreshDrawing"></v-text-field>
													<v-text-field v-model="newLinkTo.borderWidth" label="Border Width" type="number" hide-details style="margin-bottom: 20px"></v-text-field>
													<span>Border Color</span>
													<v-color-picker class="mt-2" v-model="newLinkTo.borderColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
												</div>
											</template>
											<template v-else-if="newLinkTo.type === 'Completed_Training'">
												<v-select v-model="newLinkTo.target" :items="['Dialog', 'Embed']" label="Target" dense outlined></v-select>
											</template>
											<template v-else-if="newLinkTo.type === 'Text'">
												<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="initTextEditor" v-model="newLinkTo.value" />
												<br />
												<v-text-field v-model="newLinkTo.padding" label="Padding" dense outlined></v-text-field>
												<span>Background Color</span>
												<v-color-picker class="mt-2" v-model="newLinkTo.backgroundColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
												<v-select v-model="newLinkTo.borderWidth" label="Border" :items="['thick', 'medium', 'thin', 'none']" outlined dense></v-select>
												<span>Border Color</span>
												<v-color-picker class="mt-2 mb-3" v-model="newLinkTo.borderColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
											</template>
											<template v-else-if="newLinkTo.type === 'Button' || newLinkTo.type === 'Back_Button'">
												<v-btn color="primary" style="margin-bottom: 20px;text-transform: none" @click="showButtonLibrary">Button Library</v-btn>
												<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="initTextEditor" v-model="newLinkTo.value" style="background-color: #eee"/>
												<br />
												<v-select
													v-model="newLinkTo.backgroundType"
													:items="['Color', 'Upload']"
													label="Type"
													@change="changeBackground()"
												></v-select>
												<span >Background</span>
												<input
													v-if="newLinkTo.backgroundType == 'Upload'"
													ref="attachment7"
													type="file"
													accept="image/png, image/jpeg, image/jpg, video/mp4"
													@change="onBackgroundUploadForButtonLibrary"
													style="display: none"
												/>
												<v-text-field
													v-if="newLinkTo.backgroundType == 'Upload'"
													v-model="buttonLibraryBackgroundFileName"
													placeholder="Upload Background"
													prepend-icon="mdi-image"
													@click="openButtonBackgroundDialog()"
													readonly
												>
												</v-text-field>
												<v-color-picker  v-else class="mt-2" v-model="newLinkTo.backgroundColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
												<v-text-field v-model="newLinkTo.borderRadius" label="Border radius" type="number" hide-details style="margin-bottom: 20px" @keyup="refreshDrawing"></v-text-field>
												<v-text-field v-model="newLinkTo.borderWidth" label="Border Width" type="number" hide-details style="margin-bottom: 20px"></v-text-field>
												<span>Border Color</span>
												<v-color-picker class="mt-2" v-model="newLinkTo.borderColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
												<v-textarea
													v-model="newLinkTo.css"
													outlined
													label="CSS"
													value=""
													:placeholder="placeholderCss"
													@blur="refreshDrawing"
												></v-textarea>
											</template>
											<template v-if="newLinkTo.type === 'File_Download'">
												<input
													ref="attachment1"
													type="file"
													accept="*/*"
													@change="onFileDownloadChange" style="display: none" />
												<v-text-field
													v-model="newLinkTo.value"
													:label="newLinkTo.type.replace('_', ' ')"
													hint="Upload using recommended extension listed in upload window"
													placeholder="Upload File"
													prepend-icon="mdi-file"
													@click="$refs.attachment1.click()"
													readonly
													:rules="[(v) => !!v || 'File is Required']"
												>
												</v-text-field>
												<v-select
													v-model="newLinkTo.subType"
													:items="fileDownloadTypeList"
													:label="newLinkTo.type.replace('_', ' ') + ' Type'"
													item-text="label"
													item-value="value"
													:rules="[(v) => !!v || newLinkTo.type.replace('_', ' ') + ' Type is required']"
													required
												></v-select>
												<br/>
											</template>
											<v-text-field
												v-else-if="newLinkTo.type === 'URL'"
												v-model="newLinkTo.value"
												label="Value"
												dense
												outlined
											></v-text-field>
											<template v-else-if="newLinkTo.type === 'Product'">
												<v-btn class="mb-6" color="primary" block @click="checkEditLinkToProduct()">Edit Product List</v-btn>
												<v-dialog v-model="product.dialog" persistent max-width="70%">
													<v-card>
														<v-card-title class="headline">
															Product List
															<v-spacer></v-spacer>
															<v-btn icon @click="product.dialog = false">
																<v-icon>mdi-close</v-icon>
															</v-btn>
														</v-card-title>

														<v-card-text>
															<v-simple-table>
																<template v-slot:top>
																	<v-toolbar flat color="white">
																		<v-spacer></v-spacer>
																		<v-btn color="primary" dark class="mb-2" @click="addNewProduct()">Add New Product</v-btn>
																	</v-toolbar>
																</template>
																<template v-slot:default>
																	<thead>
																		<tr>
																			<th class="text-left" style="width: 24%">Name</th>
																			<th class="text-left" style="width: 24%">Description</th>
																			<th class="text-left" style="width: 24%">Image</th>
																			<th class="text-left" style="width: 24%">URL Link</th>
																			<th class="text-left">Actions</th>
																		</tr>
																	</thead>
																	<tbody>
																		<tr v-for="(item, index) in product.listProduct" :key="index">
																			<td class="longtext">
																				{{ item.name }}
																			</td>
																			<td class="longtext">
																				{{ item.description }}
																			</td>
																			<td class="longtext">
																				{{ item.image }}
																			</td>
																			<td class="longtext">
																				{{ item.urlLink }}
																			</td>
																			<td>
																				<v-icon small class="mr-2" title="Edit" @click="chooseEditProduct(item.index)">mdi-pencil</v-icon>
																				<v-icon small title="Delete" @click="deleteProduct(item)">mdi-delete</v-icon>
																			</td>
																		</tr>
																	</tbody>
																</template>
															</v-simple-table>
														</v-card-text>
													</v-card>
												</v-dialog>

												<v-dialog v-model="product.addDialog" persistent max-width="500px">
													<v-form
														ref="formAddProduct"
														v-model="product.validAddProduct"
														@submit.prevent="
															product.addDialog = false;
															addProduct();
														"
													>
														<v-card>
															<v-card-title>New Product</v-card-title>
															<v-card-text>
																<v-row class="d-flex">
																	<v-col cols="12">
																		<v-text-field v-model="product.newProduct.name" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Name is required']" label="Name" outlined dense></v-text-field>
																	</v-col>
																	<v-col cols="12">
																		<v-textarea v-model="product.newProduct.description" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Description is required']" label="Description" outlined dense></v-textarea>
																	</v-col>
																	<v-col cols="3">
																		<v-select v-model="product.imageType" :items="['URL', 'Upload']" label="Image Type"></v-select>
																	</v-col>
																	<v-col cols="9">
																		<v-text-field v-if="product.imageType === 'URL'" v-model="product.newProduct.image" label="Image URL" outlined dense></v-text-field>
																		<v-file-input
																			v-else
																			v-model="product.attachment"
																			label="Image"
																			accept="image/png, image/jpeg, image/jpg"
																			hint="It’s recommended to use image approximately 125 x 125 pixels, under 500KB"
																			placeholder="Upload Image"
																			prepend-icon="mdi-image"
																			:show-size="1000"
																		>
																			<template v-slot:selection="{ text }" :default="product.newProduct.image">
																				<v-chip color="primary" dark label small>{{ text }}</v-chip>
																			</template>
																		</v-file-input>
																	</v-col>
																	<v-col cols="12">
																		<v-text-field v-model="product.newProduct.urlLink" label="URL Link" outlined dense hide-details=""></v-text-field>
																	</v-col>
																	<v-col cols="12">
																		<v-text-field v-model="product.newProduct.buttonName" label="Button Name" outlined dense></v-text-field>
																	</v-col>
																</v-row>
															</v-card-text>
															<v-card-actions>
																<v-spacer></v-spacer>
																<v-btn color="mr-2" text @click="closeAddProduct()">Cancel</v-btn>
																<v-btn color="primary" type="submit" text :disabled="!product.validAddProduct">Save</v-btn>
															</v-card-actions>
														</v-card>
													</v-form>
												</v-dialog>

												<v-dialog v-model="product.editDialog" persistent max-width="500px">
													<v-form
														ref="formEditProduct"
														v-model="product.validEditProduct"
														@submit.prevent="
															product.editDialog = false;
															editProduct(product.newProduct.index);
														"
													>
														<v-card>
															<v-card-title>Edit Product</v-card-title>
															<v-card-text>
																<v-row class="d-flex">
																	<v-col cols="12">
																		<v-text-field v-model="product.newProduct.name" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Name is required']" label="Name" outlined dense></v-text-field>
																	</v-col>
																	<v-col cols="12">
																		<v-textarea v-model="product.newProduct.description" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Description is required']" label="Description" outlined dense></v-textarea>
																	</v-col>
																	<v-col cols="3">
																		<v-select v-model="product.imageType" :items="['URL', 'Upload']" label="Image Type"></v-select>
																	</v-col>
																	<v-col cols="9">
																		<v-text-field v-if="product.imageType === 'URL'" v-model="product.newProduct.image" label="Image URL" outlined dense></v-text-field>
																		<v-file-input
																			v-else
																			v-model="product.attachment"
																			label="Image"
																			accept="image/png, image/jpeg, image/jpg"
																			hint="It’s recommended to use image approximately 125 x 125 pixels, under 500KB"
																			placeholder="Upload Image"
																			prepend-icon="mdi-image"
																			:show-size="1000"
																		>
																			<template v-slot:selection="{ text }" :default="product.newProduct.image">
																				<v-chip color="primary" dark label small>{{ text }}</v-chip>
																			</template>
																		</v-file-input>
																	</v-col>
																	<v-col cols="12">
																		<v-text-field v-model="product.newProduct.urlLink" label="URL Link" outlined dense hide-details=""></v-text-field>
																	</v-col>
																	<v-col cols="12">
																		<v-text-field v-model="product.newProduct.buttonName" label="Button Name" outlined dense></v-text-field>
																	</v-col>
																</v-row>
															</v-card-text>
															<v-card-actions>
																<v-spacer></v-spacer>
																<v-btn color="mr-2" text @click="closeEditProduct()">Cancel</v-btn>
																<v-btn color="primary" type="submit" :disabled="!product.validEditProduct" text>Save</v-btn>
															</v-card-actions>
														</v-card>
													</v-form>
												</v-dialog>
											</template>
										</v-col>
										<v-col cols="12" class="my-n4" v-if="newLinkTo.type === 'URL'">
											<v-select v-model="newLinkTo.target" :items="['Dialog', 'Current Tab', 'New Tab']" label="Target" dense outlined></v-select>
										</v-col>
										<v-col cols="12" class="my-n4" v-if="newLinkTo.type === 'Book_Consultation'">
											<v-text-field v-model="newLinkTo.email" label="Email" dense outlined></v-text-field>
											<v-text-field v-model="newLinkTo.title" label="Title" dense outlined></v-text-field>
											<v-text-field v-model="newLinkTo.name" label="Button Label" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" class="my-n4" v-if="newLinkTo.type === 'Book_Aesthetic_Record_Meeting'">
											<v-text-field v-model="newLinkTo.value" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Booking URL is required']" label="Aesthetic Record Booking Url" dense outlined></v-text-field>
											<v-select v-model="newLinkTo.target" :items="entityList" item-text="name" item-value="id" label="Room" dense outlined :rules="[v => !!v || 'Room is required']"></v-select>
										</v-col>
										<v-col cols="12" class="my-n4" v-if="newLinkTo.target === 'Dialog' && (newLinkTo.type === 'Embed_HTML' || newLinkTo.type === 'URL')">
											<v-text-field v-model="newLinkTo.title" label="Title" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" class="my-n4" v-if="newLinkTo.type === 'Private_Chat'">
											<v-select v-model="newLinkTo.privateShowType" :items="showType" item-text="showType" item-value="showType" label="Options" dense outlined :rules="[v => !!v || 'Show Option is required']"></v-select>
											<v-select v-model="newLinkTo.privateChatRoom" :items="listPrivateRoom" item-text="name" item-value="guid" label="Chat Room" dense outlined :rules="[v => !!v || 'Chat Room is required']"></v-select>
										</v-col>
										<v-col cols="12" class="my-n3 pb-8" v-if="newLinkTo.type === 'Chat'">
											<div class="pb-4">Value Field :</div>
											<input type='checkbox' @click='checkAll(newLinkTo)' v-model='newLinkTo.isCheckAll'> Check All
											<ul style="list-style-type:none;">
												<li v-for="(item, index) in roomlist" :key="index">
													<input type='checkbox' v-bind:value='item.guid' v-model='newLinkTo.rooms' @change='updateCheckall(newLinkTo)'> {{ item.name }}
												</li>
											</ul>

											<hr size=1 class="mt-6">
										</v-col>

										<v-col cols="12" class="my-n4" v-if="newLinkTo.type === 'Training_Clinic_Admin'">
											<v-select v-model="newLinkTo.target" :items="['Dialog', 'Embed']" item-text="name" label="Target" dense outlined :rules="[v => !!v || 'Target is required']"></v-select>
										</v-col>

										<template v-else-if="newLinkTo.type === 'Embed_HTML'">
												<v-select v-model="newLinkTo.target" :items="['Dialog', 'Embed']" label="Target" dense outlined></v-select>
												<v-textarea v-model="newLinkTo.value" class="mb-2" :rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Embed HTML is required']" label="Embed HTML" outlined dense hide-details=""></v-textarea>
												<span>Variables that can be used : {{embedHtmlVariable}}</span>
												<br><br>
												<span>Background Color</span>
												<v-color-picker class="mt-2 mb-3" v-model="newLinkTo.backgroundColor" mode="rgba" width="400" hide-mode-switch></v-color-picker>
											</template>

										<v-col cols="12" sm="12" class="my-n4">
											<v-checkbox v-if="newLinkTo.type" class="pt-0 mt-0" v-model="newLinkTo.tooltip.show" label="Use Tooltip"></v-checkbox>
											<div v-if="newLinkTo.tooltip.show" class="mb-7" style="border: 1px solid grey; border-radius: 5px">
												<v-textarea class="pl-3 pr-3" v-model="newLinkTo.tooltip.value" label="Tooltip" ></v-textarea>
												<span class="ml-3">Font Color</span>
												<v-color-picker class="pa-3" v-model="newLinkTo.tooltip.fontColor" mode="rgba" width="235" hide-mode-switch></v-color-picker>
												<span class="ml-3">Background Color</span>
												<v-color-picker class="pa-3" v-model="newLinkTo.tooltip.backgroundColor" mode="rgba" width="235" hide-mode-switch></v-color-picker>
											</div>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.posX" label="X" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.posY" label="Y" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.width" label="Width" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.height" label="Height" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.skewX" label="Skew X" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.skewY" label="Skew Y" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" class="text-right">
											<v-btn
												color="primary"
												@click="
													addLinkTo(entityEdit);
													isEditLinkTo = false;
												"
												>{{ isEditLinkTo ? "Edit" : "Add" }}</v-btn
											>
										</v-col>
									</v-row>
									</v-form>
								</v-card-text>
							</v-card>
						</div>
					</div>
					<v-form class="ma-1" ref="formLinkTo" v-model="validLinkTo" @submit.prevent="editStructureLinkTo">
						<v-card>
							<v-card-text>
								<v-simple-table>
									<template v-slot:default>
										<thead>
											<tr>
												<th v-if="layerMode == true" style="width: 10%"><v-icon>mdi-drag-variant</v-icon></th>
												<th style="width: 10%">NO</th>
												<th style="width: 20%">TYPE</th>
												<th style="width: 50%">VALUE</th>
												<th style="width: 20%">POSITION</th>
												<th style="width: 10%">ACTION</th>
											</tr>
										</thead>
										<draggable tag="tbody" v-model="entityEdit.linkToDataList" :disabled="layerMode == true ? false : true">
											<tr v-for="(item, index) in entityEdit.linkToDataList" :key="index" class="dragndrop">
												<td v-if="layerMode == true"><v-icon>mdi-drag-vertical</v-icon></td>
												<td>{{ index + 1 }}</td>
												<td>
													{{ $root.convertLinkTypeLabel(item.type) }}
												</td>
												<td class="text-truncate" style="max-width: 150px">
													{{ modifyLinkValue(item) }}
												</td>
												<td>
													<v-row>{{ "W : " + item.width + "% H : " + item.height + "%" }}</v-row>
													<v-row>{{ "X : " + item.posX + "% Y : " + item.posY + "%" }}</v-row>
													<v-row>{{ "Skew X : " + (item.skewX ? item.skewX : "0") + " deg" }}</v-row>
													<v-row>{{ "Skew Y : " + (item.skewY ? item.skewY : "0") + " deg" }}</v-row>
												</td>
												<td>
													<v-btn @click="editLinkTo(entityEdit, item.id)" color="primary" icon>
														<v-icon>mdi-pencil</v-icon>
													</v-btn>
													<v-btn @click="duplicateLinkTo(entityEdit, item)" color="primary" icon>
														<v-icon>mdi-content-duplicate</v-icon>
													</v-btn>
													<v-btn v-if="['Image', 'Video', 'Text', 'Button'].includes(item.type)" @click="addLinkToWizard(item)" color="primary" icon>
														<v-icon>mdi-link-plus</v-icon>
													</v-btn>
													<v-btn @click="deleteLinkTo(entityEdit, item.id)" color="red" icon>
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</td>
											</tr>
										</draggable>
									</template>
								</v-simple-table>
							</v-card-text>
							<v-card-actions class="d-flex justify-end">
								<v-btn @click="closeLinkTo()" text depressed tile>Close</v-btn>
								<v-btn :disabled="!validLinkTo" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogPresentation" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Add Presentation
					<v-spacer></v-spacer>
					<v-btn icon @click="closePresentation()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" class="my-n4">
							Presentation
							<v-text-field v-model="selectedTitle" label="Title" dense outlined></v-text-field>
							<v-text-field v-model="selectedDescription" label="Description" dense outlined></v-text-field>
							<v-select v-model="selectedType" :items="['On-Demand Video', 'Pre-recorded Video', 'Zoom Webinar', 'Zoom Meeting', 'Vimeo Live', 'Teams Meeting']" label="Type" dense outlined></v-select>
							<v-select v-if="selectedType && (selectedType == 'Zoom Webinar' || selectedType == 'Zoom Meeting' || selectedType == 'Teams Meeting')" v-model="selectedTarget" :items="['New Tab', 'Dialog']" label="Target" dense outlined></v-select>
							<v-text-field v-if="selectedType && (selectedType == 'On-Demand Video' || selectedType == 'Pre-recorded Video')" v-model="videoUrl" label="Video URL" dense outlined></v-text-field>
							<v-text-field v-if="selectedType && (selectedType == 'Zoom Webinar' || selectedType == 'Zoom Meeting')" v-model="zoomUrl" label="Zoom URL" dense outlined hide-details=""></v-text-field>
							<v-checkbox v-if="selectedType && (selectedType == 'Zoom Webinar' || selectedType == 'Zoom Meeting')" v-model="zoomDisablePreview" label="Skip the join meeting screen"></v-checkbox>
							<v-text-field v-if="selectedType && selectedType == 'Vimeo Live'" v-model="videoIframe" label="Vimeo Live Iframe" dense outlined></v-text-field>
							<v-text-field v-if="selectedType && (selectedType == 'Teams Meeting')" v-model="zoomUrl" label="Teams URL" dense outlined></v-text-field>
							Schedule
							<br />
							<br />
							<v-menu ref="startDate" v-model="isShowStartDate" :close-on-content-click="false" :return-value.sync="startDate" transition="scale-transition" offset-y max-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="Start Date"
										:rules="[(v) => !!v || 'Start Date is required']"
										prepend-icon="mdi-calendar-clock"
										v-bind="attrs"
										v-on="on"
										dense
										autocomplete="off"
										:value="formatDateTime(startDate)"
										@click="resetTime"
									></v-text-field>
								</template>
								<v-date-picker v-model="startDate" @input="startDate = changeDatetime(startDate)" color="primary" no-title>
									<div class="d-flex flex-column" style="width: 100%">
										<div class="d-flex flex-row align-space-arround">
											<span>Time</span>
											<v-select
												v-model="hour"
												:items="
													Array(24)
														.fill()
														.map((x, i) => ('' + i).padStart(2, '0'))
												"
												class="mx-2"
												style="width: 10px"
												dense
												append-icon="false"
												@input="startDate = changeDatetime(startDate)"
											>
												<template v-slot:selection="{ item }">
													<span class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
												</template> </v-select
											>:
											<v-select
												v-model="minute"
												:items="
													Array(60)
														.fill()
														.map((x, i) => ('' + i).padStart(2, '0'))
												"
												class="mx-2"
												style="width: 10px"
												dense
												append-icon="false"
												@input="startDate = changeDatetime(startDate)"
											>
												<template v-slot:selection="{ item }">
													<span class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
												</template>
											</v-select>
										</div>
										<v-divider></v-divider>
										<div class="d-flex justify-end">
											<v-btn text color="primary" @click="$refs.startDate.save((startDate = changeDatetime(startDate)))">OK</v-btn>
										</div>
									</div>
								</v-date-picker>
							</v-menu>

							<v-menu ref="endDate" v-model="isShowEndDate" :close-on-content-click="false" :return-value.sync="endDate" transition="scale-transition" offset-y max-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="End Date"
										:rules="[(v) => !!v || 'End Date is required']"
										prepend-icon="mdi-calendar-clock"
										v-bind="attrs"
										v-on="on"
										dense
										autocomplete="off"
										:value="formatDateTime(endDate)"
										@click="resetTime"
									></v-text-field>
								</template>
								<v-date-picker v-model="endDate" @input="endDate = changeDatetime(endDate)" color="primary" no-title>
									<div class="d-flex flex-column" style="width: 100%">
										<div class="d-flex flex-row align-space-arround">
											<span>Time</span>
											<v-select
												v-model="hour"
												:items="
													Array(24)
														.fill()
														.map((x, i) => ('' + i).padStart(2, '0'))
												"
												class="mx-2"
												style="width: 10px"
												dense
												append-icon="false"
												@input="endDate = changeDatetime(endDate)"
											>
												<template v-slot:selection="{ item }">
													<span class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
												</template> </v-select
											>:
											<v-select
												v-model="minute"
												:items="
													Array(60)
														.fill()
														.map((x, i) => ('' + i).padStart(2, '0'))
												"
												class="mx-2"
												style="width: 10px"
												dense
												append-icon="false"
												@input="endDate = changeDatetime(endDate)"
											>
												<template v-slot:selection="{ item }">
													<span class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
												</template>
											</v-select>
										</div>
										<v-divider></v-divider>
										<div class="d-flex justify-end">
											<v-btn text color="primary" @click="isShowEndDate = false">Cancel</v-btn>
											<v-btn text color="primary" @click="$refs.endDate.save((endDate = changeDatetime(endDate)))">OK</v-btn>
										</div>
									</div>
								</v-date-picker>
							</v-menu>
							<v-autocomplete v-model="selectedTimezone" :items="timezoneList" hide-selected label="Timezone" required></v-autocomplete>
							<div>
								<br />Selected Presenter:
								<br />
								<span v-for="(person, index) in presenterClinicList" :key="index">
									{{ person.firstName != null ? person.firstName : "" }}
									{{ person.lastName != null ? person.lastName : "" }}
									{{ person.title != null ? person.title : "" }}
									<v-btn icon @click.prevent="removePresenterClinic(person.id)">
										<span>&#10005;</span>
									</v-btn>
									<br />
								</span>
								<br />
							</div>
							Presenter 1
							<v-file-input
								accept="image/png, image/jpeg, image/jpg"
								@change="handleFile1Upload"
								hint="It’s recommended to use image with resolution approximately 200 x 200 pixels and recommended size is under 500KB"
								show-size
								counter
								multiple
								:label="'Presenter Picture'"
								ref="file1Upload"
							></v-file-input>
							<v-text-field v-model="selectedFirstName1" label="First Name" dense outlined></v-text-field>
							<v-text-field v-model="selectedLastName1" label="Last Name" dense outlined></v-text-field>
							<v-text-field v-model="selectedTitle1" label="Title" dense outlined></v-text-field>
							<v-textarea v-model="selectedBio1" label="Biography" dense outlined></v-textarea>Presenter 2
							<v-file-input
								accept="image/png, image/jpeg, image/jpg"
								@change="handleFile2Upload"
								hint="It’s recommended to use image with resolution approximately 200 x 200 pixels and recommended size is under 500KB"
								show-size
								counter
								multiple
								:label="'Presenter Picture'"
								ref="file2Upload"
							></v-file-input>
							<v-text-field v-model="selectedFirstName2" label="First Name" dense outlined></v-text-field>
							<v-text-field v-model="selectedLastName2" label="Last Name" dense outlined></v-text-field>
							<v-text-field v-model="selectedTitle2" label="Title" dense outlined></v-text-field>
							<v-textarea v-model="selectedBio2" label="Biography" dense outlined></v-textarea>Presenter 3
							<v-file-input
								accept="image/png, image/jpeg, image/jpg"
								@change="handleFile3Upload"
								hint="It’s recommended to use image with resolution approximately 200 x 200 pixels and recommended size is under 500KB"
								show-size
								counter
								multiple
								:label="'Presenter Picture'"
								ref="file3Upload"
							></v-file-input>
							<v-text-field v-model="selectedFirstName3" label="First Name" dense outlined></v-text-field>
							<v-text-field v-model="selectedLastName3" label="Last Name" dense outlined></v-text-field>
							<v-text-field v-model="selectedTitle3" label="Title" dense outlined></v-text-field>
							<v-textarea v-model="selectedBio3" label="Biography" dense outlined></v-textarea>
							<div>
								Uploaded Handout:
								<br />
								<span v-for="(handout, index) in handoutList" :key="index">
									{{ handout.title }}
									<v-btn icon @click.prevent="removeHandout(handout.id)">
										<span>&#10005;</span>
									</v-btn>
									<br />
								</span>
							</div>
							Handout 1
							<v-file-input
								accept="application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, .rar, image/jpg, image/jpeg, image/png, video/mp4"
								@change="handleFile4Upload"
								show-size
								counter
								multiple
								:label="'Handout 1'"
								ref="file4Upload"
							></v-file-input
							>Handout 2
							<v-file-input
								accept="application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, .rar, image/jpg, image/jpeg, image/png, video/mp4"
								@change="handleFile5Upload"
								show-size
								counter
								multiple
								:label="'Handout 2'"
								ref="file5Upload"
							></v-file-input
							>Handout 3
							<v-file-input
								accept="application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, .rar, image/jpg, image/jpeg, image/png, video/mp4"
								@change="handleFile6Upload"
								show-size
								counter
								multiple
								:label="'Handout 3'"
								ref="file6Upload"
							></v-file-input>
							<br>
							Embed HTML
							<v-combobox
								v-model="selectEmbedHtmlBeside.status"
								:items="itemEmbedHtmlBeside"
								label="Embed Html Beside"
							></v-combobox>
							<v-text-field
								v-model="heightEmbedHtmlBeside"
								label="Height Embed Html Beside"
								type="number"
							></v-text-field>
							<v-textarea v-model="selectEmbedHtmlBeside.value" :disabled="selectEmbedHtmlBeside.status == 'None'" dense></v-textarea>

							<v-text-field
								v-model="heightEmbedHtmlBelow"
								label="Height Embed Html Below"
								type="number"
								style="margin-top: 30px"
							></v-text-field>
							<v-textarea v-model="selectEmbedHtmlBelow" label="Embed HTML Below" dense></v-textarea>
						</v-col>
						<v-col cols="12" class="text-right">
							<v-btn
								v-if="dialogEditPresentation == false"
								color="primary"
								@click="
									addPresentation();
									closePresentation();
								"
								>Add</v-btn
							>
							<v-btn
								v-if="dialogEditPresentation == true"
								color="primary"
								@click="
									editPresentation();
									closePresentation();
								"
								>Save</v-btn
							>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
		<!-- Delete Presentation Schedule -->
		<v-dialog v-model="dialogDeletePresentationSchedule" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete Presentation Schedule</span>
				</v-card-title>
				<v-card-text>Are you sure to delete this presentation schedule ?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click.prevent="dialogDeletePresentationSchedule = false">Cancel</v-btn>
					<v-btn
						color="blue darken-1"
						text
						@click.prevent="
							dialogDeletePresentationSchedule = false;
							deletePresentationSchedule(selectedPresentationScheduleId);
						"
						>Delete</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Booth Order -->
		<v-dialog v-model="dialogBoothOrder" max-width="600px">
			<v-data-iterator :items="boothSelecteds" :items-per-page="100" hide-default-footer >
				<template v-slot:header>
					<v-toolbar color="#416d74" height="56" dark flat>
						<v-toolbar-title>Booth List</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon @click="closeBoothOrder()">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar>
				</template>
				<template v-slot:default="props">
					<v-list dense style="background-color: #00000080">
						<div v-for="(item, index) in props.items" :key="index" >
							<v-list-item v-if="item.boothBackground.type == 'Color'" dark v-bind:style="{backgroundColor: item.boothBackground.color}">
								<v-list-item-content>
									<v-row>
										<v-col>
											<span>{{ item.name}}</span>
										</v-col>
										<v-col lg="1">
											<v-icon @click="showDialogCustomBackground(index, item.boothBackground)">mdi-select-color</v-icon>
										</v-col>
									</v-row>
								</v-list-item-content>
								<v-list-item-action>
									<v-btn icon @click="movePosition(boothSelecteds, index, index - 1)">
										<v-icon>mdi-chevron-up</v-icon>
									</v-btn>
									<v-btn icon @click="movePosition(boothSelecteds, index, index + 1)">
										<v-icon>mdi-chevron-down</v-icon>
									</v-btn>
								</v-list-item-action>
							</v-list-item>
							<v-list-item v-else dark v-bind:style="{backgroundImage: 'url(' + item.boothBackground.image + ')'}">
								<v-list-item-content>
									<v-row>
										<v-col>
											<span>{{ item.name}}</span>
										</v-col>
										<v-col lg="1">
											<v-icon @click="showDialogCustomBackground(index, item.boothBackground)">mdi-select-color</v-icon>
										</v-col>
									</v-row>
								</v-list-item-content>
								<v-list-item-action>
									<v-btn icon @click="movePosition(boothSelecteds, index, index - 1)">
										<v-icon>mdi-chevron-up</v-icon>
									</v-btn>
									<v-btn icon @click="movePosition(boothSelecteds, index, index + 1)">
										<v-icon>mdi-chevron-down</v-icon>
									</v-btn>
								</v-list-item-action>
							</v-list-item>
							<v-divider></v-divider>
						</div>
					</v-list>
				</template>
			</v-data-iterator>
		</v-dialog>
			<!-- Poster Order -->
		<v-dialog v-model="dialogPosterOrder" max-width="600px">
			<v-data-iterator :items="posterSelecteds" :items-per-page="100" hide-default-footer >
				<template v-slot:header>
					<v-toolbar color="#416d74" height="56" dark flat>
						<v-toolbar-title>Poster List</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon @click="closePosterOrder()">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar>
				</template>
				<template v-slot:default="props">
					<v-list dense style="background-color: #00000080">
						<div v-for="(item, index) in props.items" :key="index" >
							<v-list-item dark>
								<v-list-item-content>
									<v-row>
										<v-col>
											<span>{{ item.name}}</span>
										</v-col>
									</v-row>
								</v-list-item-content>
								<v-list-item-action>
									<v-btn icon @click="movePositionForPoster(posterSelecteds, index, index - 1)">
										<v-icon>mdi-chevron-up</v-icon>
									</v-btn>
									<v-btn icon @click="movePositionForPoster(posterSelecteds, index, index + 1)">
										<v-icon>mdi-chevron-down</v-icon>
									</v-btn>
								</v-list-item-action>
							</v-list-item>
							<v-divider></v-divider>
						</div>
					</v-list>
				</template>
			</v-data-iterator>
		</v-dialog>

		<v-dialog v-model="dialogCustomBackground" style="margin-left: 600px" persistent width="600px">
			<v-card>
				<v-card-title>Custom Background</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="4">
							<v-select v-model="boothItem.type" :items="['Upload', 'Color']" label="Type"></v-select>
						</v-col>
						<v-col cols="12" sm="8" v-if="boothItem.type === 'Upload'">
							<v-file-input
									v-model="attachment4"
									accept="image/png, image/jpeg, image/jpg"
									label="Upload image"
									prepend-icon="mdi-image"
									hint="625x50 pixels image size is highly recommended"
							></v-file-input>
						</v-col>
						<v-col cols="12" sm="8" v-else>
							<v-text-field  @ v-model="boothItem.color" hide-details class="ma-0 pa-0" solo>
								<template v-slot:append v-if="boothItem.type === 'Color'">
									<v-menu v-model="boothItem.menu" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
										<template v-slot:activator="{ on }">
											<v-icon  v-on="on">mdi-palette</v-icon>
										</template>
										<v-card>
											<v-card-text class="pa-0">
												<v-color-picker v-model="boothItem.color" flat />
											</v-card-text>
										</v-card>
									</v-menu>
								</template>
							</v-text-field>
						</v-col>
					</v-row>
					<div class="d-flex justify-end">
						<v-btn color="primary" style="margin-right: 10px" @click="closeDialogCustomBackground(boothItem.index)"> cancel </v-btn>
						<v-btn color="primary"  @click="setDialogCustomBackground(boothItem.index)">OK</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!---Button Library-->
		<v-dialog v-model="dialogButtonLibrary" persistent no-click-animation fullscreen hide-overlay>
			<v-card>
				<v-card-title class="headline">
					Choose one of the button below
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogButtonLibrary = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>

				<br />
				<div class="d-flex flex-wrap justify-space-around align-stretch">
					<v-hover v-for="(entity, index) in buttonLibraryList" :key="index" v-slot:default="{ hover }">
						<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
							<div
								class="v-card__text pa-0"
								style="position: relative; height: 200px; max-height: 200px; overflow: auto; background-color: #bbb"
							>
								<div
									:style="{
										position: 'absolute',
										transformOrigin: 'top left',
										transform: entity.transform,
										margin: entity.margin
									}"
								>
									<v-btn
										v-if="entity.backgroundType === 'Color'"
										:class="'hotspot_btn button_library_' + entity.id"
										large
										:style="{
											backgroundColor: entity.background,
											borderRadius: entity.borderRadius + 'px',
											border: entity.borderWidth + 'px solid ' + entity.borderColor,
											width: entity.width + 'px',
											height: entity.height + 'px'
										}"
										@click="chooseButton(entity)"
									>
										<div v-html="entity.value + '<style scoped>' + entity.css.replace(/button_library/g, 'button_library_' + entity.id) + '</style>'" style="text-transform: none"></div>
									</v-btn>
									<v-btn
										v-else
										:class="'hotspot_btn button_library_' + entity.id"
										large
										:style="{
											backgroundImage: 'url(' + entity.background + ')',
											borderRadius: entity.borderRadius + 'px',
											border: entity.borderWidth + 'px solid ' + entity.borderColor,
											width: entity.width + 'px',
											height: entity.height + 'px'
										}"
										@click="chooseButton(entity)"
									>
										<div v-html="entity.value + '<style scoped>' + entity.css.replace(/button_library/g, 'button_library_' + entity.id) + '</style>'"></div>
									</v-btn>
								</div>
							</div>
						</v-card>
					</v-hover>
				</div>

			</v-card>
		</v-dialog>

	</div>
</template>
<style scoped>
#structure-view .entry-view {
	max-width: 100%;
	margin: 0 auto;
}
.entry-view {
	position: relative;
}
.room-link {
	cursor: pointer;
	position: absolute;
}
.longtext {
	max-width: 100px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.icon_vimeo_succes_upload {
	color: white;
	background-color: rgb(38, 185, 241);
	border-radius: 25px;
	width: 25px;
	height: 25px;
	padding-top: 4px;
	align-items: flex-start;
}
.icon_vimeo_progress_upload {
	color: #f00;
	align-items: flex-start;
}
</style>

<script>
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";
import draggable from "vuedraggable";

export default {
	props: ["experienceId"],
	components: {
		draggable,
		editor: Editor,
		editor1: Editor
	},
	data() {
		return {
			showType: ["Embed", "Link"],
			valid: true,
			validEdit: true,
			validLinkTo: true,
			dialogAdd: false,
			dialogEdit: false,
			dialogLinkTo: false,
			dialogRoomLibrary: false,
			dialogButtonLibrary: false,
			entity: {
				mainStructure: false,
				dataMap: {
					introTransition: {
						autoplay: true,
						sound: false
					},
					outroTransition: {
						autoplay: true,
						sound: false
					}
				},
				linkToDataList: [],
				status: false,
				errorMsg: "",
				selectedRoom: [],
			},
			entityEdit: {
				mainStructure: false,
				dataMap: {
					introTransition: {
						autoplay: true,
						sound: false
					},
					outroTransition: {
						autoplay: true,
						sound: false
					}
				},
				linkToDataList: [],
				status: false,
				transitMap: {
					videoUploadStatus: {
						Intro_Transition: "",
						Background: "asdfs",
						Outro_Transition: "",
						Banner_Rotating: "",
						Background_Login: ""
					}
				},
				erorrMsg: "",
				selectedRoom: [],
			},
			entityList: [],
			mainStructure: 1,
			linkTypes: [],
			booths: [],
			tracks: [],
			auditoriums: [],
			boothBackgroundType: "Upload",
			bannerRotatingVideoType: "Upload",
			backgroundType: "Upload",
			introTransitionType: "Upload",
			outroTransitionType: "Upload",
			backgroundLoginType: "Upload",
			newLinkTo: {
				posX: 0,
				posY: 0,
				width: 0,
				height: 0,
				value: null,
				borderWidth: "none",
				backgroundColor: "#FFFFFF00",
				borderColor: "#00000000",
				images: [],
				tooltip: {value: "", backgroundColor: "#000000FF", fontColor: "#FFFFFFFF", show: false},
				chatRoom: "",
				selectedRoom: [],
				privateChatRoom: "",
				privateShowType: "",
				rooms: [],
				roomsName: [],
				isCheckAll: false,
			},
			attachment1: null,
			attachment2: null,
			attachment3: null,
			x: null,
			y: null,
			baseLocation: axios.defaults.baseURL,
			product: {
				validForm: false,
				dialog: false,
				addDialog: false,
				validAddProduct: true,
				editDialog: false,
				validEditProduct: true,
				listProduct: [],
				newProduct: {},
				attachment: null,
				imageType: "URL"
			},
			roomLibraryList: { data: [], page: 1, size: 15, length: 0, total: 0 },
			isClinic: false,
			selectedTemplate: {},
			isEditLinkTo: false,
			initEditor: {
				height: 600,
				image_title: true,
				automatic_uploads: true,
				file_picker_types: "file image media",
				images_upload_credentials: false,
				image_dimensions: true,
				menubar: true,
				images_upload_handler: (blobInfo, success, failure) => {
					let formdata = new FormData();
					formdata.append("attachment1", blobInfo.blob());
					formdata.append("tenantId", this.$store.state.principal.tenantId);
					axios.post("/system/structure/tinymce/image/upload", formdata).then((res) => {
						if (res.data != null) {
							success(axios.defaults.baseURL + "/asset/file/" + res.data);
						} else {
							failure("upload failed!");
						}
					});
				},
				media_live_embeds: true,
				selector: "editor",
				plugins: ["code", "media", "image", "preview", "link"],
				toolbar: "code undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help |media |image |file |preview |link"
			},
			initTextEditor: {
				height: 300,
				menubar: false,
				plugins: ["advlist autolink lists link image charmap print preview anchor", "searchreplace visualblocks code fullscreen", "insertdatetime media table paste code help wordcount"],
				toolbar1: "undo redo | formatselect",
				toolbar2: "fontselect | fontsizeselect",
				toolbar3: "alignleft aligncenter alignright | bold italic underline | forecolor backcolor | link",
				fontsize_formats: '1pt 2pt 3pt 4pt 5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt'
			},
			initNotifEditor: {
				height: 200,
				menubar: false,
				plugins: "link",
				toolbar: "link",
				selector: "textarea"
			},

			entityPresentation: {
				presenterClinicList: []
			},
			entityPresentationSchedule: {
				dataMap: {}
			},
			timezoneList: [],
			selectedTimezone: null,
			videoUrl: null,
			videoIframe: null,
			zoomUrl: null,
			zoomDisablePreview: true,
			isShowStartDate: false,
			isShowEndDate: false,
			isShowStartTime: false,
			isShowEndTime: false,
			startDate: null,
			endDate: null,
			startTime: null,
			endTime: null,
			hour: null,
			minute: null,
			today: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
			selectedType: null,
			selectedTarget: null,
			selectedTitle: null,
			selectedDescription: null,
			dialogPresentation: false,
			attachment4: null,
			attachment5: null,
			attachment6: null,
			selectedFirstName1: null,
			selectedFirstName2: null,
			selectedFirstName3: null,
			selectedLastName1: null,
			selectedLastName2: null,
			selectedLastName3: null,
			selectedTitle1: null,
			selectedTitle2: null,
			selectedTitle3: null,
			selectedBio1: null,
			selectedBio2: null,
			selectedBio3: null,
			selectEmbedHtmlBeside: { status: "None", value: "" },
			selectEmbedHtmlBelow: "",
			heightEmbedHtmlBeside: null,
			heightEmbedHtmlBelow: null,
			presentationScheduleList: null,
			presenterClinicList: [],
			handoutList: [],
			dialogEditPresentation: false,
			selectedPresentationId: null,
			selectedPresentationScheduleId: null,
			dialogDeletePresentationSchedule: false,
			host: location.host,
			isExhibitionHall: false,
			isPosterRoom: false,
			isPasswordProtectRoom: false,
			passwordProtect: null,
			dialogBoothOrder: false,
			dialogPosterOrder: false,
			posterSelecteds: [],
			boothSelecteds: [],
			boothBackgroundList: [],
			selectedBoothBackground: null,
			frameList: [],
			ticketList: [],
			passwordFieldType: "password",
			draggingStatus: null,
			isMainStructure: false,
			backgroundFileName: "",
			downloadFileName: "",
			downloadFileNameOriginal: "",
			introTransitionFileName: "",
			outroTransitionFileName: "",
			backgroundImageName: "",
			introTransitionImageName: "",
			outroTransitionImageName: "",
			backgroundLoginFileName: "",
			backgroundLoginImageName: "",
			bannerRotatingVideoFileName: "",
			bannerRotatingVideoImageName: "",
			backgroundTemp: "",
			introTransitionTemp: "",
			outroTransitionTemp: "",
			backgroundLoginTemp: "",
			bannerRotatingVideoTemp: "",
			editBackgroundTemp: "",
			editIntroTransitionTemp: "",
			editOutroTransitionTemp: "",
			editBackgroundLoginTemp: "",
			editBannerRotatingVideoTemp: "",
			tagFilter: [],
			tagList: [],
			boothBackgroundTagFilter: [],
			boothBackgroundTagList: [],
			boothBackgroundAll: [],
			attachments: null,
			frameTagFilter: [],
			frameTagList: [],
			frameAll: [],
			slugList: [],
			entityEditOld: {},
			bookingTypes: [],
			bookingType: "Send_Email",
			dialogBackgroundTransition: false,
			backgroundTransitionList: [],
			backgroundTransitionAll: [],
			tagFilterTransition: [],
			tagListTransition: [],
			isAdd: false,
			isEdit: false,
			dialogCustomBackground: false,
			boothItem: {},
			boothItemDefault: {},
			customBackgroundDefault:{
				type: 'Color',
				color: '#00000000',
				image: '',
				menu: false,
			},
			resize: {
				status: false,
				indexActive: -1,
				points:[
					{x: 0, y: 0, cursor:'nw-resize'},
					{x: 0, y: 0, cursor:'n-resize'},
					{x: 0, y: 0, cursor:'ne-resize'},
					{x: 0, y: 0, cursor:'w-resize'},
					{x: 0, y: 0, cursor:'e-resize'},
					{x: 0, y: 0, cursor:'sw-resize'},
					{x: 0, y: 0, cursor:'s-resize'},
					{x: 0, y: 0, cursor:'se-resize'},
				]
			},
			isIntro: true,
			buttonLibraryList: null,
			buttonLibraryBackgroundFileName: "",
			placeholderCss: ".hotspot_btn_custom {\n\tcolor: blue !important;\n}",
			posterList: [],
			posterPage: [],
			fileDownloadTypeList: [
				{label: "Current Tab", value: "Current_Tab"},
				{label: "New Tab", value: "New_Tab"},
				{label: "Dialog", value: "Dialog"},
				{label: "Force Download", value: "Force_Download"}
			],
			experience: null,
			layerMode: false,
			linkTypeDescriptions: {
				Image: "Upload IMAGES or gifs in jpeg or png format",
				URL: "Add LINKS to websites, Vimeo or Youtube or any external links",
				Text: "Write TEXT in different fonts and colors",
				Structure: "Link a HOTSPOT to another specified room within your experience",
				Embed_HTML: "Utilize external CODE to embed forms, surveys, e-commerce stores and videos",
				File_Upload: "Add a button to a virtual space so visitors can UPLOAD FILES you want them to submit and these will appear in your tenant portal dashboard under files",
				Video: " VIDEO you add will appear within the hotspot dimensions you have created instead of inside a pop up frame",
				Dialog: "Add TEXT in a pop up when a hot spot is clicked.",
				Product: "Add PRODUCTS with images that will appear in a pop up in list format",
				Book_Consultation: "Add an EMAIL ADDRESS to a contact form to receive information.  This form is not customizable",
				Presentation: "Add multiple PRESENTATIONS to a meeting room to show date and countdown clock to host live, simulive or on demand presentations",
				Image_Slider: "Add MULTIPLE pdf's, images or photographs to a slider",
				Button: "Create a clickable BUTTON to add text to with the ability to customize fonts and colors",
				Zoom: "Embed a ZOOM MEETING link within dimensions of a hot spot or in a dialog pop up frame",
				Teams: "Embed a TEAMS MEETING link within dimensions of a hot spot or in a dialog pop up frame",
				Training: "training",
				Completed_Training: "Completed Training",
				Live_Support: "Create a hotspot button and link to open LIVE SUPPORT",
				File_Download: "Create a hotspot that enables you to add files that when clicked are downloadable",
				Book_Aesthetic_Record_Meeting: "You need to be an current user of AR software for these link types to be activated",
				Attend_Aesthetic_Record_Meeting: "You need to be an current user of AR software for these link types to be activated",
				Show_Aesthetic_Record_Meeting: "You need to be an current user of AR software for these link types to be activated",
				Leaderboard: "LINKS to your Leaderboard page",
				Booth: "add LINKS to access booth directly when a hot spot is clicked",
				Track: "add LINKS to access auditorium track directly when a hot spot is clicked",
				Auditorium: "add LINKS to access auditorium directly when a hot spot is clicked",
				Chat_Lounge: "LINKS to your Chat Lounge",
				Back_Button: "",
				Training_Clinic_Admin: "Add Training Clinic Admin to manage employees",
				Chat: "add specific chat room",
				Private_Chat: "Add a private group CHAT ROOM",
			},
			itemEmbedHtmlBeside: ['None','Left','Right'],
			rowsPerPage: [15, 30, 60],
			boothSelectMap: {},
			introTransitionYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			outroTransitionYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundLoginYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true, dnt: true},
			introTransitionVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true, dnt: true},
			outroTransitionVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true, dnt: true},
			backgroundLoginVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true, dnt: true},
			embedHtmlVariable:"{{user_email}}, {{user_first_name}}, {{user_last_name}}",
			trainingCategoryList: [],
			trainingUseDefaultButton: false,
			listPublicRoom: [],
			listPrivateRoom: [],
			roomlist: [],
			selectedRoom: [],
			vTrainingUserGUID: "",

			isCheckAll: false,
            rooms: [],
			roomsName: [],

			hideObjectId: "",
			uploadType: "CloudFront",
		};
	},
	computed: {
		color: {
			get() {
				return this["hex"];
			},
			set(v) {
				this["hex"] = v;
			}
		},
	},
	mounted() {
		this.getExperience();
		if (this.$store.state.principal.type == "Clinic") {
			this.isClinic = true;
			this.getClinicData();
		} else {
			this.isClinic = false;
		}

		this.listStructure();
		this.listLinkType();
		this.listBooth();
		this.listPoster();
		this.listAuditorium();
		this.listRoomLibrary();
		this.listTimezone();
		this.listPresentationSchedule();
		this.listBoothBackground();
		this.listFrameLibrary();
		this.listTicket();
		this.listTag();
		this.listTagTransition();
		this.listBackgroundTransitionLibrary();

		window.addEventListener("mouseup", this.stopDraw);

		this.$root.appendTinyMCECustomFonts(this.initTextEditor);
		this.appendFontHelveticaNeue67MediumCondensed(this.initEditor);

		this.listGeneralPublicRoom();
		this.listGeneralPrivateRoom();

		this.listAllRoom();

	},
	methods: {
		checkAll(el){
			el.isCheckAll = !el.isCheckAll;
			el.rooms = [];
			el.roomsName = [];
			if(el.isCheckAll){ // Check all
				for (var key in this.roomlist) {
					el.rooms.push(this.roomlist[key].guid);
					el.roomsName.push(this.roomlist[key].name);
				}
			}
		},
		updateCheckall(el){

			if (el != undefined) {
				if (this.roomlist != null) {

					if (el.rooms != null) {

						if(el.rooms.length == this.roomlist.length){
							el.isCheckAll = true;
						} else{
							el.isCheckAll = false;
						}

						el.roomsName = [];
						let roms = this.roomlist.filter(r => el.rooms.includes(r.guid) );
						roms.forEach(e => el.roomsName.push(e.name));
					} else {

						if (this.rooms != null) {

							if(this.rooms.length == this.roomlist.length){
								el.isCheckAll = true;
							} else{
								el.isCheckAll = false;
							}

							el.roomsName = [];
							let roms = this.roomlist.filter(r => this.rooms.includes(r.guid) );
							roms.forEach(e => el.roomsName.push(e.name));

						}
					}
				}
			}
		},
		appendFontHelveticaNeue67MediumCondensed(initEditor) {
			initEditor.content_style =
			`	@font-face{
					font-family:"helvetica-neue-67-medium-condensed";
					src: local("Helvetica_Neue_67_Medium_Condensed"), url("/fonts/Helvetica_Neue_67_Medium_Condensed.ttf") format("truetype");
				}

				@font-face {
			  	font-family: "abril fatface";
			  	src: local("AbrilFatface-Regular"), url("/fonts/AbrilFatface-Regular.ttf") format("truetype");
				}

				@font-face {
			  	font-family: "sacramento";
			  	src: local("Sacramento-Regular"), url("/fonts/Sacramento-Regular.ttf") format("truetype");
				}

				@font-face {
			  	font-family: "dm sans";
			  	src: local("DMSans-Regular"), url("/fonts/DMSans-Regular.ttf") format("truetype");
				}

			`;
			initEditor.font_formats = "Abril Fatface=abril fatface;" +
				"Andale Mono=andale mono,times;" +
				"Arial=arial,helvetica,sans-serif;" +
				"Arial Black=arial black,avant garde;" +
				"Book Antiqua=book antiqua,palatino;" +
				//"Comic Neue=comic neue;" +
				"Comic Sans MS=comic sans ms,sans-serif;"+
				"Courier New=courier new,courier;" +
				"DM Sans=dm sans;" +
				"Georgia=georgia,palatino;" +
				//"Inter=inter;" +
				"Helvetica=helvetica;"+
				"Helvetica Neue 67 Medium Condensed=helvetica-neue-67-medium-condensed;" +
				//"Oswald=oswald;" +
				"Impact=impact,chicago;"+
				//"Greek=greek;" +
				"Sacramento=sacramento;" +
				"Symbol=symbol;"+
				"Tahoma=tahoma,arial,helvetica,sans-serif;" +
				"Terminal=terminal,monaco;" +
				"Times New Roman=times new roman,times;" +
				//"Allerta=allerta;" +
				"Trebuchet MS=trebuchet ms,geneva;"+
				"Verdana=verdana,geneva;" +
				//"Fredoka One=fredoka one;" +
				"Webdings=webdings;"+
				//"Xingy Dings=xingy dings;"
				"Wingdings=wingdings,zapf dingbats"
		},
		getClinicData() {
			axios
				.post("/system/clinic/data", {
					experienceId: this.experienceId
				})
				.then(response => {
					this.entity = response.data;
					this.$root.selectedExperience = response.data.selectedExperience;

					if (!this.entity.dataMap.introTransition) {
						this.entity.dataMap.introTransition = {
							autoplay: true,
							sound: false
						}
					}
					if (!this.entity.dataMap.outroTransition) {
						this.entity.dataMap.outroTransition = {
							autoplay: true,
							sound: false
						}
					}
				})
				.catch(() => {});
		},
		getExperience() {
			axios
				.post("/system/experience", {
					id: this.experienceId
				})
				.then((response) => {
					this.experience = response.data;
					this.layerMode = this.experience.layerMode;
				})
				.catch(() => {});
		},
		listBoothBackground() {
			axios
				.post("/system/boothbackgroundlibrary/membership/list", {
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then((response) => {
					this.boothBackgroundList = response.data;
					// Check if small asset is exist and use it
					let vm = this;
					this.boothBackgroundList.map(obj => {
						vm.$root.isImageExist(vm.$root.smallAsset(obj.background), function(status) {
							if (status) {
								obj.background = vm.$root.smallAsset(obj.background)
							}
						});
						return obj;
					});
					this.boothBackgroundAll = this.boothBackgroundList;
				});
		},
		selectBoothBackground(item) {
			this.selectedBoothBackground = item.id;
		},
		listLinkType() {
			axios.get("/system/enumeration/linktype/list").then((response) => {
				if (this.isClinic) {
					this.linkTypes = response.data.filter((item) => {
						return [
							"Attend_Consultation", 
							"Auditorium", 
							"Booth", 
							"Chat_Lounge", 
							"Leaderboard", 
							"Track",
							"Chat",
							"Book_Aesthetic_Record_Meeting",
							"Attend_Aesthetic_Record_Meeting",
							"Show_Aesthetic_Record_Meeting",
							"Training",
							"Completed_Training",
							"Training_Clinic_Admin",
							"Private_Chat"
						].indexOf(item) === -1;
					});
				} else {
					this.linkTypes = response.data.filter((item) => {
						return [
							"Attend_Consultation", 
							"Presentation", 
							"Product", 
							"Book_Aesthetic_Record_Meeting", 
							"Attend_Aesthetic_Record_Meeting", 
							"Show_Aesthetic_Record_Meeting"
						].indexOf(item) === -1;
					});
				}
			});
		},
		listBookingType() {
			axios.get("/system/enumeration/booking/type/list").then((response) => {
				this.bookingTypes = response.data;
			});
		},
		listBooth() {
			axios.get("/system/booth/list?experienceId=" + this.experienceId).then((response) => {
				this.booths = response.data;
			});
		},
		listPoster() {
			axios.get("/system/poster/find?&experienceId=" + this.experienceId).then((response) => {
				this.posterList = response.data;
			});
		},
		listTrack() {
			axios.get("/system/track/list?experienceId=" + this.experienceId + "&auditoriumId=" + this.newLinkTo.subType).then((response) => {
				this.tracks = response.data;
			});
		},
		listStructure() {
			axios.get("/system/structure/list?experienceId=" + this.experienceId).then((response) => {
				this.entityList = response.data;
				// Check if small asset is exist and use it
				let vm = this;
				this.entityList.map(obj => {
					vm.$root.isImageExist(vm.$root.smallAsset(obj.background), function(status) {
						if (status) {
							obj.background = vm.$root.smallAsset(obj.background)
						}
					});
					return obj;
				});
				this.listRoomSlug();

				this.$nextTick(() => {
					if (this.$vuetify.breakpoint.mobile){
						this.$root.playYoutube(this.$refs.backgroundIndexYoutube);
					}
				});
			});
		},
		listAllRoom() {
			axios.post("/system/vchat/room/group/list", { experienceId: this.experienceId }).then((response) => {
				this.roomlist = response.data;
			});
		},
		listGeneralPublicRoom() {
			axios.get("/system/generalPublicChatRoom/list?experienceId=" + this.experienceId).then((response) => {
				this.listPublicRoom = response.data;
			});
		},
		listGeneralPrivateRoom() {
			axios.get("/system/generalPrivateChatRoom/list?experienceId=" + this.experienceId).then((response) => {
				this.listPrivateRoom = response.data;
			});
		},
		modifyLinkValue(linkTo){
			if(linkTo.type === "Book_Consultation"){
				return linkTo.email;
			} else if(linkTo.type === "Training"){
				return "[]";
			} else {
				return linkTo.value ? linkTo.value : linkTo.images;
			}
		},
		listAuditorium() {
			axios.get("/system/auditorium/list?experienceId=" + this.experienceId).then((response) => {
				this.auditoriums = response.data;
			});
		},
		listRoomLibrary() {
			axios
				.post("/system/roomlibrary/list", {
					planFilter: [],
					tagFilter: this.tagFilter,
					tenantPlanId: this.$store.state.principal.tenantPlanId,
					page: this.roomLibraryList.page,
					size: this.roomLibraryList.size
				})
				.then((response) => {
					this.roomLibraryList = response.data;
					// Check if small asset is exist and use it
					let vm = this;
					this.roomLibraryList.data.map(obj => {
						vm.$root.isImageExist(vm.$root.smallAsset(obj.background), function(status) {
							if (status) {
								obj.background = vm.$root.smallAsset(obj.background)
							}
						});
						return obj;
					});
				});
		},
		listBackgroundTransitionLibrary() {
			axios
				.post("/system/transitionlibrary/membership/list", {
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then((response) => {
					this.backgroundTransitionList = response.data;
					this.backgroundTransitionAll = this.backgroundTransitionList;
				});
		},
		listTag() {
			axios.get("/system/roomlibrary/tag/list").then((response) => {
				this.tagList = response.data;
			});
		},
		listTagTransition() {
			axios.get("/system/transitionlibrary/tag/list").then((response) => {
				this.tagListTransition = response.data;
			});
		},
		resetRoomLibraryFilter() {
			this.planFilter = [];
			this.tagFilter = [];
			this.roomLibraryList.page = 1;
			this.roomLibraryList.size = 15;
			this.listRoomLibrary();
		},
		listFrameTag() {
			axios.get("/system/frame/tag/list").then((response) => {
				this.frameTagList = response.data;
			});
		},
		filterFrameLibrary() {
			axios
				.post("/system/frame/filter", {
					planFilter: [],
					tagFilter: this.frameTagFilter,
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then((response) => {
					this.frameList = response.data;
				});
		},
		resetFrameLibraryFilter() {
			this.framePlanFilter = [];
			this.frameTagFilter = [];
			this.frameList = this.frameAll;
		},
		listBoothBackgroundTag() {
			axios.get("/system/boothbackgroundlibrary/tag/list").then((response) => {
				this.boothBackgroundTagList = response.data;
			});
		},
		filterBoothBackground() {
			axios
				.post("/system/boothbackgroundlibrary/filter", {
					planFilter: [],
					tagFilter: this.boothBackgroundTagFilter,
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then((response) => {
					this.boothBackgroundList = response.data;
				});
		},
		resetBoothBackground() {
			this.boothBackgroundPlanFilter = [];
			this.boothBackgroundTagFilter = [];
			this.boothBackgroundList = this.boothBackgroundAll;
		},
		filterBackgroundTransition() {
			axios
				.post("/system/transitionlibrary/filter", {
					planFilter: [],
					tagFilter: this.tagFilterTransition,
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then((response) => {
					this.backgroundTransitionList = response.data;
				});
		},
		resetBackgroundTransitionFilter() {
			this.planFilter = [];
			this.tagFilter = [];
			this.backgroundTransitionList = this.backgroundTransitionAll;
		},
		listFrameLibrary() {
			axios
				.post("/system/frame/membership/list", {
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then((response) => {
					this.frameList = response.data;
					this.frameAll = this.frameList;
					this.listFrameTag();
				});
		},
		showAdd() {
			this.boothBackgroundType = "URL";
			this.bannerRotatingVideoType = "URL";
			this.backgroundType = "URL";
			this.introTransitionType = "URL";
			this.outroTransitionType = "URL";
			this.uploadType = "CloudFront";
			this.entity = Object.assign({}, this.selectedTemplate);
			this.entity.id = null;
			this.isMainStructure = false;
			this.entity.mainStructure = false;
			this.entity.dataMap = {
				introTransition: {
					autoplay: true,
					sound: false
				},
				outroTransition: {
					autoplay: true,
					sound: false
				}
			};
			this.dialogAdd = true;
			this.listBoothBackgroundTag();

			if (this.entity.status == null) {
				this.entity.status = true;
			}
			if (!this.entity.dataMap.introTransition) {
				this.entity.dataMap.introTransition = {
					autoplay: true,
					sound: false
				}
			}
			if (!this.entity.dataMap.outroTransition) {
				this.entity.dataMap.outroTransition = {
					autoplay: true,
					sound: false
				}
			}
		},
		showRoomLibrary() {
			this.dialogRoomLibrary = true;
		},
		showBackgroundTransitionLibrary() {
			this.dialogBackgroundTransition = true;
		},
		showEdit(item) {
			this.listBoothBackgroundTag();
			axios
				.get("/system/structure/find?id=" + item.id)
				.then((response) => {
					this.entityEdit = response.data;
					if (this.entityEdit.mainStructure) {
						this.isMainStructure = true;
					}
					if (this.entityEdit.background) {
						this.entityEdit.background = this.$root.reverseToOriginal(this.entityEdit.background);
					}
					if (this.entityEdit.dataMap.isExhibitionHall) {
						this.isExhibitionHall = true;
					}
					if (this.entityEdit.dataMap.isPosterRoom) {
						this.isPosterRoom = true;
					}
					if (this.entityEdit.dataMap.boothBackgroundId) {
						this.selectedBoothBackground = this.entityEdit.dataMap.boothBackgroundId;
					}
					if (this.entityEdit.dataMap.bannerRotatingVideo) {
						this.bannerRotatingVideoType = "URL";
					} else {
						this.bannerRotatingVideoType = "Upload";
					}
					if (this.entityEdit.background) {
						this.backgroundType = "URL";
					} else {
						this.backgroundType = "Upload";
					}
					if (this.entityEdit.introTransition) {
						this.introTransitionType = "URL";
					} else {
						this.introTransitionType = "Upload";
					}
					if (this.entityEdit.outroTransition) {
						this.outroTransitionType = "URL";
					} else {
						this.outroTransitionType = "Upload";
					}
					if (this.entityEdit.mainStructure && this.entityEdit.dataMap.backgroundLogin) {
						this.backgroundLoginType = "URL";
					} else {
						this.backgroundLoginType = "Upload";
					}
					if (this.entityEdit.dataMap.uploadType) {
						this.uploadType = this.entityEdit.dataMap.uploadType;
					}
					if (!this.entityEdit.dataMap.introTransition) {
						this.entityEdit.dataMap.introTransition = {
							autoplay: true,
							sound: false
						}
					}
					if (!this.entityEdit.dataMap.outroTransition) {
						this.entityEdit.dataMap.outroTransition = {
							autoplay: true,
							sound: false
						}
					}

					if (this.entityEdit.dataMap.isPasswordProtectRoom) {
						this.isPasswordProtectRoom = this.entityEdit.dataMap.isPasswordProtectRoom;
						this.passwordProtect = this.entityEdit.dataMap.passwordProtect;
					}
					this.entityEditOld = this.$root.clone(this.entityEdit);
					this.dialogEdit = true;
				})
				.catch(() => {});
		},
		showLinkTo(item) {
			this.entityEdit = item;
			for (let entity of this.entityEdit.linkToDataList) {
				if (entity.type === "Button") {
					if(isNaN(entity.borderRadius)) {
						entity.borderRadius = entity.borderRadius === "rounded" ? "28px" : "0px";
					}  else {
						entity.borderRadius = entity.borderRadius + 'px';
					}
					if (!isNaN(entity.borderWidth)) {
						entity.borderWidth = entity.borderWidth + 'px';
					}
				} else if (entity.type === "Video") {
					if (isNaN(entity.autoplay)) {
						entity.autoplay = true;
					}
				} else if (entity.type === "Chat") {
					if (entity.selectedChatRoom != null) {
						this.rooms = entity.selectedChatRoom;
						this.updateCheckall(entity);
					}
				}

				if (!entity.tooltip) {
					entity.tooltip = {value: "", backgroundColor: "#000000FF", fontColor: "#FFFFFFFF", show: false}
				}
			}
			this.dialogLinkTo = true;
		},
		closeAdd() {
			this.entity = {
				mainStructure: false,
				//consultationRoom: false,
				dataMap: {
					introTransition: {
						autoplay: true,
						sound: false
					},
					outroTransition: {
						autoplay: true,
						sound: false
					}
				},
				linkToDataList: [],
				status: false
			};
			this.dialogAdd = false;
			this.$refs.formAdd.reset();
			this.resetRoomLibraryFilter();
			this.resetBoothBackground();
		},
		closeEdit() {
			this.entityEdit = {
				mainStructure: false,
				//consultationRoom: false,
				dataMap: {
					introTransition: {
						autoplay: true,
						sound: false
					},
					outroTransition: {
						autoplay: true,
						sound: false
					}
				},
				linkToDataList: [],
				transitMap: {
					videoUploadStatus: {
						Intro_Transition: "",
						Background: "",
						Outro_Transition: "",
						Banner_Rotating: "",
						Background_Login: ""
					}
				}
			};
			this.entityEditOld = {};
			this.newLinkTo = {
				posX: 0,
				posY: 0,
				width: 0,
				height: 0,
				value: null,
				css: "",
				autoplay: true,
				borderWidth: "none",
				backgroundColor: "#FFFFFF00",
				borderColor: "#00000000",
				backgroundType: "Color",
				images: [],
				border: "1px solid #76FF03",
				tooltip: {value: "", backgroundColor: "#000000FF", fontColor: "#FFFFFFFF", show: false}
			};
			this.dialogEdit = false;
			this.$refs.formEdit.reset();
			this.resetRoomLibraryFilter();
			this.resetBoothBackground();
		},
		closeLinkTo() {
			this.listStructure();
			this.entityEdit = {
				mainStructure: false,
				//consultationRoom: false,
				dataMap: {
					introTransition: {
						autoplay: true,
						sound: false
					},
					outroTransition: {
						autoplay: true,
						sound: false
					}
				},
				linkToDataList: [],
				transitMap: {
					videoUploadStatus: {
						Intro_Transition: "",
						Background: "",
						Outro_Transition: "",
						Banner_Rotating: "",
						Background_Login: ""
					}
				}
			};
			this.$refs.formLinkTo.reset();
			this.newLinkTo = {
				posX: 0,
				posY: 0,
				width: 0,
				height: 0,
				value: null,
				css: "",
				autoplay: true,
				borderWidth: "none",
				backgroundColor: "#FFFFFF00",
				borderColor: "#00000000",
				backgroundType: "Color",
				images: [],
				tooltip: {value: "", backgroundColor: "#000000FF", fontColor: "#FFFFFFFF", show: false}
			};
			this.dialogLinkTo = false;
			this.$refs.formLinkTo.reset();
			this.resetFrameLibraryFilter();
		},
		closeRoomLibrary() {
			this.dialogRoomLibrary = false;
			if (this.isAdd) {
				this.showAdd();
				this.isAdd = false;
			} else if (this.isEdit) {
				this.dialogEdit = true;
				this.isEdit = false;
			} else {
				this.resetRoomLibraryFilter();
				this.resetBoothBackground();
			}
		},
		closeBackgroundTransition() {
			this.dialogBackgroundTransition = false;
			if (this.isAdd) {
				this.showAdd();
				this.isAdd = false;
			} else if (this.isEdit) {
				this.dialogEdit = true;
				this.isEdit = false;
			} else {
				this.resetBackgroundTransitionFilter();
			}
		},
		closeAddProduct() {
			this.product.addDialog = false;
			this.product.newProduct = {buttonName: "VIEW FULL PRODUCT DETAILS"};
			this.resetForms();
		},
		closeEditProduct() {
			this.product.editDialog = false;
			this.product.newProduct = {buttonName: "VIEW FULL PRODUCT DETAILS"};
			this.resetForms();
		},
		async addLinkTo(entity) {
			if(this.$refs.linkToForm.validate()){

				if (this.isEditLinkTo) {
					document.getElementById(this.hideObjectId).style.display = "block";
					this.hideObjectId = "";
				}

				if (this.backgroundType === "Upload" && this.attachment1) {
					let formData = new FormData();
					formData.append("attachment1", this.attachment1);
					formData.append("experienceId", JSON.stringify(this.entityEdit.experienceId));
					formData.append("structureId", JSON.stringify(this.entityEdit.id));
					await axios.post("/system/structure/linkto/image", formData).then((response) => {
						this.newLinkTo.value = response.data;
						this.attachment1 = null;
					});
				}

				if (this.newLinkTo.type === "File_Download" && this.attachment1) {
					let formData = new FormData();
					formData.append("attachment1", this.attachment1);
					formData.append("experienceId", JSON.stringify(this.entityEdit.experienceId));
					formData.append("structureId", JSON.stringify(this.entityEdit.id));
					await axios.post("/system/structure/linkto/image", formData).then((response) => {
						this.newLinkTo.value = response.data;
						this.attachment1 = null;
					});
				}

				if (this.newLinkTo.type === "Image_Slider" && this.attachments) {
					for (let i = 0; i < this.attachments.length; i++) {
						let formData = new FormData();
						formData.append("attachment1", this.attachments[i]);
						formData.append("experienceId", JSON.stringify(this.entityEdit.experienceId));
						formData.append("structureId", JSON.stringify(this.entityEdit.id));
						await axios.post("/system/structure/linkto/image", formData).then((response) => {
							this.newLinkTo.images.push(response.data);
						});
					}
					this.attachments = null;
				}

				if (this.backgroundType === "Button" && this.attachment7) {
					let formData = new FormData();
					formData.append("attachment1", this.attachment7);
					formData.append("experienceId", JSON.stringify(this.entityEdit.experienceId));
					formData.append("structureId", JSON.stringify(this.entityEdit.id));
					await axios.post("/system/structure/linkto/image", formData).then((response) => {
						this.newLinkTo.backgroundImage = response.data;
						this.attachment7 = null;
					});
				}

				this.newLinkTo.id = this.newLinkTo.id ? this.newLinkTo.id : Date.now();
				if (this.newLinkTo.type && this.newLinkTo.posX && this.newLinkTo.posY && this.newLinkTo.width && this.newLinkTo.height) {
					if (this.newLinkTo.type === "Presentation") {
						this.newLinkTo.value = this.newLinkTo.value.join(",");
					} else if (this.newLinkTo.type === "Button") {
						this.newLinkTo.borderRadius = this.newLinkTo.borderRadius + "px";
						this.newLinkTo.borderWidth = this.newLinkTo.borderWidth + "px";
					} else if (this.newLinkTo.type === "Book_Consultation"){
						this.newLinkTo.bookingType = "Send_Email"
					} else if (this.newLinkTo.type === "URL"){
						this.newLinkTo.value = this.newLinkTo.value.trim();
					}

					let index = entity.linkToDataList.findIndex(item => item.id === this.newLinkTo.id);
					if (index >= 0) {
						entity.linkToDataList.splice(index, 1, this.newLinkTo);
					} else {
						this.layerMode == true ? entity.linkToDataList.unshift(this.newLinkTo) : entity.linkToDataList.push(this.newLinkTo);
					}

					this.newLinkTo = {
						posX: 0,
						posY: 0,
						width: 0,
						height: 0,
						value: null,
						css: "",
						autoplay: true,
						borderWidth: "none",
						backgroundColor: "#FFFFFF00",
						borderColor: "#00000000",
						backgroundType: "Color",
						images: [],
						tooltip: {value: "", backgroundColor: "#000000FF", fontColor: "#FFFFFFFF", show: false},
						chatRoom: "",
						privateChatRoom: "",
						selectedRoom: this.selectedRoom,
					};
					this.product.listProduct = [];
					this.$nextTick(() => {
						this.$refs.linkToForm.reset();
					});
				}
			}
		},
		duplicateLinkTo(entity, item) {
			let newItem = this.$root.clone(item);
			newItem.id = Date.now();
			this.layerMode == true ? entity.linkToDataList.unshift(newItem) : entity.linkToDataList.push(newItem);
		},
		editLinkTo(entity, id) {

			document.getElementById("linkTo").scrollIntoView({ behavior: "smooth" });

			document.getElementById(id).style.display = "none";
			this.hideObjectId = id;

			let list = entity.linkToDataList;
			for (let i in list) {
				if (list[i].id === id) {
					this.newLinkTo = this.$root.clone(list[i]);
					if (this.newLinkTo.type === "Presentation") {
						this.newLinkTo.value = this.newLinkTo.value.split(",").map(Number);
					} else if (["Image", "Video"].includes(this.newLinkTo.type)) {
						if (this.frameList.some((e) => e.file === this.newLinkTo.value)) {
							this.backgroundType = "Library";
						} else {
							this.backgroundType = "URL";
						}
					} else if (this.newLinkTo.type === "Button") {
						if (this.newLinkTo.backgroundColor != '') {
							this.newLinkTo.backgroundType = "Color";
						} else {
							this.newLinkTo.backgroundType = "Upload";
						}
						this.newLinkTo.borderRadius = this.newLinkTo.borderRadius.replace("px", "");
						this.newLinkTo.borderWidth = this.newLinkTo.borderWidth.replace("px", "");
						this.newLinkTo.backgroundColor = this.newLinkTo.backgroundColor.startsWith("#") && this.newLinkTo.backgroundColor.length < 8 ? this.newLinkTo.backgroundColor + "FF" : this.newLinkTo.backgroundColor;
						this.newLinkTo.borderColor =  this.newLinkTo.borderColor.startsWith("#") && this.newLinkTo.borderColor.length < 8 ? this.newLinkTo.borderColor + "FF" : this.newLinkTo.borderColor;
					} else if (this.newLinkTo.type === "Book_Consultation"){
						this.newLinkTo.bookingType = "Send_Email"
					} else if (this.newLinkTo.type === "Book_Aesthetic_Record_Meeting" && this.newLinkTo.target){
						// need to parse in order to display edit room
						this.newLinkTo.target = parseInt(this.newLinkTo.target);
					} else if (this.newLinkTo.type === "Training"){
						this.trainingUseDefaultButton = !this.newLinkTo.value;
						if (this.newLinkTo.backgroundColor != '') {
							this.newLinkTo.backgroundType = "Color";
						} else {
							this.newLinkTo.backgroundType = "Upload";
						}
						this.setTrainingCategory();
					} else if (this.newLinkTo.type == 'Zoom') {
						this.newLinkTo.disablePreview = this.newLinkTo.disablePreview == null ? true : this.newLinkTo.disablePreview;
					}

					this.isEditLinkTo = true;
					this.resize.status = false;
					return;
				}
			}
		},
		deleteLinkTo(entity, id) {
			let list = entity.linkToDataList;
			for (let i in list) {
				if (list[i].id === id) {
					list.splice(i, 1);
					return;
				}
			}
			this.resize.status = false;
		},
		deleteStructure(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/structure/delete", { id }).then(() => {
					this.listStructure();
				});
			}
		},
		addStructure() {
			this.entity.experienceId = this.experienceId;
			if (this.isMainStructure) {
				this.entity.mainStructure = true;
			}
			/*if (this.isConsultationRoom) {
				this.entity.consultationRoom = true;
			}*/
			if (this.isExhibitionHall) {
				this.entity.dataMap.isExhibitionHall = true;
				this.entity.dataMap.isPosterRoom = false;
				this.entity.dataMap.boothBackgroundId = this.selectedBoothBackground;
			} else if (this.isPosterRoom) {
				this.entity.dataMap.isExhibitionHall = false;
				this.entity.dataMap.isPosterRoom = true;
			}
			if (this.isPasswordProtectRoom) {
				this.entity.dataMap.isPasswordProtectRoom = true;
			}
			if (this.uploadType) {
				this.entity.dataMap.uploadType = this.uploadType;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entity));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}
			if (this.attachment4) {
				formData.append("attachment4", this.attachment4);
			}
			if (this.attachment5) {
				formData.append("attachment5", this.attachment5);
			}
			if (this.attachment6) {
				formData.append("attachment6", this.attachment6);
			}

			axios.post("/system/structure/add", formData).then(() => {
				this.listStructure();
				this.entity = {
					mainStructure: false,
					//consultationRoom: false,
					dataMap: {
						introTransition: {
							autoplay: true,
							sound: false
						},
						outroTransition: {
							autoplay: true,
							sound: false
						}
					},
					linkToDataList: [],
					status: true
				};
				this.$refs.formAdd.reset();
				this.closeRoomLibrary();
				this.dialogAdd = false;
				this.clearData();
			});
		},
		editStructure() {
			if (this.isMainStructure) {
				this.entityEdit.mainStructure = true;
			} else {
				this.entityEdit.dataMap.backgroundLogin = null;
			}
			/*if (this.isConsultationRoom) {
				this.entityEdit.consultationRoom = true;
			} else {
				this.entityEdit.consultationRoom = undefined;
			}*/
			if (this.isExhibitionHall) {
				this.entityEdit.dataMap.isExhibitionHall = true;
				this.entityEdit.dataMap.boothBackgroundId = this.selectedBoothBackground;
			} else {
				this.entityEdit.dataMap.isExhibitionHall = undefined;
				this.entityEdit.dataMap.boothBackground = undefined;
				this.entityEdit.dataMap.bannerRotatingVideo = undefined;
			}
			if (this.isPosterRoom) {
				this.entityEdit.dataMap.isPosterRoom = true;
			} else {
				this.entityEdit.dataMap.isPosterRoom = undefined;
			}
			if (this.isPasswordProtectRoom) {
				this.entityEdit.dataMap.isPasswordProtectRoom = true;
			} else {
				this.entityEdit.dataMap.isPasswordProtectRoom = false;
				this.entityEdit.dataMap.passwordProtect = undefined;
			}
			if (this.uploadType) {
				this.entityEdit.dataMap.uploadType = this.uploadType;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entityEdit));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}
			if (this.attachment4) {
				formData.append("attachment4", this.attachment4);
			}
			if (this.attachment5) {
				formData.append("attachment5", this.attachment5);
			}
			if (this.attachment6) {
				formData.append("attachment6", this.attachment6);
			}

			axios.post("/system/structure/edit", formData).then(() => {
				this.listStructure();
				this.entityEdit = {
					mainStructure: false,
					//consultationRoom: false,
					dataMap: {
						introTransition: {
							autoplay: true,
							sound: false
						},
						outroTransition: {
							autoplay: true,
							sound: false
						}
					},
					linkToDataList: [],
					transitMap: {
						videoUploadStatus: {
							Intro_Transition: "",
							Background: "",
							Outro_Transition: "",
							Banner_Rotating: "",
							Background_Login: ""
						}
					}
				};
				this.$refs.formEdit.reset();
				this.dialogEdit = false;
				this.clearData();
				location.reload();
			});
		},
		editStructureLinkTo() {

			let formData = new FormData();
			var vm = this;

			for (let entity of this.entityEdit.linkToDataList) {
				if (entity.type == 'Button') {
					entity.borderRadius = entity.borderRadius.replace("px", "");
					entity.borderWidth = entity.borderWidth.replace("px", "");
				} else if (entity.type == 'Training') {
					if (this.trainingUseDefaultButton) {
						entity.value = "";
						entity.backgroundColor = "#FFFFFF00";
						entity.borderColor = "#00000000";
						entity.borderWidth = "0";
						entity.borderRadius = "0";
					}
				} else if (entity.type == 'Chat') {
					entity.selectedChatRoom = vm.rooms;
				}
			}

			formData.append("entity", JSON.stringify(this.entityEdit));

			axios
				.post("/system/structure/edit/linkto", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					vm.closeLinkTo()
				});


		},
		setBoothAttribute(id) {
			this.newLinkTo.name = this.booths.find((item) => item.id == id).name;
			this.newLinkTo.logo = this.booths.find((item) => item.id == id).logo;
		},
		draw(event) {
			event.preventDefault();



			if (this.draggingStatus == 'draw') {
				this.newLinkTo.posX = this.x;
				this.newLinkTo.posY = this.y;
				if (event.offsetX - this.newLinkTo.posX >= 1) {
					this.newLinkTo.width = event.offsetX - this.newLinkTo.posX;
					this.newLinkTo.height = event.offsetY - this.newLinkTo.posY;
				}
			} else if (this.draggingStatus == 'dragAndDrop') {
				let x = parseFloat(this.x) - parseFloat(event.offsetX);
				let y = parseFloat(this.y) - parseFloat(event.offsetY);
				let widthCanvas = this.entityEdit.background && this.entityEdit.background.toLowerCase().endsWith('.mp4') ? 960 : event.target.width;
				let heightCanvas = this.entityEdit.background && this.entityEdit.background.toLowerCase().endsWith('.mp4') ? 540 : event.target.height;

				if (this.isInZone(x, y, widthCanvas, heightCanvas)) {
					this.newLinkTo.posX = parseFloat(this.newLinkTo.posX) - (parseFloat(this.x) - parseFloat(event.offsetX));
					this.newLinkTo.posY = parseFloat(this.newLinkTo.posY) - (parseFloat(this.y) - parseFloat(event.offsetY));

					this.x = event.offsetX;
					this.y = event.offsetY;

				}
				this.showResize();
			} else if (this.draggingStatus == 'resize') {
				if (this.resize.indexActive == 0) {
					this.resizeTop(event);
					this.resizeLeft(event);
				} else if (this.resize.indexActive == 1 ) {
					this.resizeTop(event);
				} else if (this.resize.indexActive == 2 ) {
					this.resizeTop(event);
					this.resizeRight(event);
				} else if (this.resize.indexActive == 3 ) {
					this.resizeLeft(event);
				} else if (this.resize.indexActive == 4 ) {
					this.resizeRight(event);
				} else if (this.resize.indexActive == 5 ) {
					this.resizeBottom(event);
					this.resizeLeft(event);
				} else if (this.resize.indexActive == 6 ) {
					this.resizeBottom(event);
				} else if (this.resize.indexActive == 7 ) {
					this.resizeBottom(event);
					this.resizeRight(event);
				}
				this.x = event.offsetX;
				this.y = event.offsetY;
				this.showResize();
			}
		},
		startDraw(event) {
			let x1 = this.newLinkTo.posX;
			let x2 = parseInt(this.newLinkTo.width) + parseInt(this.newLinkTo.posX);
			let y1 = this.newLinkTo.posY;
			let y2 = parseInt(this.newLinkTo.posY) + parseInt(this.newLinkTo.height);

			if (x1 <= event.offsetX &&  x2 >= event.offsetX && y1 <= event.offsetY && y2 >= event.offsetY) {
				this.draggingStatus = 'dragAndDrop';
				this.showResize();
				this.resize.indexActive = -1;
				this.newLinkTo.border = '1px dashed black';
			} else if (this.isResize(event.offsetX, event.offsetY)) {
				this.draggingStatus = 'resize';
			} else {
				this.draggingStatus = 'draw';
				this.resize.status = false;
				this.resize.indexActive = -1;
				this.newLinkTo.border = '1px solid #76FF03';
			}
			this.x = event.offsetX;
			this.y = event.offsetY;

		},
		stopDraw() {
			this.draggingStatus = null;
		},
		isInZone(x, y, widthCanvas, heightCanvas) {
			let x2 = parseInt(this.newLinkTo.posX) + parseInt(this.newLinkTo.width);
			let y2 = parseInt(this.newLinkTo.posY) + parseInt(this.newLinkTo.height);

			if (x < 0 && ( x2 > (widthCanvas - 10))) {
				this.newLinkTo.posX = (widthCanvas - 10) - parseInt(this.newLinkTo.width);
				return false;
			} else if (x > 0 && ( parseInt(this.newLinkTo.posX) < 10)) {
				this.newLinkTo.posX = 10;
				return false;
			}
			if (y < 0 && ( y2 > (heightCanvas - 10))) {
				this.newLinkTo.posY = (heightCanvas - 10) - parseInt(this.newLinkTo.height);
				return false;
			} else if (y > 0 && ( parseInt(this.newLinkTo.posY) < 10)) {
				this.newLinkTo.posY = 10;
				return false;
			}
			return true;
		},
		resizeLeft(event) {
			let width = parseInt(this.newLinkTo.width) + parseInt(this.x) - parseInt(event.offsetX);
			if (width >= 20) {
				this.newLinkTo.width = width;
				this.newLinkTo.posX = parseInt(this.newLinkTo.posX) - (parseInt(this.x) - parseInt(event.offsetX));
			}
		},
		resizeTop(event) {
			let height = parseInt(this.newLinkTo.height) + (parseInt(this.y) - parseInt(event.offsetY));
			if (height >= 20) {
				this.newLinkTo.height = height;
				this.newLinkTo.posY = parseInt(this.newLinkTo.posY) - (parseInt(this.y) - parseInt(event.offsetY));
			}
		},
		resizeRight(event) {
			let width = parseInt(this.newLinkTo.width) - (parseInt(this.x) - parseInt(event.offsetX));
			if (width >= 20) {
				this.newLinkTo.width = width;
			}
		},
		resizeBottom(event) {
			let height = parseInt(this.newLinkTo.height) - (parseInt(this.y) - parseInt(event.offsetY));
			if (height >= 20) {
				this.newLinkTo.height = height;
			}
		},
		showResize() {
			let x1 = parseInt(this.newLinkTo.posX);
			let x2 = parseInt(this.newLinkTo.width) + parseInt(this.newLinkTo.posX);
			let y1 = parseInt(this.newLinkTo.posY);
			let y2 = parseInt(this.newLinkTo.posY) + parseInt(this.newLinkTo.height);
			let centerX = (parseFloat(this.newLinkTo.width)/2) + parseFloat(this.newLinkTo.posX);
			let centerY = parseFloat(this.newLinkTo.posY) + (parseFloat(this.newLinkTo.height)/2);

			this.resize.status = true;

			this.resize.points[0].x = x1 - 10;
			this.resize.points[0].y = y1 - 10;
			this.resize.points[1].x = centerX - 5;
			this.resize.points[1].y = y1 - 10;
			this.resize.points[2].x = x2;
			this.resize.points[2].y = y1 - 10;

			this.resize.points[3].x = x1 - 10;
			this.resize.points[3].y = centerY - 5;
			this.resize.points[4].x = x2;
			this.resize.points[4].y = centerY - 5;

			this.resize.points[5].x = x1 - 10;
			this.resize.points[5].y = y2;
			this.resize.points[6].x = centerX - 5;
			this.resize.points[6].y = y2;
			this.resize.points[7].x = x2;
			this.resize.points[7].y = y2;

		},
		isResize(x, y) {
			for (let i = 0; i < this.resize.points.length; i++) {
				let x1 = parseInt(this.resize.points[i].x);
				let x2 = parseInt(this.resize.points[i].x) + 10;
				let y1 = parseInt(this.resize.points[i].y);
				let y2 = parseInt(this.resize.points[i].y) + 10;

				if (x1 <= x &&  x2 >= x && y1 <= y && y2 >= y) {
					this.resize.indexActive = i;
					return true;
				}
			}
			this.resize.indexActive = -1;
			return false;
		},
		addNewProduct() {
			this.product.newProduct = {buttonName: "VIEW FULL PRODUCT DETAILS"};
			this.product.addDialog = true;
		},
		async addProduct() {
			this.product.newProduct.index = 0;
			if (this.product.listProduct != null) {
				this.product.newProduct.index = this.product.listProduct.length;
			}

			let formData = new FormData();
			if (this.product.imageType === "Upload" && this.product.attachment) {
				if (this.product.attachment) {
					formData.append("productAttachment", this.product.attachment);
				}

				formData.append("experienceId", JSON.stringify(this.experienceId));
				formData.append("structureId", JSON.stringify(this.entityEdit.id));
				await axios.post("/system/structure/linkto/product/image", formData).then((response) => {
					this.product.newProduct.image = response.data;
				});
			}

			this.product.listProduct.push(this.product.newProduct);
			this.product.attachment = null;
			this.product.newProduct = {buttonName: "VIEW FULL PRODUCT DETAILS"};
			this.resetForms();
			this.newLinkTo.value = JSON.stringify(this.product.listProduct);
		},
		chooseEditProduct(index) {
			this.product.editDialog = true;
			this.product.newProduct = Object.assign({}, this.product.listProduct[index]);
			if (!this.product.newProduct.buttonName) {
				this.product.newProduct.buttonName = "VIEW FULL PRODUCT DETAILS";
			}
		},
		async editProduct(index) {
			let formData = new FormData();
			if (this.product.imageType === "Upload" && this.product.attachment) {
				if (this.product.attachment) {
					formData.append("productAttachment", this.product.attachment);
				}

				formData.append("experienceId", JSON.stringify(this.experienceId));
				formData.append("structureId", JSON.stringify(this.entityEdit.id));
				await axios.post("/system/structure/linkto/product/image", formData).then((response) => {
					this.product.newProduct.image = response.data;
				});
			}

			this.product.listProduct.splice(index, 1, this.product.newProduct);
			this.product.attachment = null;
			this.product.newProduct = {buttonName: "VIEW FULL PRODUCT DETAILS"};
			this.newLinkTo.value = JSON.stringify(this.product.listProduct);
			this.resetForms();
		},
		checkEditLinkToProduct() {
			this.product.dialog = true;
			if (this.isEditLinkTo) {
				this.product.listProduct = JSON.parse(this.newLinkTo.value);
				this.isEditLinkTo = false;
			}
		},
		deleteProduct(item) {
			if (confirm("Are you sure to remove " + item.name + "?")) {
				this.product.listProduct.splice(item.index, 1);
				if (this.product.listProduct != null) {
					let i = 0;
					this.product.listProduct.forEach((item) => {
						item.index = i;
						i++;
					});
				}
				this.newLinkTo.value = JSON.stringify(this.product.listProduct);
			}
		},
		resetForms() {
			if (this.$refs.formAddProduct) {
				this.$refs.formAddProduct.reset();
			}
			if (this.$refs.formEditProduct) {
				this.$refs.formEditProduct.reset();
			}
		},
		formatDateTime(date) {
			if (date != null) {
				const zeroPad = (num, places) => String(num).padStart(places, "0");
				var year = parseInt(date.substring(0, 4));
				var month = parseInt(date.substring(5, 7));
				var day = parseInt(date.substring(8, 10));
				var hour = zeroPad(parseInt(date.substring(11, 13)), 2);
				var minute = zeroPad(parseInt(date.substring(14, 16)), 2);
				const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
				return day + " " + monthNames[month - 1] + " " + year + " " + hour + ":" + minute;
			} else {
				return "";
			}
		},
		changeDatetime: function (dateTime) {
			if (dateTime === "") {
				return this.today + " " + this.hour + ":" + this.minute;
			} else {
				return dateTime.substr(0, 10) + " " + this.hour + ":" + this.minute;
			}
		},
		resetTime() {
			this.hour = "00";
			this.minute = "00";
			this.second = "00";
		},
		listTimezone() {
			axios
				.get("/system/enumeration/timezone/list")
				.then((response) => {
					this.timezoneList = response.data;
				})
				.catch(() => {});
		},
		clearPresentation() {
			this.selectedTimezone = null;
			this.videoUrl = null;
			this.zoomUrl = null;
			this.zoomDisablePreview = true;
			this.videoIframe = null;
			this.isShowStartDate = false;
			this.isShowEndDate = false;
			this.isShowStartTime = false;
			this.isShowEndTime = false;
			this.startDate = null;
			this.endDate = null;
			this.startTime = null;
			this.endTime = null;
			this.selectedType = null;
			this.selectedTarget = null;
			this.selectedTitle = null;
			this.selectedDescription = null;
			this.attachment1 = null;
			this.attachment2 = null;
			this.attachment3 = null;
			this.attachment4 = null;
			this.attachment5 = null;
			this.attachment6 = null;
			this.attachment7 = null;
			this.selectedFirstName1 = null;
			this.selectedFirstName2 = null;
			this.selectedFirstName3 = null;
			this.selectedLastName1 = null;
			this.selectedLastName2 = null;
			this.selectedLastName3 = null;
			this.selectedTitle1 = null;
			this.selectedTitle2 = null;
			this.selectedTitle3 = null;
			this.selectedBio1 = null;
			this.selectedBio2 = null;
			this.selectedBio3 = null;
			this.selectedPresentationId = null;
			this.selectedPresentationScheduleId = null;
			this.selectEmbedHtmlBeside = { status: "None", value: "" },
			this.selectEmbedHtmlBelow = "",
			this.heightEmbedHtmlBeside = null,
			this.heightEmbedHtmlBelow = null,
			this.presenterClinicList = [];
			this.handoutList = [];
			this.entityPresentation = {
				presenterClinicList: []
			};
			this.entityPresentationSchedule = {
				dataMap: {}
			};
			this.$refs.file1Upload.reset();
			this.$refs.file2Upload.reset();
			this.$refs.file3Upload.reset();
			this.$refs.file4Upload.reset();
			this.$refs.file5Upload.reset();
			this.$refs.file6Upload.reset();
		},
		closePresentation() {
			this.dialogPresentation = false;
			this.dialogEditPresentation = false;
			this.clearPresentation();
		},
		handleFile1Upload(fileList) {
			this.attachment1 = fileList[0];
		},
		handleFile2Upload(fileList) {
			this.attachment2 = fileList[0];
		},
		handleFile3Upload(fileList) {
			this.attachment3 = fileList[0];
		},
		handleFile4Upload(fileList) {
			this.attachment4 = fileList[0];
		},
		handleFile5Upload(fileList) {
			this.attachment5 = fileList[0];
		},
		handleFile6Upload(fileList) {
			this.attachment6 = fileList[0];
		},
		addPresentation() {
			this.entityPresentation.title = this.selectedTitle;
			this.entityPresentation.description = this.selectedDescription;
			this.entityPresentation.type = this.selectedType;
			this.entityPresentation.videoUrl = this.videoUrl;
			this.entityPresentation.videoIframe = this.videoIframe;
			this.entityPresentation.participantUrl = this.zoomUrl;
			this.entityPresentation.status = true;
			this.entityPresentation.embedHtmlBesideMap = this.selectEmbedHtmlBeside;
			this.entityPresentation.embedHtmlBelow = this.selectEmbedHtmlBelow;

			if (!this.entityPresentation.dataMap) {
				this.entityPresentation.dataMap = {};
			}

			if (this.heightEmbedHtmlBeside) {
				this.entityPresentation.dataMap.heightEmbedHtmlBeside = this.heightEmbedHtmlBeside;
			}
			if (this.heightEmbedHtmlBelow) {
				this.entityPresentation.dataMap.heightEmbedHtmlBelow = this.heightEmbedHtmlBelow;
			}

			if (this.selectedType == 'Zoom Webinar' || this.selectedType == 'Zoom Meeting') {
				this.entityPresentation.dataMap.zoomTarget = this.selectedTarget;
			}

			if (this.zoomDisablePreview) {
				this.entityPresentation.dataMap.disablePreview = this.zoomDisablePreview;
			}

			let presenterClinicArray = [];
			if (this.selectedFirstName1 || this.selectedLastName1 || this.selectedBio1) {
				let presenterClinic = {
					firstName: this.selectedFirstName1,
					lastName: this.selectedLastName1,
					title: this.selectedTitle1,
					bio: this.selectedBio1
				};
				presenterClinicArray.push(presenterClinic);
			}
			if (this.selectedFirstName2 || this.selectedLastName2 || this.selectedBio2) {
				let presenterClinic = {
					firstName: this.selectedFirstName2,
					lastName: this.selectedLastName2,
					title: this.selectedTitle2,
					bio: this.selectedBio2
				};
				presenterClinicArray.push(presenterClinic);
			}
			if (this.selectedFirstName3 || this.selectedLastName3 || this.selectedBio3) {
				let presenterClinic = {
					firstName: this.selectedFirstName3,
					lastName: this.selectedLastName3,
					title: this.selectedTitle3,
					bio: this.selectedBio3
				};
				presenterClinicArray.push(presenterClinic);
			}
			this.entityPresentation.presenterClinicList = presenterClinicArray;

			this.entityPresentationSchedule.timezone = this.selectedTimezone;

			const zeroPad = (num, places) => String(num).padStart(places, "0");
			var hour = zeroPad(parseInt(this.startDate.substring(11, 13)), 2);
			var minute = zeroPad(parseInt(this.startDate.substring(14, 16)), 2);
			this.startTime = hour + ":" + minute;
			if (this.startDate) {
				if (this.startTime) {
					this.entityPresentationSchedule.dataMap.startDate = this.startDate;
					this.entityPresentationSchedule.dataMap.startTime = this.startTime;
				} else {
					this.entityPresentationSchedule.dataMap.startDate = this.startDate + " " + "00:00";
				}
			}
			if (this.startTime) {
				this.entityPresentationSchedule.dataMap.startTime = this.startTime;
			}

			hour = zeroPad(parseInt(this.endDate.substring(11, 13)), 2);
			minute = zeroPad(parseInt(this.endDate.substring(14, 16)), 2);
			this.endTime = hour + ":" + minute;
			if (this.endDate) {
				if (this.endTime) {
					this.entityPresentationSchedule.dataMap.endDate = this.endDate;
					this.entityPresentationSchedule.dataMap.endTime = this.endTime;
				} else {
					this.entityPresentationSchedule.dataMap.endDate = this.endDate + " " + "00:00";
				}
			}
			if (this.endTime) {
				this.entityPresentationSchedule.dataMap.endTime = this.endTime;
			}

			let formData = new FormData();
			formData.append("experienceId", this.experienceId);
			formData.append("entityPresentation", JSON.stringify(this.entityPresentation));
			formData.append("entityPresentationSchedule", JSON.stringify(this.entityPresentationSchedule));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}
			if (this.attachment4) {
				formData.append("attachment4", this.attachment4);
			}
			if (this.attachment5) {
				formData.append("attachment5", this.attachment5);
			}
			if (this.attachment6) {
				formData.append("attachment6", this.attachment6);
			}

			axios
				.post("/system/presentation/clinic/add", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.listPresentationSchedule();
				})
				.catch(() => {});
		},
		editPresentation() {
			this.entityPresentation.id = this.selectedPresentationId;
			this.entityPresentation.title = this.selectedTitle;
			this.entityPresentation.description = this.selectedDescription;
			this.entityPresentation.type = this.selectedType;
			this.entityPresentation.videoUrl = this.videoUrl;
			this.entityPresentation.videoIframe = this.videoIframe;
			this.entityPresentation.participantUrl = this.zoomUrl;
			this.entityPresentation.status = true;
			this.entityPresentation.presenterClinicList = this.presenterClinicList;
			this.entityPresentation.handoutList = this.handoutList;
			this.entityPresentation.embedHtmlBesideMap = this.selectEmbedHtmlBeside;
			this.entityPresentation.embedHtmlBelow = this.selectEmbedHtmlBelow;

			if (!this.entityPresentation.dataMap) {
				this.entityPresentation.dataMap = {};
			}

			if (this.selectedType == 'Zoom Webinar' || this.selectedType == 'Zoom Meeting') {
				this.entityPresentation.dataMap.zoomTarget = this.selectedTarget;
			}

			if (this.selectedType == 'Teams Meeting') {
				this.entityPresentation.dataMap.target = this.selectedTarget;
			}

			this.entityPresentation.dataMap.disablePreview = this.zoomDisablePreview;

			if (this.selectedFirstName1 || this.selectedLastName1 || this.selectedBio1) {
				let presenterClinic = {
					firstName: this.selectedFirstName1,
					lastName: this.selectedLastName1,
					title: this.selectedTitle1,
					bio: this.selectedBio1
				};
				this.entityPresentation.presenterClinicList.push(presenterClinic);
			}
			if (this.selectedFirstName2 || this.selectedLastName2 || this.selectedBio2) {
				let presenterClinic = {
					firstName: this.selectedFirstName2,
					lastName: this.selectedLastName2,
					title: this.selectedTitle2,
					bio: this.selectedBio2
				};
				this.entityPresentation.presenterClinicList.push(presenterClinic);
			}
			if (this.selectedFirstName3 || this.selectedLastName3 || this.selectedBio3) {
				let presenterClinic = {
					firstName: this.selectedFirstName3,
					lastName: this.selectedLastName3,
					title: this.selectedTitle3,
					bio: this.selectedBio3
				};
				this.entityPresentation.presenterClinicList.push(presenterClinic);
			}

			this.entityPresentationSchedule.id = this.selectedPresentationScheduleId;
			this.entityPresentationSchedule.timezone = this.selectedTimezone;

			const zeroPad = (num, places) => String(num).padStart(places, "0");
			var hour = zeroPad(parseInt(this.startDate.substring(11, 13)), 2);
			var minute = zeroPad(parseInt(this.startDate.substring(14, 16)), 2);
			this.startTime = hour + ":" + minute;
			if (this.startDate) {
				if (this.startTime) {
					this.entityPresentationSchedule.dataMap.startDate = this.startDate;
					this.entityPresentationSchedule.dataMap.startTime = this.startTime;
				} else {
					this.entityPresentationSchedule.dataMap.startDate = this.startDate + " " + "00:00";
				}
			}
			if (this.startTime) {
				this.entityPresentationSchedule.dataMap.startTime = this.startTime;
			}

			hour = zeroPad(parseInt(this.endDate.substring(11, 13)), 2);
			minute = zeroPad(parseInt(this.endDate.substring(14, 16)), 2);
			this.endTime = hour + ":" + minute;
			if (this.endDate) {
				if (this.endTime) {
					this.entityPresentationSchedule.dataMap.endDate = this.endDate;
					this.entityPresentationSchedule.dataMap.endTime = this.endTime;
				} else {
					this.entityPresentationSchedule.dataMap.endDate = this.endDate + " " + "00:00";
				}
			}
			if (this.endTime) {
				this.entityPresentationSchedule.dataMap.endTime = this.endTime;
			}

			if (this.heightEmbedHtmlBeside) {
				this.entityPresentation.dataMap.heightEmbedHtmlBeside = this.heightEmbedHtmlBeside;
			}
			if (this.heightEmbedHtmlBelow) {
				this.entityPresentation.dataMap.heightEmbedHtmlBelow = this.heightEmbedHtmlBelow;
			}

			let formData = new FormData();
			formData.append("experienceId", this.experienceId);
			formData.append("entityPresentation", JSON.stringify(this.entityPresentation));
			formData.append("entityPresentationSchedule", JSON.stringify(this.entityPresentationSchedule));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}
			if (this.attachment4) {
				formData.append("attachment4", this.attachment4);
			}
			if (this.attachment5) {
				formData.append("attachment5", this.attachment5);
			}
			if (this.attachment6) {
				formData.append("attachment6", this.attachment6);
			}

			axios
				.post("/system/presentation/clinic/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.listPresentationSchedule();
				})
				.catch(() => {});
		},
		deletePresentationSchedule() {
			axios
				.post("/system/presentationschedule/delete", {
					id: this.selectedPresentationScheduleId
				})
				.then(() => {
					axios
						.post("/system/presentation/delete", {
							id: this.selectedPresentationId
						})
						.then(() => {})
						.catch(() => {});

					this.listPresentationSchedule();
					this.removePresentationScheduleFromLinkTo(this.selectedPresentationScheduleId);
				})
				.catch(() => {});
		},
		listPresentationSchedule() {
			axios.get("/system/presentationschedule/list?experienceId=" + this.experienceId).then((response) => {
				this.presentationScheduleList = response.data;
			});
		},
		selectEditPresentation(item) {
			this.dialogPresentation = true;

			this.selectedPresentationId = item.presentation.id;
			this.dialogEditPresentation = true;
			this.selectedTitle = item.presentation.title;
			this.selectedDescription = item.presentation.description;
			this.selectedType = item.presentation.type;
			this.selectEmbedHtmlBeside = item.presentation.embedHtmlBesideMap;
			this.selectEmbedHtmlBelow = item.presentation.embedHtmlBelow;
			this.heightEmbedHtmlBeside = item.presentation.dataMap.heightEmbedHtmlBeside;
			this.heightEmbedHtmlBelow = item.presentation.dataMap.heightEmbedHtmlBelow;
			this.videoUrl = item.presentation.videoUrl;
			this.videoIframe = item.presentation.videoIframe;
			this.zoomUrl = item.presentation.participantUrl;
			this.zoomDisablePreview = item.presentation.dataMap.disablePreview == null ? true : item.presentation.dataMap.disablePreview;

			if (this.selectedType == 'Zoom Webinar' || this.selectedType == 'Zoom Meeting') {
				if (!item.presentation.dataMap || !item.presentation.dataMap.zoomTarget) {
					this.selectedTarget = "New Tab";
				} else {
					this.selectedTarget = item.presentation.dataMap.zoomTarget;
				}
			}

			if (this.selectedType == 'Teams Meeting') {
				if (!item.presentation.dataMap || !item.presentation.dataMap.target) {
					this.selectedTarget = "New Tab";
				} else {
					this.selectedTarget = item.presentation.dataMap.target;
				}
			}

			this.selectedPresentationScheduleId = item.id;
			this.startDate = new Date(item.dataMap.startDate).toISOString().substr(0, 10) + " " + item.dataMap.startTime;
			item.endDate != null ? (this.endDate = new Date(item.dataMap.endDate).toISOString().substr(0, 10) + " " + item.dataMap.endTime) : (this.endDate = null);
			this.selectedTimezone = item.timezone;

			this.presenterClinicList = item.presentation.presenterClinicList;
			this.handoutList = item.presentation.handoutList;
		},
		selectDeletePresentationSchedule(item) {
			this.dialogDeletePresentationSchedule = true;
			this.selectedPresentationScheduleId = item.id;
			this.selectedPresentationId = item.presentation.id;
		},
		removePresenterClinic(id) {
			this.presenterClinicList = this.presenterClinicList.filter(function (item) {
				return item.id != id;
			});
		},
		removeHandout(id) {
			this.handoutList = this.handoutList.filter(function (item) {
				return item.id != id;
			});
		},
		removePresentationScheduleFromLinkTo(id) {
			this.newLinkTo.value = this.newLinkTo.value.filter(function (item) {
				return item != id;
			});
		},
		addLinkToWizard(item) {
			this.newLinkTo = Object.assign({}, item);
			this.newLinkTo.id = undefined;
			this.newLinkTo.type = undefined;
			this.newLinkTo.value = undefined;
			document.getElementById("linkTo").scrollIntoView({ behavior: "smooth" });
		},
		previewImage(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.newLinkTo.previewImage = fr.result;
					this.newLinkTo.value = imageName;
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
			} else {
				this.attachment1 = null;
			}
		},
		previewVideo(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let videoName = files[0].name;
				if (videoName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.newLinkTo.previewVideo = URL.createObjectURL(files[0]);
					this.newLinkTo.value = videoName;
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
			} else {
				this.attachment1 = null;
			}
		},
		showBoothOrder(boothList, isFormAdd) {
			axios
				.post("/system/booth/list", {
					experienceId: this.experienceId
				})
				.then((response) => {
					this.boothSelecteds = [];
					let newBoothList = [];
					for (let i = 0; i < boothList.length; i++) {
						let list = this.$root.clone(response.data);
						for (let data of list) {
							if (boothList[i] == data.id) {
								this.boothSelecteds.push(data);
								newBoothList.push(data.id);
							}
						}
					}

					if (!isFormAdd) {
						this.entityEdit.dataMap.boothSelected = newBoothList;
					}
					for (let booth of this.boothSelecteds) {
						if (booth.boothBackground == null){
							booth.boothBackground = this.$root.clone(this.customBackgroundDefault);
						} else {
							booth.boothBackground.menu = false;
						}
					}
					this.dialogBoothOrder = true;
				});
		},
		closeBoothOrder() {
			this.boothSelecteds = [];
			this.dialogBoothOrder = false;
		},
		movePosition(arr, oldIndex, newIndex) {
			if (newIndex > -1 && newIndex < arr.length) {
				if (newIndex >= arr.length) {
					var k = newIndex - arr.length + 1;
					while (k--) {
						arr.push(undefined);
						if (this.entity.dataMap.boothSelected) {
							this.entity.dataMap.boothSelected.push(undefined);
						} else {
							this.entityEdit.dataMap.boothSelected.push(undefined);
						}
					}
				}
				arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
				if (this.entity.dataMap.boothSelected) {
					this.entity.dataMap.boothSelected.splice(newIndex, 0, this.entity.dataMap.boothSelected.splice(oldIndex, 1)[0]);
				} else {
					this.entityEdit.dataMap.boothSelected.splice(newIndex, 0, this.entityEdit.dataMap.boothSelected.splice(oldIndex, 1)[0]);
				}
			}
		},
		showPosterOrder(posterList, isFormAdd) {
			axios
				.post("/system/poster/find", {
					experienceId: this.experienceId
				})
				.then((response) => {
					this.posterSelecteds = [];
					let newPosterList = [];
					for (let i = 0; i < posterList.length; i++) {
						let list = this.$root.clone(response.data);
						for (let data of list) {
							if (posterList[i] == data.id) {
								this.posterSelecteds.push(data);
								newPosterList.push(data.id);
							}
						}
					}

					if (!isFormAdd) {
						this.entityEdit.dataMap.posterSelected = newPosterList;
					}
					this.dialogPosterOrder = true;
				});
		},
		closePosterOrder() {
			this.posterSelecteds = [];
			this.dialogPosterOrder = false;
		},
		movePositionForPoster(arr, oldIndex, newIndex) {
			if (newIndex > -1 && newIndex < arr.length) {
				if (newIndex >= arr.length) {
					var k = newIndex - arr.length + 1;
					while (k--) {
						arr.push(undefined);
						if (this.entity.dataMap.posterSelected) {
							this.entity.dataMap.posterSelected.push(undefined);
						} else {
							this.entityEdit.dataMap.posterSelected.push(undefined);
						}
					}
				}
				arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
				if (this.entity.dataMap.posterSelected) {
					this.entity.dataMap.posterSelected.splice(newIndex, 0, this.entity.dataMap.posterSelected.splice(oldIndex, 1)[0]);
				} else {
					this.entityEdit.dataMap.posterSelected.splice(newIndex, 0, this.entityEdit.dataMap.posterSelected.splice(oldIndex, 1)[0]);
				}
			}
		},
		duplicateRoom(entity) {
			this.boothBackgroundType = "URL";
			this.bannerRotatingVideoType = "URL";
			this.backgroundType = "URL";
			this.introTransitionType = "URL";
			this.outroTransitionType = "URL";
			this.entity = Object.assign({}, entity);
			this.entity.id = null;
			this.entity.slug = null;
			this.entity.mainStructure = false;
			this.isExhibitionHall = entity.dataMap.isExhibitionHall;
			if(entity.dataMap.isPasswordProtectRoom){
				this.isPasswordProtectRoom = entity.dataMap.isPasswordProtectRoom;
				this.passwordProtect = entity.dataMap.passwordProtect;
			}

			if (!this.entity.dataMap.introTransition) {
				this.entity.dataMap.introTransition = {
					autoplay: true,
					sound: false
				}
			}
			if (!this.entity.dataMap.outroTransition) {
				this.entity.dataMap.outroTransition = {
					autoplay: true,
					sound: false
				}
			}
			this.dialogAdd = true;
		},
		listTicket() {
			axios
				.get("/system/ticket/list?experienceId=" + this.experienceId)
				.then((response) => {
					this.ticketList = response.data;
				})
				.catch(() => {});
		},
		switchVisibility() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		},
		loadContent(content) {
			this.$nextTick(() => {
				var iframe = document.getElementById("embed");
				this.$nextTick(() => {
					var iframeContent = iframe.contentDocument;
					iframeContent.write(content);
				});
			});
		},
		onBackgroundUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.backgroundTemp = fr.result;
					} else {
						this.editBackgroundTemp = fr.result;
					}
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
				this.backgroundFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.backgroundImageName = files[0].name;
			} else {
				this.attachment1 = null;
			}
		},
		onFileDownloadChange(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.backgroundTemp = fr.result;
					} else {
						this.editBackgroundTemp = fr.result;
					}
					this.attachment1 = files[0];
				});
				this.newLinkTo.value = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.newLinkTo.name = files[0].name;
			} else {
				this.attachment1 = null;
			}
		},
		onIntroTransitionUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.introTransitionTemp = fr.result;
					} else {
						this.editIntroTransitionTemp = fr.result;
					}
					this.attachment2 = files[0]; // this is an image file that can be sent to server...
				});
				this.introTransitionFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.introTransitionImageName = files[0].name;
			} else {
				this.attachment2 = null;
			}
		},
		onOutroTransitionUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.outroTransitionTemp = fr.result;
					} else {
						this.editOutroTransitionTemp = fr.result;
					}
					this.attachment6 = files[0]; // this is an image file that can be sent to server...
				});
				this.outroTransitionFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.outroTransitionImageName = files[0].name;
			} else {
				this.attachment6 = null;
			}
		},
		onBackgroundLoginUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.backgroundLoginTemp = fr.result;
					} else {
						this.editBackgroundLoginTemp = fr.result;
					}
					this.attachment5 = files[0]; // this is an image file that can be sent to server...
				});
				this.backgroundLoginFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.backgroundLoginImageName = files[0].name;
			} else {
				this.attachment5 = null;
			}
		},
		onBannerRotatingVideoUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.bannerRotatingVideoTemp = fr.result;
					} else {
						this.editBannerRotatingVideoTemp = fr.result;
					}
					this.attachment3 = files[0]; // this is an image file that can be sent to server...
				});
				this.bannerRotatingVideoFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.bannerRotatingVideoImageName = files[0].name;
			} else {
				this.attachment3 = null;
			}
		},
		openButtonBackgroundDialog() {
			this.$refs.attachment7.click();
		},
		openBackgroundDialog() {
			this.$refs.attachment1.click();
		},
		openIntroTransitionDialog() {
			this.$refs.attachment2.click();
		},
		openOutroTransitionDialog() {
			this.$refs.attachment6.click();
		},
		openBackgroundLoginDialog() {
			this.$refs.attachment5.click();
		},
		openBannerRotatingVideoDialog() {
			this.$refs.attachment3.click();
		},
		clearData() {
			this.isPasswordProtectRoom = false;
			this.passwordProtect = null;
			this.attachment1 = null;
			this.attachment2 = null;
			this.attachment3 = null;
			this.attachment5 = null;
			this.attachment6 = null;
			(this.backgroundFileName = ""),
				(this.introTransitionFileName = ""),
				(this.outroTransitionFileName = ""),
				(this.backgroundImageName = ""),
				(this.introTransitionImageName = ""),
				(this.outroTransitionImageName = ""),
				(this.backgroundLoginFileName = ""),
				(this.backgroundLoginImageName = ""),
				(this.bannerRotatingVideoFileName = ""),
				(this.bannerRotatingVideoImageName = ""),
				(this.backgroundTemp = ""),
				(this.introTransitionTemp = ""),
				(this.outroTransitionTemp = ""),
				(this.backgroundLoginTemp = ""),
				(this.bannerRotatingVideoTemp = ""),
				(this.editBackgroundTemp = ""),
				(this.editIntroTransitionTemp = ""),
				(this.editOutroTransitionTemp = ""),
				(this.editBackgroundLoginTemp = ""),
				(this.editBannerRotatingVideoTemp = "");
		},
		getBoothSelectedList(boothList, slug) {
			if (!this.boothSelectMap[slug]) {
				let result = [];
				let listBooth = Object.assign([], boothList);
				for (let i = 0; i < listBooth.length; i++) {
					let list = this.$root.clone(this.booths);
					if (list.length > 0) {
						result.push(list.filter((item) => listBooth[i] == item.id)[0]);
					}
				}
				if (result.length > 0) {
					this.boothSelectMap[slug] = Object.assign([], result);
				}
				return result;
			} else {
				return this.boothSelectMap[slug];
			}
		},
		getPosterSelectedList(posterList, page) {
			let result = [];
			let start = (page-1) * 4;
			let end = page * 4;
			if (posterList.length < end) {
				end = posterList.length;
			}

			let listPoster = Object.assign([], posterList);
			for (let i = start; i < end; i++) {
				let list = this.$root.clone(this.posterList);
				let poster = list.filter((item) => listPoster[i] == item.id)[0];
				if(poster){
					for (let item of poster.posterDataList) {
						for (let item1 of item) {
							if (item1.type === "GALLERY") {
								let length = item1.images.length;
								// for hide default image
								item1.images.splice(length - 1, 1);
							}
						}
					}
					result.push(poster);
				}
			}
			return result;
		},
		listRoomSlug() {
			this.slugList = [];
			for (let tenant of this.entityList) {
				this.slugList.push(tenant["slug"].toLowerCase());
			}
			this.slugList.sort();
			this.slugList.reverse();
		},
		createUrl(name, isUpdate) {
			let slug = name ? name.toLowerCase().replace(/ /g, "") : null;
			let tenantSlugMap = {};
			for (let i of this.slugList) {
				tenantSlugMap[i] = true;
			}

			let match = new RegExp("^(.*)([0-9]+)$").exec(slug);
			let word = slug;
			let number = "";

			if (match != null) {
				word = match[1];
				number = Number(match[2]); // handle 09, 009, 0009 and so on
			}

			while (tenantSlugMap[word + "" + number]) {
				// increment
				if (number == "") {
					number = 1;
				} else {
					number++;
				}
			}

			slug = word + "" + number;
			slug = slug == "null" ? "" : slug;

			if (isUpdate) {
				if (this.entityEditOld.name && name.toLowerCase() == this.entityEditOld.name.toLowerCase()) {
					this.entityEdit.slug = this.entityEditOld.slug;
				} else {
					this.entityEdit.slug = slug;
				}
			} else {
				this.entity.slug = slug;
			}
		},
		chooseRoomLibrary(room) {
			if (!this.isEdit) {
				this.selectedTemplate = { ...room };
				if (this.entity.linkToDataList && this.entity.linkToDataList.length > 0) {
					this.selectedTemplate.linkToDataList = this.entity.linkToDataList;
				}
				if (this.entity.name) {
					this.selectedTemplate.name = this.entity.name;
				}
				if (this.entity.url) {
					this.selectedTemplate.url = this.entity.url;
				}
				this.dialogRoomLibrary = false;
				this.showAdd();
				this.isAdd = false;
			} else {
				this.entityEdit.background = room.background;
				this.entityEdit.backgroundDisplay = room.backgroundDisplay;
				this.entityEdit.introTransition = room.introTransition;
				this.entityEdit.outroTransition = room.outroTransition;
				this.dialogRoomLibrary = false;
				this.dialogEdit = true;
				if (this.entityEdit.background) {
					this.entityEdit.background = this.$root.reverseToOriginal(this.entityEdit.background);
					this.backgroundType = "URL";
				} else {
					this.backgroundType = "Upload";
				}
				if (this.entityEdit.introTransition) {
					this.introTransitionType = "URL";
				} else {
					this.introTransitionType = "Upload";
				}
				if (this.entityEdit.outroTransition) {
					this.outroTransitionType = "URL";
				} else {
					this.outroTransitionType = "Upload";
				}
				this.isEdit = false;
			}
		},
		chooseBackgroundTransition(backgroundTransition) {
			if (this.isIntro) {
				this.introTransitionType = "URL";
				this.entity.introTransition = null;
			} else {
				this.outroTransitionType = "URL";
				this.entity.outroTransition = null;
			}
			if (!this.isEdit) {
				if (this.isIntro) {
					this.selectedTemplate.introTransition = backgroundTransition;
				} else {
					this.selectedTemplate.outroTransition = backgroundTransition;
				}
				this.dialogBackgroundTransition = false;
				this.showAdd();
				this.isAdd = false;
			} else {
				if (this.isIntro) {
					this.entityEdit.introTransition = backgroundTransition;
				} else {
					this.entityEdit.outroTransition = backgroundTransition;
				}
				this.dialogBackgroundTransition = false;
				this.dialogEdit = true;
				this.isEdit = false;
			}
		},
		getVideoDimensions(e, entity) {
			var element = document.getElementsByClassName("structure-view-" + entity.id)[0];
			if (this.$root.isImage(entity.background)) {
				let img = new Image();
				img.src = this.$root.asset(entity.background);
				element.style.transform = "scale(" + 340 / img.width + ")";
			} else {
				element.style.transform = "scale(" + 340 / e.target.videoWidth + ")";
			}
		},
		showDialogCustomBackground(index, item) {
			this.boothItemDefault = this.$root.clone(item);
			this.boothItem = item;
			this.boothItem.index = index;
			this.dialogCustomBackground = true;
		},
		closeDialogCustomBackground(index) {
			this.boothSelecteds[index].boothBackground.color = this.boothItemDefault.color;
			this.boothSelecteds[index].boothBackground.image = this.boothItemDefault.image;
			this.boothSelecteds[index].boothBackground.type = this.boothItemDefault.type;
			this.boothSelecteds[index].boothBackground.menu = false;
			this.bootItem = {};
			this.dialogCustomBackground = false;
		},
		setDialogCustomBackground(index) {
			let formData = new FormData();
			formData.append("id", JSON.stringify(this.boothSelecteds[index].id));
			formData.append("boothBackground", JSON.stringify(this.boothSelecteds[index].boothBackground));
			if (this.attachment4) {
				formData.append("attachment1", this.attachment4);
			}

			axios
				.post("/system/booth/edit/background", formData)
				.then((response) => {
					if (response.data) {
						if (this.boothSelecteds[index].boothBackground.type == "Upload") {
							this.boothSelecteds[index].boothBackground.image = response.data.image;
							this.boothSelecteds[index].boothBackground.color = "#00000000";
						} else {
							this.boothSelecteds[index].boothBackground.image = "";
							this.boothSelecteds[index].boothBackground.color = response.data.color;
						}
						this.boothSelecteds[index].boothBackground.menu = false;
						this.boothItem = {};
						this.attachment4 = null;
						this.dialogCustomBackground = false;
					}
				})
				.catch(() => {});
		},
		experiencePortal() {
			let origin = window.location.origin;
			if (origin.startsWith('https://administrator.')) {
				return 'https://' + origin.slice('https://administrator.'.length);
			} else if (origin.startsWith('https://tenant.')) {
				return 'https://' + origin.slice('https://tenant.'.length);
			}
			return '';
		},
		changeItem() {
			this.newLinkTo.value = null;

			if (this.newLinkTo.type == 'Button') {
				this.newLinkTo.backgroundColor = "#FFFFFFFF";
				this.newLinkTo.borderColor = "#000000FF";
				this.newLinkTo.backgroundType = "Color";
				this.newLinkTo.borderRadius = "0";
				this.newLinkTo.borderWidth = "0";
			} else if (this.newLinkTo.type == 'Book_Consultation') {
				this.newLinkTo.name = "Submit";
			} else if (this.newLinkTo.type == 'Training') {
				this.setTrainingCategory();
			} else if (this.newLinkTo.type == 'Zoom') {
				this.newLinkTo.disablePreview = this.newLinkTo.disablePreview == null ? true : this.newLinkTo.disablePreview;
			} else {
				this.newLinkTo.backgroundColor = "#FFFFFF00";
				this.newLinkTo.borderColor = "#00000000";
			}

			this.newLinkTo.tooltip = {value: "", backgroundColor: "#000000FF", fontColor: "#FFFFFFFF", show: false};
		},
		showButtonLibrary() {
			axios.get("/system/buttonlibrary/list").then((response) => {
				if (response.data) {
					this.buttonLibraryList = response.data;
					for (let entity of this.buttonLibraryList) {
						this.setCenter(entity, 1.0, entity.width, entity.height);
					}
				}
			});
			this.dialogButtonLibrary = true;
		},
		setCenter(entity, scale, width, height) {
			let x = (340 - parseInt(width)) / 2;
			let y = (200 - parseInt(height)) / 2;

			if (x <= 0 || y <= 0) {
				scale = scale - 0.1;
				width = entity.width * scale;
				height = entity.height * scale;

				this.setCenter(entity, scale, width, height);
			} else {
				entity.transform = 'scale(' + scale + ")";
				entity.margin = y + 'px ' + x + 'px';
			}
		},
		chooseButton(entity) {
			this.newLinkTo.value = entity.value;
			this.newLinkTo.css = entity.css.replace(/button_library/g, "hotspot_btn_custom");
			this.newLinkTo.backgroundColor = entity.background.startsWith("#") && entity.background.length < 8 ? entity.background + "FF" : entity.background;
			this.newLinkTo.backgroundImage = entity.background.startsWith("#") ? null : entity.background;
			this.newLinkTo.width = entity.width;
			this.newLinkTo.height = entity.height;
			this.newLinkTo.borderColor =  entity.borderColor.startsWith("#") && entity.borderColor.length < 8 ? entity.borderColor + "FF" : entity.borderColor;
			this.newLinkTo.borderWidth = entity.borderWidth.toString();
			this.newLinkTo.borderRadius = entity.borderRadius.toString();
			this.dialogButtonLibrary = false;
			this.newLinkTo.posX = 0;
			this.newLinkTo.posY = 0;
			this.newLinkTo.backgroundType = entity.backgroundType;
			this.showResize();
			this.refreshDrawing();
		},
		changeBackground() {
			if (this.newLinkTo.backgroundType === "Color") {
				this.newLinkTo.backgroundColor = "#F5F5F5FF";
				this.newLinkTo.backgroundImage = "";
				this.buttonLibraryBackgroundFileName = "";
				this.attachment1 = null;
			} else {
				this.newLinkTo.backgroundColor = "";
			}
			this.refreshDrawing();
		},
		onBackgroundUploadForButtonLibrary(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.newLinkTo.backgroundImage = fr.result;
					this.attachment7 = files[0]; // this is an image file that can be sent to server...
					this.refreshDrawing();
				});
				this.buttonLibraryBackgroundFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.showResize();
			} else {
				this.attachment7 = null;
			}
		},
		refreshDrawing() {
			let x = this.newLinkTo.posX;
			let y = this.newLinkTo.posY;
			this.newLinkTo.posX = 0;
			this.newLinkTo.posY = 0;
			this.newLinkTo.posX = x;
			this.newLinkTo.posY = y;
		},
		changeType(type) {
			if (type === 'exhibition_hall' && this.isExhibitionHall) {
				this.isPosterRoom = false;
			} else if (type === 'poster_room' && this.isPosterRoom) {
				this.isExhibitionHall = false;
			}
		},
		getHightForPoster(entity) {
			let id = "";
			if (entity.backgroundDisplay) {
				id = "background-display-" + entity.slug;
			} else if (this.$root.isImage(entity.background)) {
				id = "background-" + entity.slug;
			} else if (this.$root.isVideo(entity.background)) {
				id = "background-video-" + entity.slug;
			}

			if (id) {
				let background = document.getElementById(id);
				if (background) {
					let height = background.clientHeight * 2;
					return height - 10 ;
				}
			}
			return 900;
		},
		playYoutube(type) {
			this.$nextTick(() => {
				if (this.$vuetify.breakpoint.mobile){
					if (type === 'background') {
						this.$refs.backgroundYoutube.player.playVideo();
					} else if (type === 'introTransition') {
						this.$refs.introTransitionYoutube.player.playVideo();
					} else if (type === 'outroTransition') {
						this.$refs.outroTransitionYoutube.player.playVideo();
					} else if (type === 'backgroundLogin') {
						this.$refs.backgroundLoginYoutube.player.playVideo();
					}
				}
			});
		},
		setTrainingCategory() {
			axios.get("/system/vTraining/category/list").then((response) => {
				if (response.data) {
					this.trainingCategoryList = response.data;
				}
			});
		}
	}
};
</script>
